
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6s1V6", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $l8HGx = parcelRequire("l8HGx");


var $eTl29 = parcelRequire("eTl29");

function $a51537e3e9451832$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $cbY7C.bind)(window, {
        type: (0, $l8HGx.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $l8HGx.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $cbY7C.bind)(window, {
        type: (0, $l8HGx.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $l8HGx.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $cbY7C.bind)(window, {
        type: (0, $l8HGx.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $eTl29.getViewportWidth)() !== initialViewPort.w || (0, $eTl29.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $l8HGx.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}
module.exports["attachAbortListeners"] = $a51537e3e9451832$export$9010aa71841a6887;

});

parcelRegister("l8HGx", function(module, exports) {
const $03af72831333e8e6$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};
module.exports["AbortEvent"] = $03af72831333e8e6$export$199edc0307b5587f;

});

parcelRegister("eTl29", function(module, exports) {
function $d8c34cdac5519af9$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $d8c34cdac5519af9$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
module.exports["getViewportWidth"] = $d8c34cdac5519af9$export$a497a1dcb4408212;
module.exports["getViewportHeight"] = $d8c34cdac5519af9$export$4f01c15d21ef9cc6;

});

parcelRegister("a1L5E", function(module, exports) {
$parcel$export(module.exports, "default", () => $56bb2059ecc12551$export$2e2bcd8739ae039);

var $65DSU = parcelRequire("65DSU");


var $ah4BL = parcelRequire("ah4BL");


var $lnE0c = parcelRequire("lnE0c");


var $56bb2059ecc12551$export$2e2bcd8739ae039 = (0, $65DSU.default);

});

parcelRegister("3QDLx", function(module, exports) {
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $992e72c32fa62283$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $992e72c32fa62283$export$2e2bcd8739ae039 = $992e72c32fa62283$var$coinflip;
module.exports["default"] = $992e72c32fa62283$export$2e2bcd8739ae039;

});

parcelRegister("jtTx3", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $a4skX = parcelRequire("a4skX");


var $iDrrr = parcelRequire("iDrrr");

let $e6734f44f305b918$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $e6734f44f305b918$var$cachedIsFedrampModerate;
function $e6734f44f305b918$var$detectIsFedrampModerate() {
    if ($e6734f44f305b918$var$cachedIsFedrampModerate !== undefined) return $e6734f44f305b918$var$cachedIsFedrampModerate;
    try {
        $e6734f44f305b918$var$cachedIsFedrampModerate = (0, $a4skX.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $e6734f44f305b918$var$cachedIsFedrampModerate = false;
    }
    return $e6734f44f305b918$var$cachedIsFedrampModerate;
}
function $e6734f44f305b918$export$89dc2b6be8cc261() {
    $e6734f44f305b918$var$cachedIsFedrampModerate = undefined;
}
function $e6734f44f305b918$export$1133b5e2873baa7a() {
    try {
        return $e6734f44f305b918$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $e6734f44f305b918$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $e6734f44f305b918$export$f9bb3bb330fb9609 = 'fy26.04';
function $e6734f44f305b918$export$2182e73d31080cbc() {
    return $e6734f44f305b918$export$f9bb3bb330fb9609;
}
const $e6734f44f305b918$export$d50dacda7fe6392b = 1000;
function $e6734f44f305b918$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof enabledVCRevisions?.byExperience === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...enabledVCRevisions?.all ?? [],
            ...Object.values(byExperience).flat()
        ];
        $e6734f44f305b918$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $e6734f44f305b918$var$config = newConfig;
}
function $e6734f44f305b918$export$44487a86467333c3() {
    return $e6734f44f305b918$var$config;
}
function $e6734f44f305b918$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    // 1. FedRAMP override always wins.
    if ($e6734f44f305b918$var$detectIsFedrampModerate()) return $e6734f44f305b918$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? $e6734f44f305b918$var$config?.vc?.selectorConfig ?? defaultConfig;
}
function $e6734f44f305b918$export$74bdb753f1cf4860() {
    // Default to enabled if config is not set or enabled is not explicitly false
    return $e6734f44f305b918$var$config?.enabled !== false;
}
const $e6734f44f305b918$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $e6734f44f305b918$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$e6734f44f305b918$var$config) return [];
        if ($e6734f44f305b918$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $e6734f44f305b918$var$config.vc ?? {};
            if ($e6734f44f305b918$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions?.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $iDrrr.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($e6734f44f305b918$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $e6734f44f305b918$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $e6734f44f305b918$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $e6734f44f305b918$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $e6734f44f305b918$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $e6734f44f305b918$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $e6734f44f305b918$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $e6734f44f305b918$export$2d8f8d64dc343d7b() {
    if (!$e6734f44f305b918$var$config) return undefined;
    try {
        const stats = $e6734f44f305b918$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $e6734f44f305b918$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$e6734f44f305b918$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $e6734f44f305b918$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $e6734f44f305b918$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $e6734f44f305b918$export$48f4e0d964030a96(name, interactionType) {
    return $e6734f44f305b918$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $e6734f44f305b918$export$9c69f5a724f05f38(name, interactionType) {
    return $e6734f44f305b918$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $e6734f44f305b918$export$1d459f020c06ae34(name, interactionType) {
    return $e6734f44f305b918$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $e6734f44f305b918$export$29b9ffb14861a1d(capability) {
    if ((0, $iDrrr.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$e6734f44f305b918$var$config) return 0;
        const { capability: capabilityRate } = $e6734f44f305b918$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $e6734f44f305b918$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$e6734f44f305b918$var$config) return 0;
        const gotConfig = $e6734f44f305b918$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
const $e6734f44f305b918$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $e6734f44f305b918$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$e6734f44f305b918$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $e6734f44f305b918$var$config;
        if (typingMethod != null && $e6734f44f305b918$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $e6734f44f305b918$export$2d311b3fd18dcab1() {
    try {
        if (!$e6734f44f305b918$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $e6734f44f305b918$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $e6734f44f305b918$export$4f4649ef27b6f5d6() {
    try {
        if (!$e6734f44f305b918$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $e6734f44f305b918$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $e6734f44f305b918$export$b150ddad71c80d77() {
    try {
        if (!$e6734f44f305b918$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $e6734f44f305b918$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $e6734f44f305b918$export$3c170167645a0eff() {
    try {
        if (!$e6734f44f305b918$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $e6734f44f305b918$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $e6734f44f305b918$export$d6dc9444bd15f70f() {
    try {
        if (!$e6734f44f305b918$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $e6734f44f305b918$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $e6734f44f305b918$export$20e8108b8ccdd0bd() {
    try {
        if (!$e6734f44f305b918$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $e6734f44f305b918$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $e6734f44f305b918$export$2a8604960d7d23d9 = 60000;
function $e6734f44f305b918$export$c681731847989445(ufoName) {
    try {
        if (!$e6734f44f305b918$var$config) return $e6734f44f305b918$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $e6734f44f305b918$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $e6734f44f305b918$export$2a8604960d7d23d9;
    } catch  {
        return $e6734f44f305b918$export$2a8604960d7d23d9;
    }
}
module.exports["isFedrampOverrideActive"] = $e6734f44f305b918$export$1133b5e2873baa7a;
module.exports["DEFAULT_TTVC_REVISION"] = $e6734f44f305b918$export$f9bb3bb330fb9609;
module.exports["setUFOConfig"] = $e6734f44f305b918$export$10d6139a8fb42158;
module.exports["getConfig"] = $e6734f44f305b918$export$44487a86467333c3;
module.exports["getSelectorConfig"] = $e6734f44f305b918$export$59e1f072477dfb48;
module.exports["isUFOEnabled"] = $e6734f44f305b918$export$74bdb753f1cf4860;
module.exports["isVCRevisionEnabled"] = $e6734f44f305b918$export$4babcefc81a3ef0b;
module.exports["getMostRecentVCRevision"] = $e6734f44f305b918$export$70184d6e2c753893;
module.exports["getReactHydrationStats"] = $e6734f44f305b918$export$2d8f8d64dc343d7b;
module.exports["getInteractionRate"] = $e6734f44f305b918$export$9466a8f085fa7d4e;
module.exports["shouldUseRawDataThirdPartyBehavior"] = $e6734f44f305b918$export$9c69f5a724f05f38;
module.exports["getPostInteractionRate"] = $e6734f44f305b918$export$1d459f020c06ae34;
module.exports["getCapabilityRate"] = $e6734f44f305b918$export$29b9ffb14861a1d;
module.exports["getAwaitBM3TTIList"] = $e6734f44f305b918$export$2d311b3fd18dcab1;
module.exports["getUfoNameOverrides"] = $e6734f44f305b918$export$4f4649ef27b6f5d6;
module.exports["getMinorInteractions"] = $e6734f44f305b918$export$b150ddad71c80d77;
module.exports["getDoNotAbortActivePressInteraction"] = $e6734f44f305b918$export$3c170167645a0eff;
module.exports["getDoNotAbortActivePressInteractionOnTransition"] = $e6734f44f305b918$export$d6dc9444bd15f70f;
module.exports["getFinishInteractionOnTransition"] = $e6734f44f305b918$export$20e8108b8ccdd0bd;
module.exports["getInteractionTimeout"] = $e6734f44f305b918$export$c681731847989445;

});

parcelRegister("7Hxln", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $jtTx3 = parcelRequire("jtTx3");

function $f7eec8a03beb2671$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $f7eec8a03beb2671$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/')) name = name.replace(/\/+$/, '');
    return name;
}
function $f7eec8a03beb2671$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $f7eec8a03beb2671$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $jtTx3.getConfig)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $f7eec8a03beb2671$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $f7eec8a03beb2671$export$1adbaf5c2363e4ae(label);
            const name = $f7eec8a03beb2671$export$3535cd9da4961282(label.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $f7eec8a03beb2671$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = $f7eec8a03beb2671$export$3535cd9da4961282(l.name);
        if ($f7eec8a03beb2671$export$1adbaf5c2363e4ae(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}
function $f7eec8a03beb2671$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        const name = $f7eec8a03beb2671$export$3535cd9da4961282(l.name);
        if ($f7eec8a03beb2671$export$1adbaf5c2363e4ae(l)) return `${name}:segment`;
        return name;
    }).join('/');
}
function $f7eec8a03beb2671$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$f7eec8a03beb2671$export$1adbaf5c2363e4ae(l) ? l.segmentId : $f7eec8a03beb2671$export$3535cd9da4961282(l.name)).join('/');
}
function $f7eec8a03beb2671$export$1787b1cd413c7e2(labelStack, startWith) {
    return $f7eec8a03beb2671$export$caeee352b541de1f(labelStack).startsWith($f7eec8a03beb2671$export$caeee352b541de1f(startWith));
}
function $f7eec8a03beb2671$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $f7eec8a03beb2671$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: $f7eec8a03beb2671$export$3535cd9da4961282(ls.name),
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $f7eec8a03beb2671$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $f7eec8a03beb2671$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $f7eec8a03beb2671$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $f7eec8a03beb2671$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $jtTx3.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config?.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $f7eec8a03beb2671$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $f7eec8a03beb2671$export$1adbaf5c2363e4ae(ls);
            const name = $f7eec8a03beb2671$export$3535cd9da4961282(ls.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}
module.exports["sanitizeUfoName"] = $f7eec8a03beb2671$export$e08487ea3ae92adb;
module.exports["sanitizeLabelStackName"] = $f7eec8a03beb2671$export$3535cd9da4961282;
module.exports["isSegmentLabel"] = $f7eec8a03beb2671$export$1adbaf5c2363e4ae;
module.exports["buildSegmentTree"] = $f7eec8a03beb2671$export$1569bc0edeecbcd8;
module.exports["stringifyLabelStackFully"] = $f7eec8a03beb2671$export$caeee352b541de1f;
module.exports["labelStackStartWith"] = $f7eec8a03beb2671$export$1787b1cd413c7e2;
module.exports["optimizeLabelStackWithRegistry"] = $f7eec8a03beb2671$export$cb3145456a04e238;
module.exports["getOldSegmentsLabelStack"] = $f7eec8a03beb2671$export$b70bcfd92c93435e;

});

parcelRegister("c9IWh", function(module, exports) {

var $3IE7e = parcelRequire("3IE7e");

var $km5e4 = parcelRequire("km5e4");


var $iDrrr = parcelRequire("iDrrr");


var $aK89A = parcelRequire("aK89A");

function $d38d1b265dd500b1$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}


const $adf95be0e1aea1d1$var$state = {
    context: null
};
const $adf95be0e1aea1d1$var$traceIdKey = (0, $km5e4.createContextKey)('traceId');
const $adf95be0e1aea1d1$var$spanIdKey = (0, $km5e4.createContextKey)('spanId');
const $adf95be0e1aea1d1$var$experienceTypeKey = (0, $km5e4.createContextKey)('type');
function $adf95be0e1aea1d1$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $adf95be0e1aea1d1$export$f2e521e495a88544(interactionId, experienceType) {
    $adf95be0e1aea1d1$export$a1002be327997103(interactionId.replace(/-/g, ''), $adf95be0e1aea1d1$export$295213bc4d0c54ad(), experienceType);
}
function $adf95be0e1aea1d1$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $iDrrr.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $km5e4.ROOT_CONTEXT).setValue($adf95be0e1aea1d1$var$traceIdKey, traceId).setValue($adf95be0e1aea1d1$var$spanIdKey, spanId).setValue($adf95be0e1aea1d1$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $aK89A.getContextManager)() instanceof (0, $aK89A.UFOContextManager)) {
            let contextManager = (0, $aK89A.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $adf95be0e1aea1d1$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $adf95be0e1aea1d1$export$b6ac780db3a3cc77() {
    if ((0, $iDrrr.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $3IE7e.context).active().getValue($adf95be0e1aea1d1$var$traceIdKey)),
            spanId: String((0, $3IE7e.context).active().getValue($adf95be0e1aea1d1$var$spanIdKey)),
            type: String((0, $3IE7e.context).active().getValue($adf95be0e1aea1d1$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $adf95be0e1aea1d1$var$state.context || undefined;
}
function $adf95be0e1aea1d1$export$17ab21d7be720b() {
    if ((0, $iDrrr.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $aK89A.getContextManager)() instanceof (0, $aK89A.UFOContextManager)) {
            let contextManager = (0, $aK89A.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $km5e4.ROOT_CONTEXT));
        }
    } else $adf95be0e1aea1d1$var$state.context = null;
}
function $adf95be0e1aea1d1$export$6e17cce6446848f9(_url) {
    if ($adf95be0e1aea1d1$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $adf95be0e1aea1d1$export$b6ac780db3a3cc77();
    return (0, $d38d1b265dd500b1$export$1115c5277eb10d5e)(traceId, spanId);
}
function $adf95be0e1aea1d1$export$a1e7396778592551(_url) {
    const traceHeaders = $adf95be0e1aea1d1$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}
module.exports["setInteractionActiveTrace"] = $adf95be0e1aea1d1$export$f2e521e495a88544;
module.exports["setActiveTrace"] = $adf95be0e1aea1d1$export$a1002be327997103;
module.exports["getActiveTrace"] = $adf95be0e1aea1d1$export$b6ac780db3a3cc77;
module.exports["clearActiveTrace"] = $adf95be0e1aea1d1$export$17ab21d7be720b;
module.exports["getActiveTraceHttpRequestHeaders"] = $adf95be0e1aea1d1$export$6e17cce6446848f9;
module.exports["getActiveTraceAsQueryParams"] = $adf95be0e1aea1d1$export$a1e7396778592551;

});

parcelRegister("aK89A", function(module, exports) {

var $km5e4 = parcelRequire("km5e4");

/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $52005cd102fa2b01$var$contextManager;
function $52005cd102fa2b01$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $52005cd102fa2b01$var$contextManager = ctxMgr;
}
function $52005cd102fa2b01$export$831109c9f7727010() {
    return $52005cd102fa2b01$var$contextManager;
}
class $52005cd102fa2b01$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $km5e4.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $km5e4.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $km5e4.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $km5e4.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
     * whether the context manager is enabled or not
     */ this._enabled = false;
        /**
     * Keeps the reference to current context
     */ this._currentContext = (0, $km5e4.ROOT_CONTEXT);
    }
}
module.exports["setContextManager"] = $52005cd102fa2b01$export$4a00ab8a5dd9b5cf;
module.exports["getContextManager"] = $52005cd102fa2b01$export$831109c9f7727010;
module.exports["UFOContextManager"] = $52005cd102fa2b01$export$dd301b96c16f583d;

});

parcelRegister("8BQV6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ac2767032b0a44$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");

var $d6ac2767032b0a44$export$2e2bcd8739ae039 = (0, $5EzLH.default);
const $d6ac2767032b0a44$export$11bcb6e9af2aca35 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInteractionContext() {
    return (0, $cozmU.useContext)((0, $5EzLH.default));
} : function useInteractionContext() {
    return (0, $cozmU.useContext)((0, $5EzLH.default));
};
module.exports["useInteractionContext"] = $d6ac2767032b0a44$export$11bcb6e9af2aca35;

});

parcelRegister("4QMIF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a8860cf98fb4a8c5$var$listeners = new Set();
// Observable interaction ID implementation
class $a8860cf98fb4a8c5$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $a8860cf98fb4a8c5$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $a8860cf98fb4a8c5$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $a8860cf98fb4a8c5$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $a8860cf98fb4a8c5$export$3109542b68df9ba1 = $a8860cf98fb4a8c5$var$initializeGlobalDefaultInteractionID();
const $a8860cf98fb4a8c5$export$3e0c3023952f6774 = (listener)=>{
    $a8860cf98fb4a8c5$var$listeners.add(listener);
    return ()=>{
        $a8860cf98fb4a8c5$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $a8860cf98fb4a8c5$var$interactionContext = (0, $cozmU.createContext)($a8860cf98fb4a8c5$export$3109542b68df9ba1);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a8860cf98fb4a8c5$export$2e2bcd8739ae039 = $a8860cf98fb4a8c5$var$interactionContext;
const $a8860cf98fb4a8c5$export$37bca3107733ac1e = ()=>$a8860cf98fb4a8c5$export$3109542b68df9ba1;
const $a8860cf98fb4a8c5$export$9f6000531b78127e = ()=>$a8860cf98fb4a8c5$export$3109542b68df9ba1;
module.exports["DefaultInteractionID"] = $a8860cf98fb4a8c5$export$3109542b68df9ba1;
module.exports["subscribeToInteractionIdChanges"] = $a8860cf98fb4a8c5$export$3e0c3023952f6774;
module.exports["default"] = $a8860cf98fb4a8c5$export$2e2bcd8739ae039;
module.exports["getInteractionId"] = $a8860cf98fb4a8c5$export$37bca3107733ac1e;

});

parcelRegister("a33Aa", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $3QDLx = parcelRequire("3QDLx");


var $h2dFL = parcelRequire("h2dFL");


var $jtTx3 = parcelRequire("jtTx3");


var $5hkVZ = parcelRequire("5hkVZ");


var $7Hxln = parcelRequire("7Hxln");


var $c9IWh = parcelRequire("c9IWh");


var $7OZjB = parcelRequire("7OZjB");


var $4QMIF = parcelRequire("4QMIF");


var $l8ayF = parcelRequire("l8ayF");


var $lRNyi = parcelRequire("lRNyi");


var $gz1Do = parcelRequire("gz1Do");

const $92cce4424696a266$export$cc97b17ef9aeb088 = new Map();






var $8fj6C = parcelRequire("8fj6C");




const $f68717c26090ea49$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $f68717c26090ea49$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $gz1Do.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $8fj6C.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $jtTx3.getConfig)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = (0, $jtTx3.getConfig)()?.timeWindowForLateMutationsInMilliseconds || $f68717c26090ea49$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}


const $d4a067864e38b56d$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $d4a067864e38b56d$export$d8f52e8f804021e8 = new (0, $f68717c26090ea49$export$2e2bcd8739ae039)();
const $d4a067864e38b56d$var$interactionQueue = [];
const $d4a067864e38b56d$var$segmentCache = new Map();
const $d4a067864e38b56d$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $d4a067864e38b56d$var$segmentObservers = [];
function $d4a067864e38b56d$export$2b3954d2e8509985() {
    const interactionId = (0, $4QMIF.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId.current);
}
function $d4a067864e38b56d$var$isPerformanceTracingEnabled() {
    return (0, $jtTx3.getConfig)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $d4a067864e38b56d$var$performanceEventObserver;
const $d4a067864e38b56d$export$17afbba0f16b4b19 = ()=>{
    $d4a067864e38b56d$var$performanceEventObserver = $d4a067864e38b56d$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $d4a067864e38b56d$export$e6be05b411ce21a6(entry);
    });
    return $d4a067864e38b56d$var$performanceEventObserver;
};
const $d4a067864e38b56d$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $d4a067864e38b56d$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $d4a067864e38b56d$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $d4a067864e38b56d$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $d4a067864e38b56d$var$addSegmentObserver(observer) {
    $d4a067864e38b56d$var$segmentObservers.push(observer);
    for (const segmentInfo of $d4a067864e38b56d$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $d4a067864e38b56d$var$removeSegmentObserver(observer) {
    const index = $d4a067864e38b56d$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $d4a067864e38b56d$var$segmentObservers.splice(index, 1);
}
function $d4a067864e38b56d$export$cd7f480d6b8286c3(interactionId) {
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).delete(interactionId);
}
function $d4a067864e38b56d$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $d4a067864e38b56d$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $d4a067864e38b56d$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $d4a067864e38b56d$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $d4a067864e38b56d$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $d4a067864e38b56d$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $l8ayF.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $d4a067864e38b56d$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $d4a067864e38b56d$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $d4a067864e38b56d$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $d4a067864e38b56d$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $h2dFL.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $d4a067864e38b56d$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $d4a067864e38b56d$export$85d1eb835f669bf(_interactionId, _labelStack, _time) {}
function $d4a067864e38b56d$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $d4a067864e38b56d$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $d4a067864e38b56d$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $d4a067864e38b56d$export$9e04fe1a58571ec(moduleId, timestamp) {
    $d4a067864e38b56d$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $d4a067864e38b56d$export$6f228d1fdc911d7(identifier, start, end) {
    $d4a067864e38b56d$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $d4a067864e38b56d$var$moduleLoadingRequests = {};
function $d4a067864e38b56d$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $d4a067864e38b56d$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $d4a067864e38b56d$var$labelStackToString(labelStack), name, startTime);
}
function $d4a067864e38b56d$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $d4a067864e38b56d$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $kHija.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $d4a067864e38b56d$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($d4a067864e38b56d$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $d4a067864e38b56d$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $d4a067864e38b56d$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $d4a067864e38b56d$var$removeHoldCriterion(id);
            const currentInteraction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        $d4a067864e38b56d$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $d4a067864e38b56d$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($d4a067864e38b56d$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $d4a067864e38b56d$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $d4a067864e38b56d$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $d4a067864e38b56d$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        $d4a067864e38b56d$var$recordMetricVariantCategoryEnd(interaction, labelStack, end);
        $d4a067864e38b56d$var$ensureExtendedHoldInfo(interaction).push({
            labelStack: labelStack,
            name: name,
            start: start,
            end: end
        });
    }
}
function $d4a067864e38b56d$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($d4a067864e38b56d$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $d4a067864e38b56d$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $d4a067864e38b56d$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                $d4a067864e38b56d$var$recordMetricVariantCategoryEnd(currentInteraction, current3pHold.labelStack, end);
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $d4a067864e38b56d$export$2df109852219d16e(interactionId) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $d4a067864e38b56d$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $d4a067864e38b56d$export$9e04fe1a58571ec($d4a067864e38b56d$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $d4a067864e38b56d$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $d4a067864e38b56d$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $d4a067864e38b56d$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $d4a067864e38b56d$var$moduleLoadingRequests[info.identifier];
            $d4a067864e38b56d$export$6f228d1fdc911d7($d4a067864e38b56d$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $4QMIF.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d4a067864e38b56d$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $4QMIF.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d4a067864e38b56d$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $d4a067864e38b56d$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $d4a067864e38b56d$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $d4a067864e38b56d$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $jtTx3.getConfig)()?.postInteractionLog?.enabled) $d4a067864e38b56d$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $d4a067864e38b56d$var$pushToQueue(id, data) {
    $d4a067864e38b56d$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $d4a067864e38b56d$var$handleInteraction = $d4a067864e38b56d$var$pushToQueue;
const $d4a067864e38b56d$var$isKnownMetricVariantCategory = (type)=>type === 'third-party' || type === 'gen-ai';
const $d4a067864e38b56d$var$hasMetricVariantCategory = (labelStack, category)=>labelStack?.some((label)=>'type' in label && label.type === category) ?? false;
const $d4a067864e38b56d$var$hasAnyMetricVariantCategory = (labelStack)=>labelStack?.some((label)=>'type' in label && $d4a067864e38b56d$var$isKnownMetricVariantCategory(label.type)) ?? false;
const $d4a067864e38b56d$var$getMetricVariantCategories = (labelStack)=>{
    const categories = new Set();
    labelStack?.forEach((label)=>{
        if ('type' in label && $d4a067864e38b56d$var$isKnownMetricVariantCategory(label.type)) categories.add(label.type);
    });
    return [
        ...categories
    ];
};
const $d4a067864e38b56d$var$hasMetricVariantCategoryInHoldData = (interaction, category)=>interaction.holdInfo.some((hold)=>$d4a067864e38b56d$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.holdActive.values() ?? []
    ].some((hold)=>$d4a067864e38b56d$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pInfo ?? []
    ].some((hold)=>$d4a067864e38b56d$var$hasMetricVariantCategory(hold.labelStack, category)) || [
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$d4a067864e38b56d$var$hasMetricVariantCategory(hold.labelStack, category));
const $d4a067864e38b56d$var$recordMetricVariantCategoryEnd = (interaction, labelStack, end)=>{
    const categories = $d4a067864e38b56d$var$getMetricVariantCategories(labelStack);
    if (categories.length === 0) return;
    interaction.metricCategoryEnds = interaction.metricCategoryEnds ?? {};
    categories.forEach((category)=>{
        interaction.metricCategoryEnds[category] = Math.max(interaction.metricCategoryEnds[category] ?? 0, end);
    });
};
const $d4a067864e38b56d$var$recordActiveMetricVariantCategoryEnds = (interaction, end)=>{
    interaction.hold3pActive?.forEach((hold)=>{
        $d4a067864e38b56d$var$recordMetricVariantCategoryEnd(interaction, hold.labelStack, end);
    });
};
const $d4a067864e38b56d$var$hasActiveMetricVariantCategory = (interaction, category)=>[
        ...interaction.hold3pActive?.values() ?? []
    ].some((hold)=>$d4a067864e38b56d$var$hasMetricVariantCategory(hold.labelStack, category));
function $d4a067864e38b56d$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    return $d4a067864e38b56d$var$hasAnyMetricVariantCategory(hold.labelStack) || interaction.end !== 0 && hold.start > interaction.end;
}
function $d4a067864e38b56d$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $d4a067864e38b56d$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $d4a067864e38b56d$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$d4a067864e38b56d$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $d4a067864e38b56d$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $d4a067864e38b56d$var$ensureMetricWindows(interaction) {
    if (interaction.end === 0) return;
    const hasGenAI = $d4a067864e38b56d$var$hasMetricVariantCategoryInHoldData(interaction, 'gen-ai');
    const hasThirdParty = $d4a067864e38b56d$var$hasMetricVariantCategoryInHoldData(interaction, 'third-party');
    const includeThirdPartyEnd = interaction.metricCategoryEnds?.['third-party'] !== undefined ? Math.max(interaction.metricCategoryEnds['third-party'], interaction.end) : interaction.end3p;
    const includeGenAIEnd = interaction.metricCategoryEnds?.['gen-ai'] !== undefined ? Math.max(interaction.metricCategoryEnds['gen-ai'], interaction.end) : undefined;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party',
                'gen-ai'
            ]
        }
    };
    if (includeThirdPartyEnd !== undefined && (hasThirdParty || !hasGenAI)) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: includeThirdPartyEnd,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
    if (hasGenAI && includeGenAIEnd !== undefined) interaction.metricWindows['include-gen-ai'] = {
        start: interaction.start,
        end: includeGenAIEnd,
        includeCategories: [
            'gen-ai'
        ],
        excludeCategories: []
    };
}
function $d4a067864e38b56d$var$addLifecycleObservation(interaction, observation) {
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $d4a067864e38b56d$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $d4a067864e38b56d$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $d4a067864e38b56d$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $7OZjB.currentFeatureFlagsAccessed));
    (0, $c9IWh.clearActiveTrace)();
    $d4a067864e38b56d$var$callCleanUpCallbacks(data);
    (0, $lRNyi.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $jtTx3.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    if (!(0, $3QDLx.default)((0, $jtTx3.getPostInteractionRate)((0, $7Hxln.sanitizeUfoName)(data.ufoName), data.type))) $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
    $d4a067864e38b56d$export$cd7f480d6b8286c3(id);
    $d4a067864e38b56d$export$dbba6cdedab4e68b.id = data.id;
    $d4a067864e38b56d$export$dbba6cdedab4e68b.type = data.type;
    $d4a067864e38b56d$export$dbba6cdedab4e68b.timestamp = data.end;
    $d4a067864e38b56d$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $d4a067864e38b56d$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) $d4a067864e38b56d$var$handleInteraction(id, data);
    if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $d4a067864e38b56d$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$d4a067864e38b56d$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $d4a067864e38b56d$export$9e614a29a1ac213e(sinkFn) {
    if ($d4a067864e38b56d$var$handleInteraction === $d4a067864e38b56d$var$pushToQueue) {
        $d4a067864e38b56d$var$handleInteraction = sinkFn;
        $d4a067864e38b56d$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $d4a067864e38b56d$var$interactionQueue.length = 0;
    }
}
function $d4a067864e38b56d$export$8a1ba7bef607358a(sinkFn) {
    $d4a067864e38b56d$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $d4a067864e38b56d$var$activeSubmitted = false;
function $d4a067864e38b56d$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $jtTx3.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $jtTx3.getConfig)()?.postInteractionLog?.enabled) $d4a067864e38b56d$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $d4a067864e38b56d$var$activeSubmitted = false;
        };
        const noMoreActiveMetricVariantHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d4a067864e38b56d$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If using separated metric variant behavior, wait for extended category holds to clear.
        // The backing fields still use their legacy 3P names because they are part of the existing
        // third-party payload contract, but this bucket now also drives client metric windows.
        if (shouldUseSeparatedMetricVariantBehavior) {
            // If there are no standard holds active, mark the interaction as successful
            // but don't finish until extended metric variant holds are cleared.
            if (noMoreActiveHolds && !noMoreActiveMetricVariantHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $d4a067864e38b56d$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $d4a067864e38b56d$var$ensureMetricWindows(interaction);
                // Wait for extended metric variant holds to clear before finishing.
                return;
            }
            // If all holds, including extended metric variant holds, are cleared, finish the interaction.
            if (noMoreActiveHolds && noMoreActiveMetricVariantHolds) {
                if (!$d4a067864e38b56d$var$activeSubmitted) {
                    // Set the legacy third-party end marker when extended metric variant holds clear,
                    // preserving existing 3P payload behavior while category-specific end times are
                    // recorded separately in metricCategoryEnds.
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $d4a067864e38b56d$var$ensureMetricWindows(interaction);
                    $d4a067864e38b56d$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $jtTx3.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $jtTx3.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $5hkVZ.onSearchPageInteractionComplete)(interactionId, interaction);
                    $d4a067864e38b56d$var$activeSubmitted = true;
                }
                postInteraction();
            }
        } else if (noMoreActiveHolds) {
            if (!$d4a067864e38b56d$var$activeSubmitted) {
                $d4a067864e38b56d$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $jtTx3.getConfig)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $jtTx3.getConfig)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $5hkVZ.onSearchPageInteractionComplete)(interactionId, interaction);
                $d4a067864e38b56d$var$activeSubmitted = true;
            }
            postInteraction();
        }
    }
}
function $d4a067864e38b56d$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $d4a067864e38b56d$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $jtTx3.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d4a067864e38b56d$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $d4a067864e38b56d$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: interaction.hold3pActive?.size ?? 0
            });
            $d4a067864e38b56d$var$ensureMetricWindows(interaction);
            $d4a067864e38b56d$var$finishInteraction(interactionId, interaction, endTime);
            $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
            $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $d4a067864e38b56d$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (interaction.hold3pActive?.size ?? 0)
        });
        $d4a067864e38b56d$var$finishInteraction(interactionId, interaction);
        $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
        $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $d4a067864e38b56d$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $jtTx3.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d4a067864e38b56d$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $d4a067864e38b56d$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $d4a067864e38b56d$var$ensureMetricWindows(interaction);
            $d4a067864e38b56d$var$finishInteraction(interactionId, interaction, endTime);
            $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
            $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        $d4a067864e38b56d$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $d4a067864e38b56d$var$finishInteraction(interactionId, interaction);
        $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
        $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
    } else {
        // post-interaction log is active after interaction is aborted by new one
        $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
        $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $d4a067864e38b56d$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $d4a067864e38b56d$export$2b3954d2e8509985();
    const finishInteractions = (0, $jtTx3.getFinishInteractionOnTransition)();
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $jtTx3.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        const shouldUseSeparatedMetricVariantBehavior = shouldUseRawDataThirdParty || $d4a067864e38b56d$var$hasActiveMetricVariantCategory(interaction, 'gen-ai');
        // If only extended metric variant holds are active, finish as successful instead of aborting
        if (shouldUseSeparatedMetricVariantBehavior && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $d4a067864e38b56d$var$recordActiveMetricVariantCategoryEnds(interaction, interaction.end3p);
            $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $d4a067864e38b56d$var$ensureMetricWindows(interaction);
            $d4a067864e38b56d$var$finishInteraction(interactionId, interaction, endTime);
            $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
            $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
            return;
        }
        if (!hasFinished) {
            $d4a067864e38b56d$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $d4a067864e38b56d$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $d4a067864e38b56d$var$finishInteraction(interactionId, interaction);
        $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
        $d4a067864e38b56d$export$d8f52e8f804021e8.stopVCObserver();
    });
}
function $d4a067864e38b56d$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $d4a067864e38b56d$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $d4a067864e38b56d$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $jtTx3.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $d4a067864e38b56d$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $d4a067864e38b56d$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $3QDLx.default)((0, $jtTx3.getCapabilityRate)('feature_flag_access'));
    const config = (0, $jtTx3.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config?.extraSearchPageInteraction?.enabled,
        searchPageRoute: config?.extraSearchPageInteraction?.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $jtTx3.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $gz1Do.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $7OZjB.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $d4a067864e38b56d$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $d4a067864e38b56d$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $7OZjB.currentFeatureFlagsAccessed).clear();
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $d4a067864e38b56d$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $d4a067864e38b56d$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $jtTx3.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $d4a067864e38b56d$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $jtTx3.getConfig)()?.postInteractionLog?.enabled) $d4a067864e38b56d$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $d4a067864e38b56d$export$4a759336b50e86e3(event) {
    const interaction = $d4a067864e38b56d$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $d4a067864e38b56d$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $d4a067864e38b56d$export$ad216cc25852d44b(apdex) {
    (0, $92cce4424696a266$export$cc97b17ef9aeb088).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d4a067864e38b56d$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $d4a067864e38b56d$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d4a067864e38b56d$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $d4a067864e38b56d$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $d4a067864e38b56d$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d4a067864e38b56d$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($d4a067864e38b56d$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $d4a067864e38b56d$export$1c43f9ac826b6462(labelStack) {
    const key = $d4a067864e38b56d$var$getSegmentCacheKey(labelStack);
    const existingSegment = $d4a067864e38b56d$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $d4a067864e38b56d$var$segmentCache.set(key, segmentInfo);
        $d4a067864e38b56d$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $d4a067864e38b56d$export$d0365e48b58231c3(labelStack) {
    const key = $d4a067864e38b56d$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $d4a067864e38b56d$var$segmentCache.get(key);
    if (segmentInfo) {
        $d4a067864e38b56d$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $7Hxln.stringifyLabelStackFully)(labelStack);
        $d4a067864e38b56d$export$a2b14406ded37d60.set(cacheKey, ($d4a067864e38b56d$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $d4a067864e38b56d$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $d4a067864e38b56d$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $92cce4424696a266$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($d4a067864e38b56d$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $d4a067864e38b56d$export$6ce04c7ca6810a7e = [];
const $d4a067864e38b56d$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $d4a067864e38b56d$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $d4a067864e38b56d$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $d4a067864e38b56d$export$6ce04c7ca6810a7e.push(customSpan);
}
module.exports["PreviousInteractionLog"] = $d4a067864e38b56d$export$dbba6cdedab4e68b;
module.exports["postInteractionLog"] = $d4a067864e38b56d$export$d8f52e8f804021e8;
module.exports["segmentUnmountCache"] = $d4a067864e38b56d$export$a2b14406ded37d60;
module.exports["getActiveInteraction"] = $d4a067864e38b56d$export$2b3954d2e8509985;
module.exports["updatePageLoadInteractionName"] = $d4a067864e38b56d$export$f6f1cf5bedf83c71;
module.exports["addCustomData"] = $d4a067864e38b56d$export$e4380431c2bdabee;
module.exports["addSegmentExtraData"] = $d4a067864e38b56d$export$35723c3772fda7dd;
module.exports["addIframeSegmentData"] = $d4a067864e38b56d$export$c227d812a1e08d80;
module.exports["addCohortingCustomData"] = $d4a067864e38b56d$export$20265b12c6625451;
module.exports["addCustomTiming"] = $d4a067864e38b56d$export$27cacb7d7f3fe20a;
module.exports["addMark"] = $d4a067864e38b56d$export$728e28c22a0fba4;
module.exports["addSpan"] = $d4a067864e38b56d$export$2c1d6e17cfa9bbc7;
module.exports["addSpanToAll"] = $d4a067864e38b56d$export$943a8b2b5d6b1809;
module.exports["addHold"] = $d4a067864e38b56d$export$7606887303596f82;
module.exports["addHoldByID"] = $d4a067864e38b56d$export$10582acd678c213;
module.exports["addCompletedHold"] = $d4a067864e38b56d$export$d6cf9650acfb0dab;
module.exports["removeHoldByID"] = $d4a067864e38b56d$export$4983dfbbb996f7ae;
module.exports["getCurrentInteractionType"] = $d4a067864e38b56d$export$2df109852219d16e;
module.exports["addError"] = $d4a067864e38b56d$export$239c33984d9b1367;
module.exports["addErrorToAll"] = $d4a067864e38b56d$export$7379c15afd3840fa;
module.exports["addProfilerTimings"] = $d4a067864e38b56d$export$53d6f611de951a13;
module.exports["sinkInteractionHandler"] = $d4a067864e38b56d$export$9e614a29a1ac213e;
module.exports["sinkPostInteractionLogHandler"] = $d4a067864e38b56d$export$8a1ba7bef607358a;
module.exports["tryComplete"] = $d4a067864e38b56d$export$673be905888f8839;
module.exports["abort"] = $d4a067864e38b56d$export$5def58af4fd46132;
module.exports["abortByNewInteraction"] = $d4a067864e38b56d$export$c4a545284f55edf2;
module.exports["abortAll"] = $d4a067864e38b56d$export$614a7af2affc5dff;
module.exports["addOnCancelCallback"] = $d4a067864e38b56d$export$7b9261a96cfe427b;
module.exports["addNewInteraction"] = $d4a067864e38b56d$export$1a1ed1e1fdb2006b;
module.exports["addBrowserMetricEvent"] = $d4a067864e38b56d$export$4a759336b50e86e3;
module.exports["addApdex"] = $d4a067864e38b56d$export$35220fd6cdd1b731;
module.exports["addRequestInfo"] = $d4a067864e38b56d$export$57d55b4569823d8f;
module.exports["addSegment"] = $d4a067864e38b56d$export$1c43f9ac826b6462;
module.exports["removeSegment"] = $d4a067864e38b56d$export$d0365e48b58231c3;
module.exports["interactionSpans"] = $d4a067864e38b56d$export$6ce04c7ca6810a7e;
module.exports["addCustomSpans"] = $d4a067864e38b56d$export$5342dcad19138a1c;

});

parcelRegister("h2dFL", function(module, exports) {
const $c3f15c00197f4008$export$4c07c8a3507ce307 = 255;
const $c3f15c00197f4008$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $c3f15c00197f4008$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $c3f15c00197f4008$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams?.get(param)));
    } catch  {
        return false;
    }
}
function $c3f15c00197f4008$export$23e69abaca7d0236(name) {
    if (name.length <= $c3f15c00197f4008$export$4c07c8a3507ce307) return name;
    if ($c3f15c00197f4008$var$isGqlUrl(name)) return name;
    return name.slice(0, $c3f15c00197f4008$export$4c07c8a3507ce307);
}
module.exports["sanitizeTimingName"] = $c3f15c00197f4008$export$23e69abaca7d0236;

});

parcelRegister("5hkVZ", function(module, exports) {
const $208d24196263e0e8$var$interactionBuffer = [];
let $208d24196263e0e8$var$bufferInteractionData = (interactionId, data)=>{
    $208d24196263e0e8$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $208d24196263e0e8$var$clearInteractionBuffer() {
    $208d24196263e0e8$var$interactionBuffer.length = 0;
}
function $208d24196263e0e8$var$appendInteractionData(interactionId, data) {
    $208d24196263e0e8$var$bufferInteractionData(interactionId, data);
}
function $208d24196263e0e8$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $208d24196263e0e8$var$interactionBuffer)handler(interactionId, data);
    $208d24196263e0e8$var$clearInteractionBuffer();
    $208d24196263e0e8$var$bufferInteractionData = handler;
}
function $208d24196263e0e8$export$e6a07a94f3e112d4(sinkFn) {
    $208d24196263e0e8$var$installInteractionSink(sinkFn);
}
function $208d24196263e0e8$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $208d24196263e0e8$var$appendInteractionData(interactionId, data);
        $208d24196263e0e8$var$clearInteractionBuffer();
    }
}
module.exports["sinkExtraSearchPageInteractionHandler"] = $208d24196263e0e8$export$e6a07a94f3e112d4;
module.exports["onSearchPageInteractionComplete"] = $208d24196263e0e8$export$74b9ce7e9d206a8;

});

parcelRegister("7OZjB", function(module, exports) {

var $hHISI = parcelRequire("hHISI");

const $21f5a86b0a2e9695$export$5b78c989c8db2561 = new Map();
const $21f5a86b0a2e9695$export$2a5c8df26bb89760 = new Map();
function $21f5a86b0a2e9695$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $hHISI.redactValue)(featureFlagValue);
    $21f5a86b0a2e9695$export$5b78c989c8db2561.set(featureFlagName, value);
    $21f5a86b0a2e9695$export$2a5c8df26bb89760.set(featureFlagName, value);
}
module.exports["allFeatureFlagsAccessed"] = $21f5a86b0a2e9695$export$5b78c989c8db2561;
module.exports["currentFeatureFlagsAccessed"] = $21f5a86b0a2e9695$export$2a5c8df26bb89760;
module.exports["addFeatureFlagAccessed"] = $21f5a86b0a2e9695$export$47fade9662f71000;

});

parcelRegister("gz1Do", function(module, exports) {

var $jtTx3 = parcelRequire("jtTx3");

class $45e43d4f75aa22c2$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}



var $iDrrr = parcelRequire("iDrrr");





var $a33Aa = parcelRequire("a33Aa");


var $6s1V6 = parcelRequire("6s1V6");

function $e649b75b638d1d5d$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}






var $8fj6C = parcelRequire("8fj6C");

const $0455371de7291fb3$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $0455371de7291fb3$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $0455371de7291fb3$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $0455371de7291fb3$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $0455371de7291fb3$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $0455371de7291fb3$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $8fj6C.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $jtTx3.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $0455371de7291fb3$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $jtTx3.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $0455371de7291fb3$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}



var $eTl29 = parcelRequire("eTl29");





var $6AKGx = parcelRequire("6AKGx");


var $issAY = parcelRequire("issAY");


var $jlWJa = parcelRequire("jlWJa");


var $pLTIz = parcelRequire("pLTIz");

const $b0f29f7a106ee2f3$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $b0f29f7a106ee2f3$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $b0f29f7a106ee2f3$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $b0f29f7a106ee2f3$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $b0f29f7a106ee2f3$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $b0f29f7a106ee2f3$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $b0f29f7a106ee2f3$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $b0f29f7a106ee2f3$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $b0f29f7a106ee2f3$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $6AKGx.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $issAY.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $6AKGx.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$b0f29f7a106ee2f3$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $jlWJa.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $b0f29f7a106ee2f3$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $jtTx3.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $pLTIz.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
}


const $6cdad76ee05a47d6$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $6cdad76ee05a47d6$var$UNUSED_SECTOR = 0;
function $6cdad76ee05a47d6$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $6cdad76ee05a47d6$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $6cdad76ee05a47d6$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $6cdad76ee05a47d6$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $6cdad76ee05a47d6$var$UNUSED_SECTOR && ssrTime !== $6cdad76ee05a47d6$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $6cdad76ee05a47d6$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $6cdad76ee05a47d6$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $6cdad76ee05a47d6$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $6cdad76ee05a47d6$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $6cdad76ee05a47d6$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $6cdad76ee05a47d6$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $jtTx3.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($6cdad76ee05a47d6$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $eTl29.getViewportWidth)();
        this.viewport.h = (0, $eTl29.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($6cdad76ee05a47d6$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($6cdad76ee05a47d6$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $6cdad76ee05a47d6$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $jtTx3.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $6cdad76ee05a47d6$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $6cdad76ee05a47d6$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $6cdad76ee05a47d6$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $e649b75b638d1d5d$export$72e6dda9d5859230)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $e649b75b638d1d5d$export$72e6dda9d5859230)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $0455371de7291fb3$export$5c86a34c9becd6d0)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $6cdad76ee05a47d6$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $6cdad76ee05a47d6$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $jtTx3.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $a33Aa.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $jtTx3.isVCRevisionEnabled)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($6cdad76ee05a47d6$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $iDrrr.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $a33Aa.getActiveInteraction)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($6cdad76ee05a47d6$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($6cdad76ee05a47d6$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $6s1V6.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $b0f29f7a106ee2f3$export$b65d046240060e78)({
            selectorConfig: (0, $jtTx3.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $jtTx3.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $6cdad76ee05a47d6$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];



var $hILZI = parcelRequire("hILZI");








var $1P2f3 = parcelRequire("1P2f3");

class $9ea96e8e1e8e4afa$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $jtTx3.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jtTx3.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $jtTx3.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jtTx3.isVCRevisionEnabled)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        this.newVCObserver?.stop();
        (0, $jlWJa.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $jtTx3.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jtTx3.isVCRevisionEnabled)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        });
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result?.[0]?.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.ssrPlaceholderHandler = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $pLTIz.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $hILZI.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $jtTx3.isVCRevisionEnabled)('fy25.01') || (0, $jtTx3.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $6cdad76ee05a47d6$export$1f70d263701b1d01)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
}
// Some products set this variable to indicate it is running in SSR
let $9ea96e8e1e8e4afa$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $9ea96e8e1e8e4afa$var$isReactSSR = typeof $1P2f3 !== 'undefined' && Boolean($1P2f3?.env?.REACT_SSR || false);
function $9ea96e8e1e8e4afa$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($9ea96e8e1e8e4afa$var$isReactSSR || $9ea96e8e1e8e4afa$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $9ea96e8e1e8e4afa$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$9ea96e8e1e8e4afa$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $45e43d4f75aa22c2$export$24d07287b49da906)() : new $9ea96e8e1e8e4afa$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $9ea96e8e1e8e4afa$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$9ea96e8e1e8e4afa$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $45e43d4f75aa22c2$export$24d07287b49da906)() : new $9ea96e8e1e8e4afa$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}
module.exports["VCObserverWrapper"] = $9ea96e8e1e8e4afa$export$4a1fe1ab3c13bbf5;
module.exports["getVCObserver"] = $9ea96e8e1e8e4afa$export$b3bc47985717b49e;
module.exports["newVCObserver"] = $9ea96e8e1e8e4afa$export$c69731bddfc24d85;

});

parcelRegister("8fj6C", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cbY7C = parcelRequire("cbY7C");


var $iDrrr = parcelRequire("iDrrr");

const $e8d320688d2312c9$var$timings = [];
let $e8d320688d2312c9$var$wasHiddenFlag;
let $e8d320688d2312c9$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $e8d320688d2312c9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $e8d320688d2312c9$var$openedInBackground = null;
function $e8d320688d2312c9$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $e8d320688d2312c9$var$SIZE = 50;
let $e8d320688d2312c9$var$insertIndex = 0;
function $e8d320688d2312c9$export$754443ce7c615bd7(startTime, endTime) {
    const earliestHiddenTiming = $e8d320688d2312c9$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)?.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $e8d320688d2312c9$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $e8d320688d2312c9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $e8d320688d2312c9$var$openedInBackground === true;
}
function $e8d320688d2312c9$var$pushHidden(isPageHiddenFlag, time) {
    $e8d320688d2312c9$var$timings[$e8d320688d2312c9$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $e8d320688d2312c9$var$insertIndex = ($e8d320688d2312c9$var$insertIndex + 1) % $e8d320688d2312c9$var$SIZE;
    $e8d320688d2312c9$var$wasHiddenFlag = isPageHiddenFlag;
}
function $e8d320688d2312c9$var$handleChange() {
    const isPageHiddenFlag = $e8d320688d2312c9$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$e8d320688d2312c9$var$wasHiddenFlag) $e8d320688d2312c9$var$pushHidden(isPageHiddenFlag);
        $e8d320688d2312c9$var$wasHiddenFlag = true;
    } else {
        if ($e8d320688d2312c9$var$wasHiddenFlag) $e8d320688d2312c9$var$pushHidden(isPageHiddenFlag);
        $e8d320688d2312c9$var$wasHiddenFlag = false;
    }
}
let $e8d320688d2312c9$var$hasHiddenTimingBeforeSetup = false;
function $e8d320688d2312c9$export$95f048bd8bcdda23() {
    return $e8d320688d2312c9$var$hasHiddenTimingBeforeSetup;
}
function $e8d320688d2312c9$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results?.forEach((result)=>{
            if ((0, $iDrrr.fg)('platform_ufo_use_native_page_visibility_api')) $e8d320688d2312c9$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $e8d320688d2312c9$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $cbY7C.bind)(window, {
        type: 'pageshow',
        listener: $e8d320688d2312c9$var$handleChange
    });
    (0, $cbY7C.bind)(window, {
        type: 'pagehide',
        listener: $e8d320688d2312c9$var$handleChange
    });
    (0, $cbY7C.bind)(document, {
        type: 'visibilitychange',
        listener: $e8d320688d2312c9$var$handleChange
    });
}
function $e8d320688d2312c9$export$554cefe0f0373da4() {
    if (!$e8d320688d2312c9$var$setupFlag) {
        const isPageHiddenFlag = $e8d320688d2312c9$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($e8d320688d2312c9$var$openedInBackground === null) $e8d320688d2312c9$var$openedInBackground = isPageHiddenFlag && setupTime < $e8d320688d2312c9$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $e8d320688d2312c9$var$pushHidden(isPageHiddenFlag, 0);
        $e8d320688d2312c9$var$setup();
        $e8d320688d2312c9$var$setupFlag = true;
    }
}
function $e8d320688d2312c9$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($e8d320688d2312c9$var$timings.length === 0) return 'visible';
    const currentSize = $e8d320688d2312c9$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $e8d320688d2312c9$var$insertIndex;
    let endIdx = $e8d320688d2312c9$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($e8d320688d2312c9$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($e8d320688d2312c9$var$timings[tmpIdx] && $e8d320688d2312c9$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($e8d320688d2312c9$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $e8d320688d2312c9$var$timings[startIdx]) hiddenState = $e8d320688d2312c9$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $e8d320688d2312c9$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $e8d320688d2312c9$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $e8d320688d2312c9$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $e8d320688d2312c9$var$throttleMeasurements = [];
let $e8d320688d2312c9$var$throttleInsertIndex = 0;
let $e8d320688d2312c9$var$throttleIntervalId = null;
let $e8d320688d2312c9$var$lastThrottleCheckTime = null;
let $e8d320688d2312c9$var$throttleSetupDone = false;
function $e8d320688d2312c9$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $e8d320688d2312c9$var$THROTTLE_DRIFT_THRESHOLD;
    $e8d320688d2312c9$var$throttleMeasurements[$e8d320688d2312c9$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $e8d320688d2312c9$var$throttleInsertIndex = ($e8d320688d2312c9$var$throttleInsertIndex + 1) % $e8d320688d2312c9$var$THROTTLE_BUFFER_SIZE;
}
function $e8d320688d2312c9$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($e8d320688d2312c9$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $e8d320688d2312c9$var$lastThrottleCheckTime;
        $e8d320688d2312c9$var$recordThrottleMeasurement($e8d320688d2312c9$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $e8d320688d2312c9$var$lastThrottleCheckTime = currentTime;
}
function $e8d320688d2312c9$export$fa0d29a9c87052da() {
    if ($e8d320688d2312c9$var$throttleSetupDone) return;
    $e8d320688d2312c9$var$throttleSetupDone = true;
    // Record the initial timestamp
    $e8d320688d2312c9$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $e8d320688d2312c9$var$throttleIntervalId = setInterval($e8d320688d2312c9$var$throttleCheckCallback, $e8d320688d2312c9$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $e8d320688d2312c9$export$3279694d66e4a1() {
    if ($e8d320688d2312c9$var$throttleIntervalId !== null) {
        clearInterval($e8d320688d2312c9$var$throttleIntervalId);
        $e8d320688d2312c9$var$throttleIntervalId = null;
    }
    $e8d320688d2312c9$var$lastThrottleCheckTime = null;
    $e8d320688d2312c9$var$throttleSetupDone = false;
    $e8d320688d2312c9$var$throttleMeasurements.length = 0;
    $e8d320688d2312c9$var$throttleInsertIndex = 0;
}
function $e8d320688d2312c9$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($e8d320688d2312c9$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $e8d320688d2312c9$var$throttleMeasurements.length; i++){
        const measurement = $e8d320688d2312c9$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $e8d320688d2312c9$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $e8d320688d2312c9$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $e8d320688d2312c9$export$9332de935653b687(measurement) {
    $e8d320688d2312c9$var$throttleMeasurements[$e8d320688d2312c9$var$throttleInsertIndex] = measurement;
    $e8d320688d2312c9$var$throttleInsertIndex = ($e8d320688d2312c9$var$throttleInsertIndex + 1) % $e8d320688d2312c9$var$THROTTLE_BUFFER_SIZE;
}
function $e8d320688d2312c9$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($e8d320688d2312c9$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $e8d320688d2312c9$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($e8d320688d2312c9$var$insertIndex + i) % currentSize;
        const entry = $e8d320688d2312c9$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($e8d320688d2312c9$var$insertIndex + i) % currentSize;
        const entry = $e8d320688d2312c9$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $e8d320688d2312c9$export$9332de935653b687
};
module.exports["getEarliestHiddenTiming"] = $e8d320688d2312c9$export$754443ce7c615bd7;
module.exports["isOpenedInBackground"] = $e8d320688d2312c9$export$21a1a62a307062f1;
module.exports["getHasHiddenTimingBeforeSetup"] = $e8d320688d2312c9$export$95f048bd8bcdda23;
module.exports["setupHiddenTimingCapture"] = $e8d320688d2312c9$export$554cefe0f0373da4;
module.exports["getPageVisibilityState"] = $e8d320688d2312c9$export$768b2008623433e1;
module.exports["setupThrottleDetection"] = $e8d320688d2312c9$export$fa0d29a9c87052da;
module.exports["isTabThrottled"] = $e8d320688d2312c9$export$62a28c860277b3bf;
module.exports["getPageVisibilityTimeline"] = $e8d320688d2312c9$export$5a06b84e47ad70d9;

});

parcelRegister("5o4s6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $829cbda3c9bd431a$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $829cbda3c9bd431a$export$7028e9efe569888c = {
    [$829cbda3c9bd431a$export$7674290405cc25b0]: true
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $829cbda3c9bd431a$var$MediaWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MediaWrapper(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", $829cbda3c9bd431a$export$7028e9efe569888c, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function MediaWrapper({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", $829cbda3c9bd431a$export$7028e9efe569888c, children);
};
var $829cbda3c9bd431a$export$2e2bcd8739ae039 = $829cbda3c9bd431a$var$MediaWrapper;
module.exports["MEDIA_WRAPPER_TAG"] = $829cbda3c9bd431a$export$7674290405cc25b0;
module.exports["VcMediaWrapperProps"] = $829cbda3c9bd431a$export$7028e9efe569888c;

});

parcelRegister("hILZI", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $jtTx3 = parcelRequire("jtTx3");


var $7Hxln = parcelRequire("7Hxln");


var $a33Aa = parcelRequire("a33Aa");


var $pLTIz = parcelRequire("pLTIz");

class $186b21fecc2186fe$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}


const $87b2725b3831be0e$var$nameCache = new WeakMap();
function $87b2725b3831be0e$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $87b2725b3831be0e$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $87b2725b3831be0e$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $87b2725b3831be0e$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $87b2725b3831be0e$var$nameCache.set(element, name);
    return name;
}
var $87b2725b3831be0e$export$2e2bcd8739ae039 = $87b2725b3831be0e$var$getElementName;






var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");

const $63eb120dff9b319d$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $cXtTj.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $cXtTj.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};


const $e2bdd704106494fd$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $e2bdd704106494fd$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $e2bdd704106494fd$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $e2bdd704106494fd$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $e2bdd704106494fd$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $e2bdd704106494fd$var$parseStyleSet(oldValue);
    const newStyles = $e2bdd704106494fd$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$e2bdd704106494fd$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$e2bdd704106494fd$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $e2bdd704106494fd$export$2e2bcd8739ae039 = $e2bdd704106494fd$export$e20e7bf2c822f3df;





// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $9f767a0fe569cc75$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $9f767a0fe569cc75$export$2e2bcd8739ae039 = $9f767a0fe569cc75$var$taskYield;


class $a1c4551536996cb4$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $a1c4551536996cb4$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $a1c4551536996cb4$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $a1c4551536996cb4$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function $a1c4551536996cb4$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $a1c4551536996cb4$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $9f767a0fe569cc75$export$2e2bcd8739ae039)();
    }
    return arr;
}


async function $e2cf639aa54980ca$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $a1c4551536996cb4$export$3e59ac9de7402fb1)(viewport, (0, $iDrrr.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $e2cf639aa54980ca$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $e2cf639aa54980ca$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $a1c4551536996cb4$export$3e59ac9de7402fb1)(viewport, (0, $iDrrr.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $e2cf639aa54980ca$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $e2cf639aa54980ca$export$2e2bcd8739ae039 = $e2cf639aa54980ca$var$calculateTTVCPercentiles;
function $e2cf639aa54980ca$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $e2cf639aa54980ca$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}


const $ca5af20e2857006c$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $ca5af20e2857006c$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $ca5af20e2857006c$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $ca5af20e2857006c$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $ca5af20e2857006c$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $ca5af20e2857006c$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $ca5af20e2857006c$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $ca5af20e2857006c$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $ca5af20e2857006c$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};


function $38d1af56f0ecb9c0$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $38d1af56f0ecb9c0$export$2e2bcd8739ae039 = $38d1af56f0ecb9c0$var$getViewportHeight;


function $eff1c09acb177ea8$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $eff1c09acb177ea8$export$2e2bcd8739ae039 = $eff1c09acb177ea8$var$getViewportWidth;


function $8acf4e07b45ddd5f$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $8acf4e07b45ddd5f$export$2e2bcd8739ae039 = $8acf4e07b45ddd5f$var$isViewportEntryData;


// Helper function for reporting ratios
function $aeb6bc576f857224$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $aeb6bc576f857224$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)();
        const viewportHeight = (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $aeb6bc576f857224$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $8acf4e07b45ddd5f$export$2e2bcd8739ae039)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $e2cf639aa54980ca$export$96ea73435089b05a)({
            viewport: {
                width: (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)(),
                height: (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $ca5af20e2857006c$export$93ce39b765ea2cd3)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameWay ?? false,
                    dist: layoutShiftOffendersResult?.layoutShiftVariables.allMovedSameAmount ?? false
                },
                total_mut: layoutShiftOffendersResult?.layoutShiftOffenders.length ?? 0,
                mut: layoutShiftOffendersResult?.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}


// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $c1ba1c0b2515130e$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $c1ba1c0b2515130e$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $c1ba1c0b2515130e$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $c1ba1c0b2515130e$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $c1ba1c0b2515130e$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];



const $5960a97d09f6b2fb$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $5960a97d09f6b2fb$var$REVISION_NO = 'fy25.03';
const $5960a97d09f6b2fb$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested.
    // GenAI elements intentionally remain excluded from core TTVC; a server-side metric variant
    // can derive "including GenAI" from the emitted metricWindows payload.
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $5960a97d09f6b2fb$export$2e2bcd8739ae039 extends (0, $aeb6bc576f857224$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$5960a97d09f6b2fb$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $63eb120dff9b319d$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $63eb120dff9b319d$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $e2bdd704106494fd$export$7867ddcf372cd2bf)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $c1ba1c0b2515130e$export$98812f4e79596e2b).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $c1ba1c0b2515130e$export$44331555a87fcd9e).includes(attributeName) || (0, $c1ba1c0b2515130e$export$c4351da6279bef53).includes(attributeName) && (0, $iDrrr.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $c1ba1c0b2515130e$export$5a7b359ee5e32a5b).includes(attributeName) && (0, $iDrrr.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $c1ba1c0b2515130e$export$2492353b2cc31cc0).includes(attributeName) && (0, $iDrrr.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $8acf4e07b45ddd5f$export$2e2bcd8739ae039)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($5960a97d09f6b2fb$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo ?? $5960a97d09f6b2fb$var$REVISION_NO);
    }
}







const $3675866d198c1e14$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $3675866d198c1e14$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $3675866d198c1e14$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $3675866d198c1e14$export$2e2bcd8739ae039 extends (0, $5960a97d09f6b2fb$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$3675866d198c1e14$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $3675866d198c1e14$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $iDrrr.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $c1ba1c0b2515130e$export$c4351da6279bef53),
            ...(0, $iDrrr.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $c1ba1c0b2515130e$export$5a7b359ee5e32a5b) : [],
            ...(0, $iDrrr.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $c1ba1c0b2515130e$export$2492353b2cc31cc0) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $c1ba1c0b2515130e$export$98812f4e79596e2b).includes(attributeName) || (0, $c1ba1c0b2515130e$export$44331555a87fcd9e).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $3675866d198c1e14$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
}





const $9ab9afd19e41cc34$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $9ab9afd19e41cc34$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $9ab9afd19e41cc34$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $9ab9afd19e41cc34$export$2e2bcd8739ae039 extends (0, $3675866d198c1e14$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$9ab9afd19e41cc34$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $9ab9afd19e41cc34$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($9ab9afd19e41cc34$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(){
        super('next');
    }
}






var $8fj6C = parcelRequire("8fj6C");



const $97be91882b7b64cf$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $97be91882b7b64cf$var$MAX_OBSERVATIONS = 200;
const $97be91882b7b64cf$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $97be91882b7b64cf$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $97be91882b7b64cf$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $97be91882b7b64cf$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($97be91882b7b64cf$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $8fj6C.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)(),
                h: (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $97be91882b7b64cf$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $97be91882b7b64cf$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $97be91882b7b64cf$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$97be91882b7b64cf$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $97be91882b7b64cf$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $97be91882b7b64cf$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$97be91882b7b64cf$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$97be91882b7b64cf$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $jtTx3.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)(),
                h: (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}






var $6AKGx = parcelRequire("6AKGx");



var $issAY = parcelRequire("issAY");

/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $57b75ac51207ba13$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $57b75ac51207ba13$export$846396c2d8be3710 = 'data-drop-target-for-';
function $57b75ac51207ba13$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($57b75ac51207ba13$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($57b75ac51207ba13$export$846396c2d8be3710)) return true;
    return false;
}



var $jlWJa = parcelRequire("jlWJa");

function $a61b8eeec0a6b50e$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}


function $15ca0fedf0c821c2$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $15ca0fedf0c821c2$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $a61b8eeec0a6b50e$export$80d6b07c2266a1c6)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$15ca0fedf0c821c2$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}



function $7a891d751cd40ebc$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $63eb120dff9b319d$export$9db1624a8af791a4)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $7a891d751cd40ebc$export$2e2bcd8739ae039 = $7a891d751cd40ebc$var$createMutationObserver;


// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $b3c77a0f3be26195$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $b3c77a0f3be26195$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $b3c77a0f3be26195$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $b3c77a0f3be26195$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b3c77a0f3be26195$export$2e2bcd8739ae039 = $b3c77a0f3be26195$var$createPerformanceObserver;






var $3QDLx = parcelRequire("3QDLx");

// Helper function to extract component name from fiber
function $855139608d0bb192$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}


function $46767eadd3b516c8$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $855139608d0bb192$export$2e2bcd8739ae039)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $46767eadd3b516c8$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}


// Helper function to find React fiber on an element
function $77cc5ba98a7b23b4$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}


function $f5618fa6f98ca13c$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache?.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $77cc5ba98a7b23b4$export$2e2bcd8739ae039)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}


const $1947801f3cd27aea$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $1947801f3cd27aea$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $1947801f3cd27aea$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $1947801f3cd27aea$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let $1947801f3cd27aea$var$callCount = 0;
const $1947801f3cd27aea$var$CLEANUP_THRESHOLD = 50;
function $1947801f3cd27aea$var$maybeCleanup(resultCache) {
    $1947801f3cd27aea$var$callCount++;
    if ($1947801f3cd27aea$var$callCount >= $1947801f3cd27aea$var$CLEANUP_THRESHOLD && (0, $3QDLx.default)(0.3)) $1947801f3cd27aea$export$6a35c3789c327630(resultCache);
}
function $1947801f3cd27aea$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $1947801f3cd27aea$var$callCount = 0;
    return resultCache;
}
function $1947801f3cd27aea$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $1947801f3cd27aea$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $iDrrr.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $1947801f3cd27aea$var$NEW_DOM_WALK_MAX_LEVEL : $1947801f3cd27aea$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $1947801f3cd27aea$var$NEW_FIBER_WALK_MAX_LEVEL : $1947801f3cd27aea$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $f5618fa6f98ca13c$export$2e2bcd8739ae039)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $46767eadd3b516c8$export$2e2bcd8739ae039)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}



var $1hQ0e = parcelRequire("1hQ0e");

function $12c0b1ad954b8646$export$16c2770458939f21(node) {
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}


function $f3e5cf7223842155$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}


/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $f9580ead7489bae0$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $f9580ead7489bae0$export$2e2bcd8739ae039(element.parentElement);
}


// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $d6afa148253dc55e$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}


const $407f5ab39212816a$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $407f5ab39212816a$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $407f5ab39212816a$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $407f5ab39212816a$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $407f5ab39212816a$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $407f5ab39212816a$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $8b4468c2b75de6aa$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $8b4468c2b75de6aa$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $8b4468c2b75de6aa$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $8b4468c2b75de6aa$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $bd995df68a93b48e$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $f9580ead7489bae0$export$2e2bcd8739ae039)(target)) return 'mutation:remount';
        if ((0, $6AKGx.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinGenAISegment) return 'mutation:gen-ai-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $f9580ead7489bae0$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $jlWJa.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $407f5ab39212816a$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $bd995df68a93b48e$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $f9580ead7489bae0$export$2e2bcd8739ae039)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $6AKGx.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinGenAISegment) return {
            type: 'mutation:gen-ai-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $f9580ead7489bae0$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $jlWJa.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $407f5ab39212816a$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $bd995df68a93b48e$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $15ca0fedf0c821c2$export$c3799d33e0ae80a5)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $7a891d751cd40ebc$export$2e2bcd8739ae039)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $b3c77a0f3be26195$export$2e2bcd8739ae039)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $1947801f3cd27aea$export$6a35c3789c327630)(this.mapIs3pResult);
    }
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.mapIs3pResult = void 0;
        this.mapIsGenAIResult = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        this.trackLayoutShiftOffenders = void 0;
        this.searchPageConfig = void 0;
        // SSR context functions
        this.getSSRState = void 0;
        this.getSSRPlaceholderHandler = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $f3e5cf7223842155$export$e989c0fffaa6b27a)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $1947801f3cd27aea$export$2e2bcd8739ae039)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $1947801f3cd27aea$export$2e2bcd8739ae039)(addedNode, 'UFOGenAISegment', this.mapIsGenAIResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $12c0b1ad954b8646$export$16c2770458939f21)(addedNode));
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $bd995df68a93b48e$var$createElementMutationsWatcherNew : $bd995df68a93b48e$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinGenAISegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $6AKGx.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $1947801f3cd27aea$export$2e2bcd8739ae039)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                const { isWithin: isWithinGenAISegment } = (0, $1947801f3cd27aea$export$2e2bcd8739ae039)(target, 'UFOGenAISegment', this.mapIsGenAIResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (isWithinGenAISegment) return {
                    type: 'mutation:gen-ai-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $12c0b1ad954b8646$export$16c2770458939f21)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $e2bdd704106494fd$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $issAY.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $57b75ac51207ba13$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $iDrrr.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $d6afa148253dc55e$export$80a5724ceedcfd3d)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $jlWJa.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $8b4468c2b75de6aa$export$597b41700f7dcd36)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $407f5ab39212816a$export$fde63bc968551821)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            return this.searchPageConfig?.enableSmartAnswersMutations && this.searchPageConfig?.searchPageRoute && window?.location?.pathname && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.mapIsGenAIResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
}



var $cbY7C = parcelRequire("cbY7C");

class $113b719dd374c0a8$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $cbY7C.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $cbY7C.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}


const $02a36cada4009f81$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $02a36cada4009f81$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
function $02a36cada4009f81$export$88af4849fcc5bbc9() {
    return false;
}
class $02a36cada4009f81$export$2e2bcd8739ae039 {
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $02a36cada4009f81$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        this.entriesTimeline.clear();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $02a36cada4009f81$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)(),
                    width: (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $38d1af56f0ecb9c0$export$2e2bcd8739ae039)(),
                    right: (0, $eff1c09acb177ea8$export$2e2bcd8739ae039)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $5960a97d09f6b2fb$export$2e2bcd8739ae039)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $jtTx3.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $3675866d198c1e14$export$2e2bcd8739ae039)();
        const calculator_next = new (0, $9ab9afd19e41cc34$export$2e2bcd8739ae039)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $jtTx3.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $jtTx3.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data so the server can recalculate metrics
        // (ssrRatio, labelStacks, speedIndex) from raw observations.
        const rawVCCalculationStartTime = performance.now();
        const rawHandler = new (0, $97be91882b7b64cf$export$2e2bcd8739ae039)();
        // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
        const rawStopTime = rawDataStopTime ?? stop;
        const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: rawStopTime
        }) : orderedEntries;
        const raw = await rawHandler.getRawData({
            entries: rawOrderedEntries,
            startTime: start,
            stopTime: rawStopTime,
            isPageVisible: isPageVisible
        });
        results.forEach((result)=>{
            delete result.vcDetails;
            delete result.ratios;
        });
        if (raw) {
            raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
            raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
            results.push(raw);
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $87b2725b3831be0e$export$2e2bcd8739ae039)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        this.trackLayoutShiftOffenders = void 0;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $02a36cada4009f81$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $186b21fecc2186fe$export$2e2bcd8739ae039)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $jtTx3.getSelectorConfig)(config.selectorConfig, $02a36cada4009f81$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $02a36cada4009f81$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $pLTIz.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $bd995df68a93b48e$export$2e2bcd8739ae039)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue,
                    originalMutationTimestamp: mutationData?.timestamp
                };
                if (element) {
                    const labelStacks = $02a36cada4009f81$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $113b719dd374c0a8$export$2e2bcd8739ae039)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $iDrrr.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $a33Aa.getActiveInteraction)();
                    if (interaction?.type === 'press') return;
                }
                const abortEventTargetElement = $02a36cada4009f81$var$isAbortEventTargetSupported(type) && event ? $02a36cada4009f81$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
}
function $02a36cada4009f81$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $02a36cada4009f81$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $7Hxln.sanitizeLabelStackName)(label.name)).join('/');
}
function $02a36cada4009f81$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $7Hxln.sanitizeLabelStackName)(label.name)).join('/');
}
function $02a36cada4009f81$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $02a36cada4009f81$var$labelStackFromFiber(currentFiber);
                labelStackString = $02a36cada4009f81$var$labelStackToString(labelStack) || 'unknown';
                segment = $02a36cada4009f81$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $02a36cada4009f81$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $02a36cada4009f81$var$traverseFiber(fiber) : null;
}
const $02a36cada4009f81$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $02a36cada4009f81$var$isAbortEventTargetSupported(type) {
    return $02a36cada4009f81$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $02a36cada4009f81$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}
module.exports["getHasAbortingEventDuringSSR"] = $02a36cada4009f81$export$88af4849fcc5bbc9;
module.exports["default"] = $02a36cada4009f81$export$2e2bcd8739ae039;

});

parcelRegister("bC8sq", function(module, exports) {
// The UFORouteName object is a global singleton
const $2af85e82f1c2dc61$var$UFORouteName = {
    current: null
};
var $2af85e82f1c2dc61$export$2e2bcd8739ae039 = $2af85e82f1c2dc61$var$UFORouteName;
module.exports["default"] = $2af85e82f1c2dc61$export$2e2bcd8739ae039;

});

parcelRegister("ah4BL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $dHBqk = parcelRequire("dHBqk");


var $l8ayF = parcelRequire("l8ayF");


var $hk5Lv = parcelRequire("hk5Lv");

const $441723abf4861178$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const $441723abf4861178$var$ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
const $441723abf4861178$var$ASSET_RESOURCE_TYPES = new Set([
    'script',
    'link',
    'css'
]);
const $441723abf4861178$var$OTHER_JS_RESOURCE_TYPE = 'other';
const $441723abf4861178$var$SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs',
    '.cjs'
];
const $441723abf4861178$var$STYLESHEET_EXTENSIONS = [
    '.css'
];
const $441723abf4861178$var$ASSET_EXTENSIONS = [
    ...$441723abf4861178$var$SCRIPT_EXTENSIONS,
    ...$441723abf4861178$var$STYLESHEET_EXTENSIONS
];
const $441723abf4861178$var$FILE_OR_MEDIA_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.csv',
    '.zip',
    '.heic',
    '.mov',
    '.mp4',
    '.mp3',
    '.wav',
    '.woff',
    '.woff2',
    '.ttf',
    '.otf'
];
const $441723abf4861178$var$IMAGE_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.ico'
];
const $441723abf4861178$var$IMAGE_RESOURCE_LABEL = '<image-resource>';
const $441723abf4861178$var$FILE_RESOURCE_LABEL = '<file-resource>';
const $441723abf4861178$var$AVATAR_RESOURCE_LABEL = '<avatar-resource>';
const $441723abf4861178$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS = [
    /(?:^|\/)secure\/attachment(?:\/|$)/,
    /(?:^|\/)download\/attachments(?:\/|$)/,
    /(?:^|\/)wiki\/download(?:\/|$)/,
    /(?:^|\/)child\/attachment(?:\/|$)/,
    /(?:^|\/)attachment(?:\/|$)/
];
function $441723abf4861178$var$stripQueryAndHash(value) {
    return value.split(/[?#]/, 1)[0] ?? '';
}
function $441723abf4861178$var$getSanitizedLastPathSegment(value) {
    const trimmedValue = $441723abf4861178$var$stripQueryAndHash(value).replace(/\/+$/, '');
    if (!trimmedValue.includes('/')) return trimmedValue;
    return trimmedValue.split('/').filter(Boolean).pop() ?? trimmedValue;
}
function $441723abf4861178$var$hasExtension(value, extensions) {
    const path = $441723abf4861178$var$stripQueryAndHash(value).toLowerCase();
    return extensions.some((extension)=>path.endsWith(extension));
}
function $441723abf4861178$var$hasAttachmentOrDownloadPath(value) {
    return $441723abf4861178$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS.some((pattern)=>pattern.test(value));
}
function $441723abf4861178$var$isAvatarResource(value) {
    return value.includes('avatar-management') || value.includes('/initials/') || value.includes('%2finitials%2f') || value.includes('viewavatar');
}
function $441723abf4861178$var$getSanitizedBackendResourceLabel(rawName) {
    const querylessName = $441723abf4861178$var$stripQueryAndHash(rawName);
    const normalizedRawName = rawName.toLowerCase();
    const normalizedQuerylessName = querylessName.toLowerCase();
    if ($441723abf4861178$var$isAvatarResource(normalizedRawName)) return $441723abf4861178$var$AVATAR_RESOURCE_LABEL;
    if ($441723abf4861178$var$hasExtension(normalizedQuerylessName, $441723abf4861178$var$IMAGE_EXTENSIONS)) return $441723abf4861178$var$IMAGE_RESOURCE_LABEL;
    if ($441723abf4861178$var$hasAttachmentOrDownloadPath(normalizedQuerylessName) || $441723abf4861178$var$hasExtension(normalizedQuerylessName, $441723abf4861178$var$FILE_OR_MEDIA_EXTENSIONS)) return $441723abf4861178$var$FILE_RESOURCE_LABEL;
    return querylessName;
}
function $441723abf4861178$var$isBackendResourceTiming(initiatorType) {
    return (0, $l8ayF.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(initiatorType);
}
function $441723abf4861178$var$isScriptOrStylesheetResource(rawName, initiatorType) {
    if (initiatorType === $441723abf4861178$var$OTHER_JS_RESOURCE_TYPE) return $441723abf4861178$var$hasExtension(rawName, $441723abf4861178$var$ASSET_EXTENSIONS);
    if (!$441723abf4861178$var$ASSET_RESOURCE_TYPES.has(initiatorType)) return false;
    return $441723abf4861178$var$hasExtension(rawName, $441723abf4861178$var$ASSET_EXTENSIONS);
}
function $441723abf4861178$export$545c2c69328f5019(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const label = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    return {
        label: label,
        // From Resource Timing spec
        redirectStart: $441723abf4861178$var$num(timing.redirectStart),
        redirectEnd: $441723abf4861178$var$num(timing.redirectEnd),
        fetchStart: $441723abf4861178$var$num(timing.fetchStart),
        domainLookupStart: $441723abf4861178$var$num(timing.domainLookupStart),
        domainLookupEnd: $441723abf4861178$var$num(timing.domainLookupEnd),
        connectStart: $441723abf4861178$var$num(timing.connectStart),
        connectEnd: $441723abf4861178$var$num(timing.connectEnd),
        secureConnectionStart: $441723abf4861178$var$num(timing.secureConnectionStart),
        requestStart: $441723abf4861178$var$num(timing.requestStart),
        responseStart: $441723abf4861178$var$num(timing.responseStart),
        responseEnd: $441723abf4861178$var$num(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: $441723abf4861178$var$num(timing.encodedBodySize),
        decodedBodySize: $441723abf4861178$var$num(timing.decodedBodySize),
        transferSize: $441723abf4861178$var$num(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: $441723abf4861178$var$num(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: $441723abf4861178$var$num(timing.unloadEventStart),
        unloadEventEnd: $441723abf4861178$var$num(timing.unloadEventEnd),
        workerStart: $441723abf4861178$var$num(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}
function $441723abf4861178$export$58bcddf582fad063(data) {
    const payload = data?.payload || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = payload?.timing || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const isBackendTiming = $441723abf4861178$var$isBackendResourceTiming(initiatorType);
    if (!isBackendTiming && !$441723abf4861178$var$isScriptOrStylesheetResource(rawName, initiatorType)) return undefined;
    const name = isBackendTiming ? $441723abf4861178$var$getSanitizedBackendResourceLabel(rawName) : $441723abf4861178$var$getSanitizedLastPathSegment(rawName);
    const startTime = $441723abf4861178$var$num(payload.startTime);
    const duration = $441723abf4861178$var$num(payload.duration);
    const fetchStart = $441723abf4861178$var$num(timing.fetchStart);
    const workerStart = $441723abf4861178$var$num(timing.workerStart);
    const responseStart = $441723abf4861178$var$num(timing.responseStart);
    const requestStart = $441723abf4861178$var$num(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = $441723abf4861178$var$ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = {
        label: name,
        startTime: startTime,
        duration: duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType,
        ...source !== undefined ? {
            source: source
        } : {}
    };
    const cacheable = (0, $hk5Lv.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, $hk5Lv.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}



var $65DSU = parcelRequire("65DSU");

/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ const $fc9b726808a7f98d$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
function $fc9b726808a7f98d$var$extractPayload(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}
function $fc9b726808a7f98d$export$eb873803b57f13dd(data) {
    const payload = $fc9b726808a7f98d$var$extractPayload(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: $fc9b726808a7f98d$var$num(payload.startTime)
    };
}
function $fc9b726808a7f98d$export$249cfe420379ce6a(data) {
    const payload = $fc9b726808a7f98d$var$extractPayload(data);
    return {
        startTime: $fc9b726808a7f98d$var$num(payload.startTime),
        size: $fc9b726808a7f98d$var$num(payload.size)
    };
}
function $fc9b726808a7f98d$export$13eca0f9ce301e95(data) {
    const payload = $fc9b726808a7f98d$var$extractPayload(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: $fc9b726808a7f98d$var$num(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources: sources
    };
}
function $fc9b726808a7f98d$export$e8c5a8531f7dfa04(data) {
    const payload = $fc9b726808a7f98d$var$extractPayload(data);
    return payload.isFinalBatch === true;
}
function $fc9b726808a7f98d$export$6954fd19623912a2(data) {
    const payload = $fc9b726808a7f98d$var$extractPayload(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: $fc9b726808a7f98d$var$num(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}


const $2026e48d2989e8f0$var$FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const $2026e48d2989e8f0$var$FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const $2026e48d2989e8f0$var$GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const $2026e48d2989e8f0$var$ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const $2026e48d2989e8f0$var$MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const $2026e48d2989e8f0$var$ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const $2026e48d2989e8f0$var$IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const $2026e48d2989e8f0$var$NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function $2026e48d2989e8f0$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $cozmU.useContext)((0, $8BQV6.default));
    const labelStack = context?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function $2026e48d2989e8f0$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener, appType: appType }) {
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const segmentIdRef = (0, $cozmU.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, $cozmU.useRef)(0);
    const resizedCounterSegmentIdRef = (0, $cozmU.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, $cozmU.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, $cozmU.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, $a33Aa.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs: abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort($2026e48d2989e8f0$var$ABORT_TIMEOUT_INITIAL_MS);
        }, $2026e48d2989e8f0$var$ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext?.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, $a33Aa.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, $2026e48d2989e8f0$var$GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height: height, elapsed: elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < $2026e48d2989e8f0$var$MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, $a33Aa.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height: height,
                            elapsed: elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith($2026e48d2989e8f0$var$FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = $2026e48d2989e8f0$var$IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, $441723abf4861178$export$58bcddf582fad063)(restData);
                else if (suffix === 'navigation-timing') data = (0, $441723abf4861178$export$545c2c69328f5019)(restData);
                else if (suffix === 'paint-timing') data = (0, $fc9b726808a7f98d$export$eb873803b57f13dd)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, $fc9b726808a7f98d$export$249cfe420379ce6a)(restData);
                else if (suffix === 'layout-shift') data = (0, $fc9b726808a7f98d$export$13eca0f9ce301e95)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, $fc9b726808a7f98d$export$e8c5a8531f7dfa04)(restData)) return;
                    data = (0, $fc9b726808a7f98d$export$6954fd19623912a2)(restData);
                } else data = restData;
                if (data !== undefined) (0, $a33Aa.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data: data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === $2026e48d2989e8f0$var$FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max($2026e48d2989e8f0$var$ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort($2026e48d2989e8f0$var$ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && $2026e48d2989e8f0$var$NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, $a33Aa.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid_0 = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid_0 && sid && profilerAccRef.current !== null) {
                (0, $a33Aa.addIframeSegmentData)(iid_0, sid, {
                    label: 'react-profiler-timing',
                    data: {
                        ...profilerAccRef.current
                    }
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHBqk.default), {
        name: "forge-ui-requests",
        hold: navigationHold === 'holding'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2026e48d2989e8f0$var$IframeSegmentIdReader, {
        segmentIdRef: segmentIdRef
    }));
}
/** Writes per-segment extraData via addSegmentExtraData. */ const $2026e48d2989e8f0$var$SegmentExtraDataWriter = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SegmentExtraDataWriter(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { extraData: extraData } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    let t1;
    if ($[0] !== extraData || $[1] !== interactionId.current || $[2] !== segmentId) {
        t1 = ()=>{
            const currentInteractionId = interactionId.current;
            if (segmentId && currentInteractionId) (0, $a33Aa.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
        };
        $[0] = extraData;
        $[1] = interactionId.current;
        $[2] = segmentId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== extraData || $[5] !== interactionId || $[6] !== segmentId) {
        t2 = [
            extraData,
            segmentId,
            interactionId
        ];
        $[4] = extraData;
        $[5] = interactionId;
        $[6] = segmentId;
        $[7] = t2;
    } else t2 = $[7];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : function SegmentExtraDataWriter({ extraData: extraData }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const labelStack = interactionContext?.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $cozmU.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $a33Aa.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
};
const $2026e48d2989e8f0$export$5f6fe75c46d0124e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let children;
    let extraData;
    let onRegisterIframeEventListener;
    let otherProps;
    if ($[0] !== props) {
        ({ children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = extraData;
        $[3] = onRegisterIframeEventListener;
        $[4] = otherProps;
    } else {
        children = $[1];
        extraData = $[2];
        onRegisterIframeEventListener = $[3];
        otherProps = $[4];
    }
    let t0;
    if ($[5] !== extraData || $[6] !== onRegisterIframeEventListener) {
        t0 = onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2026e48d2989e8f0$var$IframeSegment, {
            onRegisterIframeEventListener: onRegisterIframeEventListener,
            appType: extraData.appType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2026e48d2989e8f0$var$SegmentExtraDataWriter, {
            extraData: extraData
        }));
        $[5] = extraData;
        $[6] = onRegisterIframeEventListener;
        $[7] = t0;
    } else t0 = $[7];
    let t1;
    if ($[8] !== children || $[9] !== otherProps || $[10] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            type: "third-party",
            ...otherProps
        }, t0, children);
        $[8] = children;
        $[9] = otherProps;
        $[10] = t0;
        $[11] = t1;
    } else t1 = $[11];
    return t1;
} : (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        type: "third-party",
        ...otherProps
    }, onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2026e48d2989e8f0$var$IframeSegment, {
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        appType: extraData.appType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2026e48d2989e8f0$var$SegmentExtraDataWriter, {
        extraData: extraData
    })), children);
};
$2026e48d2989e8f0$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';
module.exports["UFOThirdPartySegment"] = $2026e48d2989e8f0$export$5f6fe75c46d0124e;

});

parcelRegister("hk5Lv", function(module, exports) {
const $e2d6313deb496ac2$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $e2d6313deb496ac2$var$CACHE_NETWORK = 'network';
const $e2d6313deb496ac2$var$CACHE_MEMORY = 'memory';
const $e2d6313deb496ac2$var$CACHE_DISK = 'disk';
function $e2d6313deb496ac2$export$86a03f39f85a653c(url, type) {
    if ($e2d6313deb496ac2$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
function $e2d6313deb496ac2$export$82deef6698791e4e(name, type, duration, size) {
    if (!$e2d6313deb496ac2$export$86a03f39f85a653c(name, type)) return $e2d6313deb496ac2$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $e2d6313deb496ac2$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $e2d6313deb496ac2$var$CACHE_DISK;
    if (size === undefined) return null;
    return $e2d6313deb496ac2$var$CACHE_NETWORK;
}
module.exports["isCacheableType"] = $e2d6313deb496ac2$export$86a03f39f85a653c;
module.exports["calculateTransferType"] = $e2d6313deb496ac2$export$82deef6698791e4e;

});

parcelRegister("lnE0c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");

const $f426b040eda4b71e$export$208d0ee3b8b8e438 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            type: "gen-ai",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        type: "gen-ai",
        ...props
    });
};
$f426b040eda4b71e$export$208d0ee3b8b8e438.displayName = 'UFOGenAISegment';
module.exports["UFOGenAISegment"] = $f426b040eda4b71e$export$208d0ee3b8b8e438;

});

parcelRegister("9T20v", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $3QDLx = parcelRequire("3QDLx");


var $jtTx3 = parcelRequire("jtTx3");


var $c9IWh = parcelRequire("c9IWh");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $bC8sq = parcelRequire("bC8sq");

const $80f752b988c75ddb$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $80f752b988c75ddb$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $jtTx3.isUFOEnabled)()) return;
    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $bC8sq.default).current = routeName || null;
    const rate = ufoName ? (0, $jtTx3.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $3QDLx.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $kHija.v4)();
        (0, $4QMIF.DefaultInteractionID).current = newId;
        (0, $a33Aa.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $c9IWh.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $a33Aa.addHoldByID)(newId, [], $80f752b988c75ddb$var$AWAITING_PAGELOAD_NAME, $80f752b988c75ddb$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $a33Aa.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $a33Aa.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $a33Aa.removeHoldByID)(activeInteraction.id, $80f752b988c75ddb$var$AWAITING_PAGELOAD_NAME);
    }
}
var $80f752b988c75ddb$export$2e2bcd8739ae039 = $80f752b988c75ddb$var$traceUFOPageLoad;
function $80f752b988c75ddb$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $jtTx3.isUFOEnabled)()) return;
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $jtTx3.getInteractionRate)(ufoName, 'page_load');
        (0, $a33Aa.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $3QDLx.default)(rate)) (0, $bC8sq.default).current = ufoName;
        else (0, $a33Aa.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $a33Aa.removeHoldByID)(interaction.id, $80f752b988c75ddb$var$AWAITING_PAGELOAD_NAME);
}
module.exports["default"] = $80f752b988c75ddb$export$2e2bcd8739ae039;
module.exports["updatePageloadName"] = $80f752b988c75ddb$export$d0f99433cd4f4028;

});

parcelRegister("ldKLB", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

function $189b48e1daddab4c$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0) {
    (0, $a33Aa.addSpanToAll)('custom', name, [
        {
            name: 'custom'
        }
    ], start, end, size);
}
module.exports["addCustomSpans"] = $189b48e1daddab4c$export$5342dcad19138a1c;

});

parcelRegister("b8pma", function(module, exports) {
$parcel$export(module.exports, "default", () => $61354b991e1b6d8a$export$2e2bcd8739ae039);

var $dHBqk = parcelRequire("dHBqk");

var $61354b991e1b6d8a$export$2e2bcd8739ae039 = (0, $dHBqk.default);

});

parcelRegister("eYg5X", function(module, exports) {

var $2j5oi = parcelRequire("2j5oi");

function $ddcf68f1c3549841$var$traceUFOPress(name, timestamp) {
    return (0, $2j5oi.default)(name, 'press', timestamp);
}
var $ddcf68f1c3549841$export$2e2bcd8739ae039 = $ddcf68f1c3549841$var$traceUFOPress;
module.exports["default"] = $ddcf68f1c3549841$export$2e2bcd8739ae039;

});

parcelRegister("2j5oi", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $3QDLx = parcelRequire("3QDLx");


var $jtTx3 = parcelRequire("jtTx3");


var $c9IWh = parcelRequire("c9IWh");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $bC8sq = parcelRequire("bC8sq");

function $0f55281d26d26882$var$traceUFOInteraction(name, interactionType, startTime) {
    if (!(0, $jtTx3.isUFOEnabled)()) return;
    const rate = (0, $jtTx3.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $jtTx3.getDoNotAbortActivePressInteraction)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $jtTx3.getMinorInteractions)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $a33Aa.getActiveInteraction)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $a33Aa.abortAll)('new_interaction', name);
    if ((0, $3QDLx.default)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $kHija.v4)();
        (0, $4QMIF.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $c9IWh.setInteractionActiveTrace)(newId, interactionType);
        (0, $a33Aa.addNewInteraction)(newId, name, interactionType === 'hover' ? 'press' : interactionType, // TODO add dedicated type for hover, might change backend though
        startTimestamp, rate, [], (0, $bC8sq.default).current, (0, $c9IWh.getActiveTrace)());
    }
}
var $0f55281d26d26882$export$2e2bcd8739ae039 = $0f55281d26d26882$var$traceUFOInteraction;
module.exports["default"] = $0f55281d26d26882$export$2e2bcd8739ae039;

});

parcelRegister("6wGOF", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2iGHk = parcelRequire("2iGHk");

var $gTPfK = parcelRequire("gTPfK");

var $lzgC6 = parcelRequire("lzgC6");


var $a7VCe = parcelRequire("a7VCe");

const $1a16a002a1c003e0$var$packageName = "platform-pkg";
const $1a16a002a1c003e0$var$packageVersion = "0.0.0-use.local";
const $1a16a002a1c003e0$var$createAndFireEventOnAtlaskit = (0, $2iGHk.default)('atlaskit');
const $1a16a002a1c003e0$var$Select = (0, $gTPfK.default)({
    componentName: 'select',
    packageName: $1a16a002a1c003e0$var$packageName,
    packageVersion: $1a16a002a1c003e0$var$packageVersion
})((0, $lzgC6.default)({
    onChange: $1a16a002a1c003e0$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $1a16a002a1c003e0$var$packageName,
            packageVersion: $1a16a002a1c003e0$var$packageVersion
        }
    })
})((0, $a7VCe.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$1a16a002a1c003e0$export$2e2bcd8739ae039 = $1a16a002a1c003e0$var$Select;
module.exports["default"] = $1a16a002a1c003e0$export$2e2bcd8739ae039;

});

parcelRegister("a7VCe", function(module, exports) {

var $lPUNq = parcelRequire("lPUNq");


var $6Zv1z = parcelRequire("6Zv1z");

const $c000bae663ac185d$export$d1de3b251ccaa8a3 = (0, $6Zv1z.default)((0, $lPUNq.default));
module.exports["SelectWithoutAnalytics"] = $c000bae663ac185d$export$d1de3b251ccaa8a3;

});

parcelRegister("6Zv1z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e86cee836bcdca$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $b4e86cee836bcdca$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function AtlaskitSelect(props, forwardedRef) {
        const $ = (0, $bDgLe.c)(15);
        let ariaLiveMessages;
        let isInvalid;
        let restProps;
        let t0;
        let t1;
        let t2;
        if ($[0] !== props) {
            ({ ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: t0, tabSelectsValue: t1, validationState: t2, ...restProps } = props);
            $[0] = props;
            $[1] = ariaLiveMessages;
            $[2] = isInvalid;
            $[3] = restProps;
            $[4] = t0;
            $[5] = t1;
            $[6] = t2;
        } else {
            ariaLiveMessages = $[1];
            isInvalid = $[2];
            restProps = $[3];
            t0 = $[4];
            t1 = $[5];
            t2 = $[6];
        }
        const onClickPreventDefault = t0 === undefined ? true : t0;
        const tabSelectsValue = t1 === undefined ? false : t1;
        const validationState = t2 === undefined ? "default" : t2;
        const internalSelectRef = (0, $cozmU.useRef)(null);
        let t3;
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                });
            t4 = [];
            $[7] = t3;
            $[8] = t4;
        } else {
            t3 = $[7];
            t4 = $[8];
        }
        (0, $cozmU.useImperativeHandle)(forwardedRef, t3, t4);
        const t5 = isInvalid || validationState === "error";
        let t6;
        if ($[9] !== ariaLiveMessages || $[10] !== onClickPreventDefault || $[11] !== restProps || $[12] !== t5 || $[13] !== tabSelectsValue) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
                ref: internalSelectRef,
                ariaLiveMessages: ariaLiveMessages,
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: t5,
                ...restProps,
                isAsync: true
            });
            $[9] = ariaLiveMessages;
            $[10] = onClickPreventDefault;
            $[11] = restProps;
            $[12] = t5;
            $[13] = tabSelectsValue;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    } : function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $cozmU.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $cozmU.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});

parcelRegister("3PNw6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");

const $7462f4171347e009$var$UFOCustomData = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOCustomData(t0) {
    const { data: data } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    let t1;
    bb0: {
        if (!interactionContext) {
            t1 = undefined;
            break bb0;
        }
        if (typeof globalThis?.structuredClone === "function") interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
        t1 = undefined;
    }
    return null;
} : function UFOCustomData({ data: data }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    (0, $cozmU.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $7462f4171347e009$export$2e2bcd8739ae039 = $7462f4171347e009$var$UFOCustomData;
function $7462f4171347e009$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $4QMIF.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $a33Aa.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $a33Aa.addCustomData)(currentInteractionId, [], data);
}
module.exports["default"] = $7462f4171347e009$export$2e2bcd8739ae039;
module.exports["addUFOCustomData"] = $7462f4171347e009$export$d12f56a472cdbe6c;

});

parcelRegister("arQY7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9DHhW = parcelRequire("9DHhW");


var $6JrSr = parcelRequire("6JrSr");


var $iDrrr = parcelRequire("iDrrr");


var $7zsi1 = parcelRequire("7zsi1");














var $jC4nA = parcelRequire("jC4nA");


var $g9ioO = parcelRequire("g9ioO");


var $2F2yY = parcelRequire("2F2yY");

const $c8d2033fac7e31cd$var$styles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d",
    icon: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0KLXruG6qS",
    circle: "_0bjKvDS5Zs",
    hexagon: "_1uo2ZfTcEg"
};
const $c8d2033fac7e31cd$var$borderRadiusMap = {
    xxsmall: "_0bjKvDcjp5",
    xsmall: "_0bjKvDcjp5",
    UNSAFE_xsmall: "_0bjKvDcjp5",
    small: "_0bjKvDcjp5",
    medium: "_0bjKvDKxmn",
    large: "_0bjKvDKxmn",
    xlarge: "_0bjKvDKTcp",
    xxlarge: "_0bjKvDyzSk"
};
const $c8d2033fac7e31cd$var$nestedSvgStylesMap = {
    xxsmall: "_27VeLCey7F _2Qxi4ney7F",
    xsmall: "_27VeLCey7F _2Qxi4ney7F",
    UNSAFE_xsmall: "_27VeLCSPN1 _2Qxi4nSPN1",
    small: "_27VeLCoWWg _2Qxi4noWWg",
    medium: "_27VeLCUofl _2Qxi4nUofl",
    large: "_27VeLCUF4f _2Qxi4nUF4f",
    xlarge: "_27VeLCJgOI _2Qxi4nJgOI",
    xxlarge: "_27VeLCNNui _2Qxi4nNNui"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $c8d2033fac7e31cd$var$AvatarImage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { alt: t1, src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading } = t0;
    const alt = t1 === undefined ? "" : t1;
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setHasImageErrored(false);
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== src) {
        t3 = [
            src
        ];
        $[1] = src;
        $[2] = t3;
    } else t3 = $[2];
    (0, $cozmU.useEffect)(t2, t3);
    if (!src || hasImageErrored) {
        let renderedIcon;
        bb0: switch(appearance){
            case "circle":
                {
                    const t4 = testId && `${testId}--person`;
                    let t5;
                    if ($[3] !== alt || $[4] !== t4) {
                        t5 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
                            label: alt,
                            color: "var(--ds-icon-subtle, #505258)",
                            testId: t4,
                            spacing: "spacious"
                        });
                        $[3] = alt;
                        $[4] = t4;
                        $[5] = t5;
                    } else t5 = $[5];
                    renderedIcon = t5;
                    break bb0;
                }
            case "hexagon":
                {
                    const t4 = testId && `${testId}--agent`;
                    let t5;
                    if ($[6] !== alt || $[7] !== t4) {
                        t5 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                            label: alt,
                            color: "var(--ds-icon-subtle, #505258)",
                            testId: t4,
                            spacing: "spacious"
                        });
                        $[6] = alt;
                        $[7] = t4;
                        $[8] = t5;
                    } else t5 = $[8];
                    renderedIcon = t5;
                    break bb0;
                }
            default:
            case "square":
                {
                    const t4 = testId && `${testId}--ship`;
                    let t5;
                    if ($[9] !== alt || $[10] !== t4) {
                        t5 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2F2yY))), {
                            label: alt,
                            color: "var(--ds-icon-subtle, #505258)",
                            testId: t4,
                            spacing: "spacious"
                        });
                        $[9] = alt;
                        $[10] = t4;
                        $[11] = t5;
                    } else t5 = $[11];
                    renderedIcon = t5;
                }
        }
        const t4 = $c8d2033fac7e31cd$var$nestedSvgStylesMap[size];
        let t5;
        if ($[12] !== t4) {
            t5 = (0, $hekY6.default)([
                $c8d2033fac7e31cd$var$styles.icon,
                t4
            ]);
            $[12] = t4;
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== renderedIcon || $[15] !== t5) {
            t6 = /*#__PURE__*/ $cozmU.createElement("span", {
                className: t5
            }, renderedIcon);
            $[14] = renderedIcon;
            $[15] = t5;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    const t4 = testId && `${testId}--image`;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setHasImageErrored(true);
        $[17] = t5;
    } else t5 = $[17];
    const t6 = !alt ? true : undefined;
    const t7 = testId ? `${testId}--image` : "avatar-image";
    const t8 = $c8d2033fac7e31cd$var$borderRadiusMap[size];
    const t9 = appearance === "circle" && $c8d2033fac7e31cd$var$styles.circle;
    const t10 = appearance === "hexagon" && $c8d2033fac7e31cd$var$styles.hexagon;
    let t11;
    if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
        t11 = (0, $hekY6.default)([
            $c8d2033fac7e31cd$var$styles.image,
            t8,
            t9,
            t10
        ]);
        $[18] = t10;
        $[19] = t8;
        $[20] = t9;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== alt || $[23] !== imgLoading || $[24] !== src || $[25] !== t11 || $[26] !== t4 || $[27] !== t6 || $[28] !== t7) {
        t12 = /*#__PURE__*/ $cozmU.createElement("img", {
            loading: imgLoading,
            src: src,
            alt: alt,
            "data-testid": t4,
            onError: t5,
            "aria-hidden": t6,
            "data-vc": t7,
            "data-ssr-placeholder-ignored": true,
            className: t11
        });
        $[22] = alt;
        $[23] = imgLoading;
        $[24] = src;
        $[25] = t11;
        $[26] = t4;
        $[27] = t6;
        $[28] = t7;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
} : ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false); // If src changes, reset state
    (0, $cozmU.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2F2yY))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $c8d2033fac7e31cd$var$styles.icon,
                $c8d2033fac7e31cd$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $cozmU.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $hekY6.default)([
            $c8d2033fac7e31cd$var$styles.image,
            $c8d2033fac7e31cd$var$borderRadiusMap[size],
            appearance === 'circle' && $c8d2033fac7e31cd$var$styles.circle,
            appearance === 'hexagon' && $c8d2033fac7e31cd$var$styles.hexagon
        ])
    });
};
var $c8d2033fac7e31cd$export$2e2bcd8739ae039 = $c8d2033fac7e31cd$var$AvatarImage;



var $lnlX7 = parcelRequire("lnlX7");


var $bIrLJ = parcelRequire("bIrLJ");


var $b2VYe = parcelRequire("b2VYe");


































const $fb7f91f21973985a$var$styles = {
    root: "_0bjKvDaaQb _4bt5LAnQyn _2WAcuGnQyn _2V7sgO2M4S _3hxITi6wH8 _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _0GwItXDIqT _0KLXruoI2d"
};
const $fb7f91f21973985a$var$unboundStyles = {
    root: "_3vBAKHoI2d"
}; /**
    * __Icon wrapper__
    *
    * An icon wrapper is used internally only.
    */ 
const $fb7f91f21973985a$var$IconWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { bgColor: bgColor, children: children } = t0;
    let t1;
    if ($[0] !== bgColor) {
        t1 = {
            borderColor: bgColor,
            backgroundColor: bgColor
        };
        $[0] = bgColor;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $fb7f91f21973985a$var$styles.root,
            $fb7f91f21973985a$var$unboundStyles.root
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t1) {
        t3 = /*#__PURE__*/ $cozmU.createElement("span", {
            role: "presentation",
            style: t1,
            className: t2
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ $cozmU.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $hekY6.default)([
            $fb7f91f21973985a$var$styles.root,
            $fb7f91f21973985a$var$unboundStyles.root
        ])
    }, children);
var $fb7f91f21973985a$export$2e2bcd8739ae039 = $fb7f91f21973985a$var$IconWrapper;


const $d5e064e69e94276d$var$BusyIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $d5e064e69e94276d$var$FocusIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $d5e064e69e94276d$var$OfflineIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $d5e064e69e94276d$var$OnlineIndicator = /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $d5e064e69e94276d$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $d5e064e69e94276d$var$BusyIndicator;
        case 'focus':
            return $d5e064e69e94276d$var$FocusIndicator;
        case 'offline':
            return $d5e064e69e94276d$var$OfflineIndicator;
        case 'online':
            return $d5e064e69e94276d$var$OnlineIndicator;
    }
} /**
   * __Avatar presence__
   *
   * A presence shows an avatar’s availability.
   *
   * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
   * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
   * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
   */ 
const $d5e064e69e94276d$var$AvatarPresence = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { borderColor: borderColor, children: children, presence: presence } = t0;
    let t1;
    if ($[0] !== children || $[1] !== presence) {
        t1 = presence ? /*#__PURE__*/ $cozmU.createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $d5e064e69e94276d$var$getPresence(presence)) : children;
        $[0] = children;
        $[1] = presence;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== borderColor || $[4] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $fb7f91f21973985a$export$2e2bcd8739ae039), {
            bgColor: borderColor
        }, t1);
        $[3] = borderColor;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ $cozmU.createElement((0, $fb7f91f21973985a$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $cozmU.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $d5e064e69e94276d$var$getPresence(presence)) : children);
var $d5e064e69e94276d$export$2e2bcd8739ae039 = $d5e064e69e94276d$var$AvatarPresence;


const $4b3aea981a37cca5$var$styles = {
    root: "_1mT5xdWVPG _1pp6NdYbGa"
};
const $4b3aea981a37cca5$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $4b3aea981a37cca5$var$circleIconOffsetMap = {
    small: "_0Bm75GdnbC _4ApkO2dnbC",
    medium: "_0Bm75GdnbC _4ApkO2dnbC",
    large: "_0Bm75GHZdu _4ApkO2HZdu",
    xlarge: "_0Bm75GXJux _4ApkO2XJux"
};
const $4b3aea981a37cca5$var$squareIconOffsetMap = {
    root: "_0Bm75GVo9d _4ApkO2Vo9d"
};
const $4b3aea981a37cca5$var$hexagonIconOffsetMap = {
    small: "_0Bm75GA17z _4ApkO2A17z",
    medium: "_0Bm75GA17z _4ApkO2A17z",
    large: "_0Bm75GUNDJ _4ApkO2Vo9d",
    xlarge: "_0Bm75GvFgp _4ApkO28e2l"
}; /**
    * __Presence wrapper__
    *
    * A presence wrapper is used internally to position presence ontop of the avatar.
    */ 
const $4b3aea981a37cca5$var$PresenceWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId } = t0;
    const t1 = testId && `${testId}--presence`;
    const t2 = $4b3aea981a37cca5$var$iconSizeMap[size];
    const t3 = $4b3aea981a37cca5$var$circleIconOffsetMap[size];
    const t4 = appearance === "square" && $4b3aea981a37cca5$var$squareIconOffsetMap.root;
    const t5 = appearance === "hexagon" && $4b3aea981a37cca5$var$hexagonIconOffsetMap[size];
    let t6;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
        t6 = (0, $hekY6.default)([
            $4b3aea981a37cca5$var$styles.root,
            t2,
            t3,
            t4,
            t5
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = !children ? presence : undefined;
    let t8;
    if ($[5] !== borderColor || $[6] !== children || $[7] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $d5e064e69e94276d$export$2e2bcd8739ae039), {
            borderColor: borderColor,
            presence: t7
        }, children);
        $[5] = borderColor;
        $[6] = children;
        $[7] = t7;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t1 || $[10] !== t6 || $[11] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": "true",
            "data-testid": t1,
            className: t6
        }, t8);
        $[9] = t1;
        $[10] = t6;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    return t9;
} : ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $hekY6.default)([
            $4b3aea981a37cca5$var$styles.root,
            $4b3aea981a37cca5$var$iconSizeMap[size],
            $4b3aea981a37cca5$var$circleIconOffsetMap[size],
            appearance === 'square' && $4b3aea981a37cca5$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $4b3aea981a37cca5$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $d5e064e69e94276d$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $4b3aea981a37cca5$export$2e2bcd8739ae039 = $4b3aea981a37cca5$var$PresenceWrapper;
























const $1d525e804b4347f3$var$ApprovedIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $1d525e804b4347f3$var$DeclinedIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $1d525e804b4347f3$var$LockedIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
const $1d525e804b4347f3$var$WarningIndicator = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $1d525e804b4347f3$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $1d525e804b4347f3$var$ApprovedIndicator;
        case 'declined':
            return $1d525e804b4347f3$var$DeclinedIndicator;
        case 'locked':
            return $1d525e804b4347f3$var$LockedIndicator;
        case 'warning':
            return $1d525e804b4347f3$var$WarningIndicator;
    }
} /**
   * __Avatar status__
   *
   * An avatar status shows contextual information, such as if someone approves or declines something.
   *
   * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
   * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
   */ 
const $1d525e804b4347f3$var$AvatarStatus = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { borderColor: borderColor, children: children, status: status } = t0;
    let t1;
    if ($[0] !== children || $[1] !== status) {
        t1 = status ? /*#__PURE__*/ $cozmU.createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $1d525e804b4347f3$var$getStatus(status)) : children;
        $[0] = children;
        $[1] = status;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== borderColor || $[4] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $fb7f91f21973985a$export$2e2bcd8739ae039), {
            bgColor: borderColor
        }, t1);
        $[3] = borderColor;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ $cozmU.createElement((0, $fb7f91f21973985a$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $cozmU.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1d525e804b4347f3$var$getStatus(status)) : children);
var $1d525e804b4347f3$export$2e2bcd8739ae039 = $1d525e804b4347f3$var$AvatarStatus;


const $c0d82b4aac8b13ee$var$styles = {
    root: "_1mT5xdWVPG"
};
const $c0d82b4aac8b13ee$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $c0d82b4aac8b13ee$var$circleIconOffsetMap = {
    small: "_1OKFqYdnbC _2I62gzdnbC",
    medium: "_1OKFqYdnbC _2I62gzdnbC",
    large: "_1OKFqYHZdu _2I62gzHZdu",
    xlarge: "_1OKFqYXJux _2I62gzXJux"
};
const $c0d82b4aac8b13ee$var$squareIconOffsetMap = {
    root: "_1OKFqYdnbC _2I62gzdnbC"
};
const $c0d82b4aac8b13ee$var$hexagonIconOffsetMap = {
    small: "_1OKFqYA17z _2I62gzA17z",
    medium: "_1OKFqYA17z _2I62gzA17z",
    large: "_1OKFqYVo9d _2I62gzUNDJ",
    xlarge: "_1OKFqY8e2l _2I62gzvFgp"
};
const $c0d82b4aac8b13ee$var$StatusWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--status`;
    const t2 = $c0d82b4aac8b13ee$var$iconSizeMap[size];
    const t3 = $c0d82b4aac8b13ee$var$circleIconOffsetMap[size];
    const t4 = appearance === "square" && $c0d82b4aac8b13ee$var$squareIconOffsetMap.root;
    const t5 = appearance === "hexagon" && $c0d82b4aac8b13ee$var$hexagonIconOffsetMap[size];
    let t6;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
        t6 = (0, $hekY6.default)([
            $c0d82b4aac8b13ee$var$styles.root,
            t2,
            t3,
            t4,
            t5
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = !children ? status : undefined;
    let t8;
    if ($[5] !== borderColor || $[6] !== children || $[7] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $1d525e804b4347f3$export$2e2bcd8739ae039), {
            borderColor: borderColor,
            status: t7
        }, children);
        $[5] = borderColor;
        $[6] = children;
        $[7] = t7;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t1 || $[10] !== t6 || $[11] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": "true",
            "data-testid": t1,
            className: t6
        }, t8);
        $[9] = t1;
        $[10] = t6;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    return t9;
} : ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $hekY6.default)([
            $c0d82b4aac8b13ee$var$styles.root,
            $c0d82b4aac8b13ee$var$iconSizeMap[size],
            $c0d82b4aac8b13ee$var$circleIconOffsetMap[size],
            appearance === 'square' && $c0d82b4aac8b13ee$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $c0d82b4aac8b13ee$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1d525e804b4347f3$export$2e2bcd8739ae039), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $c0d82b4aac8b13ee$export$2e2bcd8739ae039 = $c0d82b4aac8b13ee$var$StatusWrapper;









var $3v3yD = parcelRequire("3v3yD");

const $64b6dc2b8b4ea041$export$b50b87a1c4086b23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $3v3yD.AvatarContext));
} : ()=>(0, $cozmU.useContext)((0, $3v3yD.AvatarContext));


const $114e8a3ad5f7d032$var$packageName = "platform-pkg";
const $114e8a3ad5f7d032$var$packageVersion = "0.0.0-use.local";
const $114e8a3ad5f7d032$var$containerStyles = null;
const $114e8a3ad5f7d032$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $iDrrr.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $114e8a3ad5f7d032$var$Avatar = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(80);
    const { analyticsContext: analyticsContext, appearance: t1, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: t2, imgLoading: imgLoading, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t0;
    const appearance = t1 === undefined ? "circle" : t1;
    const AvatarContainer = t2 === undefined ? "div" : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const context = (0, $64b6dc2b8b4ea041$export$b50b87a1c4086b23)();
    const t3 = sizeProp || context?.size || "medium";
    let t4;
    if ($[0] !== t3) {
        t4 = $114e8a3ad5f7d032$var$normalizeAvatarSize(t3);
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const size = t4;
    const customPresenceNode = /*#__PURE__*/ (0, $cozmU.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $cozmU.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== "xxlarge" && size !== "xxsmall" && size !== "xsmall";
    const indicatorSize = !isValidIconSize ? "small" : size === "UNSAFE_xsmall" ? "small" : size;
    const lastAnalytics = (0, $cozmU.useRef)(analyticsContext);
    const labelId = (0, $6JrSr.useId)();
    let t5;
    let t6;
    if ($[2] !== analyticsContext) {
        t5 = ()=>{
            lastAnalytics.current = analyticsContext;
        };
        t6 = [
            analyticsContext
        ];
        $[2] = analyticsContext;
        $[3] = t5;
        $[4] = t6;
    } else {
        t5 = $[3];
        t6 = $[4];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[5] !== createAnalyticsEvent || $[6] !== isDisabled || $[7] !== onClick) {
        t7 = (event)=>{
            if (isDisabled || typeof onClick !== "function") return;
            const analyticsEvent = createAnalyticsEvent({
                action: "clicked",
                actionSubject: "avatar",
                attributes: {
                    componentName: "avatar",
                    packageName: $114e8a3ad5f7d032$var$packageName,
                    packageVersion: $114e8a3ad5f7d032$var$packageVersion
                }
            });
            const context_0 = {
                componentName: "avatar",
                packageName: $114e8a3ad5f7d032$var$packageName,
                packageVersion: $114e8a3ad5f7d032$var$packageVersion,
                ...lastAnalytics.current
            };
            analyticsEvent.context.push(context_0);
            const clone = analyticsEvent.clone();
            if (clone) clone.fire("atlaskit");
            onClick(event, analyticsEvent);
        };
        $[5] = createAnalyticsEvent;
        $[6] = isDisabled;
        $[7] = onClick;
        $[8] = t7;
    } else t7 = $[8];
    const onClickHandler = t7;
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    const t8 = isStatus && !customStatusNode && `(${status})`;
    const t9 = isPresence && !customPresenceNode && `(${presence})`;
    let t10;
    if ($[9] !== name || $[10] !== t8 || $[11] !== t9) {
        t10 = [
            name,
            t8,
            t9
        ].filter(Boolean);
        $[9] = name;
        $[10] = t8;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    const defaultLabel = t10.join(" ");
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    const t11 = containerShouldBeImage ? "img" : undefined;
    const t12 = containerShouldBeImage ? labelId : undefined;
    let t13;
    if ($[13] !== stackIndex) {
        t13 = {
            zIndex: stackIndex
        };
        $[13] = stackIndex;
        $[14] = t13;
    } else t13 = $[14];
    let t14;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _3iDTPbvbI6 _1mT5xdRAKS"
        ]);
        $[15] = t14;
    } else t14 = $[15];
    let t15;
    if ($[16] !== ariaHasPopup || $[17] !== href || $[18] !== isDisabled || $[19] !== onClick) {
        t15 = (0, $b2VYe.default)(isDisabled, href, onClick, ariaHasPopup);
        $[16] = ariaHasPopup;
        $[17] = href;
        $[18] = isDisabled;
        $[19] = onClick;
        $[20] = t15;
    } else t15 = $[20];
    const t16 = label || defaultLabel;
    const t17 = isInteractive ? onClickHandler : undefined;
    const t18 = testId ? `${testId}--inner` : undefined;
    const t19 = !containerShouldBeImage && src ? name : undefined;
    let t20;
    if ($[21] !== appearance || $[22] !== imgLoading || $[23] !== size || $[24] !== src || $[25] !== t19 || $[26] !== testId) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $c8d2033fac7e31cd$export$2e2bcd8739ae039), {
            alt: t19,
            src: src,
            appearance: appearance,
            size: size,
            testId: testId,
            imgLoading: imgLoading
        });
        $[21] = appearance;
        $[22] = imgLoading;
        $[23] = size;
        $[24] = src;
        $[25] = t19;
        $[26] = testId;
        $[27] = t20;
    } else t20 = $[27];
    let t21;
    if ($[28] !== appearance || $[29] !== ariaControls || $[30] !== ariaExpanded || $[31] !== ariaHasPopup || $[32] !== borderColor || $[33] !== href || $[34] !== isDisabled || $[35] !== ref || $[36] !== size || $[37] !== stackIndex || $[38] !== t15 || $[39] !== t16 || $[40] !== t17 || $[41] !== t18 || $[42] !== t20 || $[43] !== target) {
        t21 = {
            as: t15,
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: t16,
            onClick: t17,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: t18,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            avatarImage: t20
        };
        $[28] = appearance;
        $[29] = ariaControls;
        $[30] = ariaExpanded;
        $[31] = ariaHasPopup;
        $[32] = borderColor;
        $[33] = href;
        $[34] = isDisabled;
        $[35] = ref;
        $[36] = size;
        $[37] = stackIndex;
        $[38] = t15;
        $[39] = t16;
        $[40] = t17;
        $[41] = t18;
        $[42] = t20;
        $[43] = target;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== children) {
        t22 = children || /*#__PURE__*/ $cozmU.createElement((0, $7zsi1.AvatarContent), null);
        $[45] = children;
        $[46] = t22;
    } else t22 = $[46];
    let t23;
    if ($[47] !== t21 || $[48] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $lnlX7.AvatarContentContext).Provider, {
            value: t21
        }, t22);
        $[47] = t21;
        $[48] = t22;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== appearance || $[51] !== customPresenceNode || $[52] !== indicatorSize || $[53] !== isPresence || $[54] !== presence || $[55] !== testId) {
        t24 = isPresence && /*#__PURE__*/ $cozmU.createElement((0, $4b3aea981a37cca5$export$2e2bcd8739ae039), {
            appearance: appearance,
            size: indicatorSize,
            presence: typeof presence === "string" ? presence : undefined,
            testId: testId
        }, customPresenceNode);
        $[50] = appearance;
        $[51] = customPresenceNode;
        $[52] = indicatorSize;
        $[53] = isPresence;
        $[54] = presence;
        $[55] = testId;
        $[56] = t24;
    } else t24 = $[56];
    let t25;
    if ($[57] !== appearance || $[58] !== borderColor || $[59] !== customStatusNode || $[60] !== indicatorSize || $[61] !== isStatus || $[62] !== status || $[63] !== testId) {
        t25 = isStatus && /*#__PURE__*/ $cozmU.createElement((0, $c0d82b4aac8b13ee$export$2e2bcd8739ae039), {
            appearance: appearance,
            size: indicatorSize,
            borderColor: borderColor,
            status: typeof status === "string" ? status : undefined,
            testId: testId
        }, customStatusNode);
        $[57] = appearance;
        $[58] = borderColor;
        $[59] = customStatusNode;
        $[60] = indicatorSize;
        $[61] = isStatus;
        $[62] = status;
        $[63] = testId;
        $[64] = t25;
    } else t25 = $[64];
    let t26;
    if ($[65] !== containerShouldBeImage || $[66] !== defaultLabel || $[67] !== labelId || $[68] !== testId) {
        t26 = containerShouldBeImage ? /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId && `${testId}--label`,
            id: labelId,
            hidden: true
        }, defaultLabel) : undefined;
        $[65] = containerShouldBeImage;
        $[66] = defaultLabel;
        $[67] = labelId;
        $[68] = testId;
        $[69] = t26;
    } else t26 = $[69];
    let t27;
    if ($[70] !== AvatarContainer || $[71] !== t11 || $[72] !== t12 || $[73] !== t13 || $[74] !== t23 || $[75] !== t24 || $[76] !== t25 || $[77] !== t26 || $[78] !== testId) {
        t27 = /*#__PURE__*/ $cozmU.createElement((0, $bIrLJ.EnsureIsInsideAvatarContext).Provider, {
            value: true
        }, /*#__PURE__*/ $cozmU.createElement(AvatarContainer, {
            "data-testid": testId,
            role: t11,
            "aria-labelledby": t12,
            style: t13,
            className: t14
        }, t23, t24, t25, t26));
        $[70] = AvatarContainer;
        $[71] = t11;
        $[72] = t12;
        $[73] = t13;
        $[74] = t23;
        $[75] = t24;
        $[76] = t25;
        $[77] = t26;
        $[78] = testId;
        $[79] = t27;
    } else t27 = $[79];
    return t27;
} : ({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const context = (0, $64b6dc2b8b4ea041$export$b50b87a1c4086b23)();
    const size = $114e8a3ad5f7d032$var$normalizeAvatarSize(sizeProp || context?.size || 'medium');
    const customPresenceNode = /*#__PURE__*/ (0, $cozmU.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $cozmU.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall'; // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $cozmU.useRef)(analyticsContext);
    const labelId = (0, $6JrSr.useId)();
    (0, $cozmU.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $114e8a3ad5f7d032$var$packageName,
                packageVersion: $114e8a3ad5f7d032$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context_0 = {
            componentName: 'avatar',
            packageName: $114e8a3ad5f7d032$var$packageName,
            packageVersion: $114e8a3ad5f7d032$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context_0); /**
                                             * Replicating the logic in the `withAnalyticsEvents` HOC.
                                             */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $cozmU.createElement((0, $bIrLJ.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $cozmU.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _3iDTPbvbI6 _1mT5xdRAKS"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lnlX7.AvatarContentContext).Provider, {
        value: {
            as: (0, $b2VYe.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? `${testId}--inner` : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $cozmU.createElement((0, $c8d2033fac7e31cd$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $cozmU.createElement((0, $7zsi1.AvatarContent), null)), isPresence && /*#__PURE__*/ $cozmU.createElement((0, $4b3aea981a37cca5$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $cozmU.createElement((0, $c0d82b4aac8b13ee$export$2e2bcd8739ae039), {
        appearance: appearance,
        size: indicatorSize,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId && `${testId}--label`,
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$114e8a3ad5f7d032$var$Avatar.displayName = 'Avatar';
var $114e8a3ad5f7d032$export$2e2bcd8739ae039 = $114e8a3ad5f7d032$var$Avatar;
module.exports["default"] = $114e8a3ad5f7d032$export$2e2bcd8739ae039;

});

parcelRegister("7zsi1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $lnlX7 = parcelRequire("lnlX7");








var $bIrLJ = parcelRequire("bIrLJ");

const $6f79223af6724947$export$7db5c57474082dd9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)((0, $bIrLJ.EnsureIsInsideAvatarContext));
    if (!context) throw new Error("Avatar sub-components must be used within a Avatar component.");
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $bIrLJ.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};


const $384a2ccebdfdde3d$var$boxShadowCssVar = '--avatar-box-shadow';
const $384a2ccebdfdde3d$var$bgColorCssVar = '--avatar-bg-color';
const $384a2ccebdfdde3d$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XjOvk _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa _3kPd40YbGa _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _0hSAgbNvrM",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    square: "_0bjKvD0O7w",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $384a2ccebdfdde3d$var$unboundStyles = {
    rootCustomBorder: "_2uo31fVZWJ",
    root: "_24h04iPvdi _0KLXruVZWJ _2OUyjtrcoi",
    hexagonFocusContainer: "_4c065U9E27 _2Y7lL42M4S _3SamIHoYZL _2YLqiKnBff _0KLXrujOvk _1uo2ZfTcEg _3YCJEinXvL",
    hexagonBorderContainerCustomBorder: "_2uo31fVZWJ",
    hexagonBorderContainer: "_4c065U7oRc _2Y7lL4Aa7o _3SamIHzX4W _2YLqiKTz7d _0KLXruVZWJ _1uo2ZfOLYo _3YCJEilfZc",
    hexagon: "_0bjKvDdnbC _1uo2ZfOLYo _2OUyjtZqHV _2Gfj6idnbC _3kPd40ZqHV _2wtOC9dnbC _0hSAgbdnbC",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu",
    interactiveMotion: "_23rrnHimX9 _3NJLv82rpu"
};
const $384a2ccebdfdde3d$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkoUduD _46hvQmUduD _03SyCPUduD _0LQT5EUduD _0rIjykPM89 _43nrzTPM89 _2xTnZxPM89 _0GTcwRPM89",
    hexagonFocusContainer: "_0xmtko7SV6 _46hvQm7SV6 _03SyCP7SV6 _0LQT5E7SV6 _0rIjykAoU6 _43nrzTAoU6 _2xTnZxAoU6 _0GTcwRAoU6"
};
const $384a2ccebdfdde3d$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
const $384a2ccebdfdde3d$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(44);
    const { children: children } = t0;
    (0, $6f79223af6724947$export$7db5c57474082dd9)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: t1, href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = (0, $cozmU.useContext)((0, $lnlX7.AvatarContentContext));
    const borderColor = t1 === undefined ? "var(--ds-surface, #FFFFFF)" : t1;
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const t2 = `0 0 0 2px ${borderColor}`;
    let t3;
    if ($[0] !== borderColor || $[1] !== t2) {
        t3 = {
            [$384a2ccebdfdde3d$var$bgColorCssVar]: borderColor,
            [$384a2ccebdfdde3d$var$boxShadowCssVar]: t2
        };
        $[0] = borderColor;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = t3;
    const t5 = ref || contextRef;
    const t6 = isInteractive ? label : undefined;
    const t7 = Container === "button" ? "button" : undefined;
    let t8;
    if ($[3] !== href || $[4] !== target) {
        t8 = href && {
            href: href,
            target: target,
            rel: target === "_blank" ? "noopener noreferrer" : undefined
        };
        $[3] = href;
        $[4] = target;
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== appearance || $[7] !== isDisabled || $[8] !== isInteractive || $[9] !== size || $[10] !== stackIndex) {
        t9 = (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.root,
            (0, $iDrrr.fg)("avatar-custom-border") && $384a2ccebdfdde3d$var$unboundStyles.rootCustomBorder,
            $384a2ccebdfdde3d$var$styles.root,
            appearance === "square" && $384a2ccebdfdde3d$var$styles.square,
            appearance === "circle" && $384a2ccebdfdde3d$var$styles.circle,
            appearance === "hexagon" && $384a2ccebdfdde3d$var$unboundStyles.hexagon,
            $384a2ccebdfdde3d$var$widthHeightMap[size],
            stackIndex !== undefined && $384a2ccebdfdde3d$var$styles.positionRelative,
            isInteractive && !isDisabled && $384a2ccebdfdde3d$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== "hexagon" && (0, $iDrrr.fg)("platform-dst-motion-uplift") && $384a2ccebdfdde3d$var$unboundStyles.interactiveMotion,
            isDisabled && $384a2ccebdfdde3d$var$styles.disabled
        ]);
        $[6] = appearance;
        $[7] = isDisabled;
        $[8] = isInteractive;
        $[9] = size;
        $[10] = stackIndex;
        $[11] = t9;
    } else t9 = $[11];
    const t10 = children || avatarImage;
    let t11;
    if ($[12] !== Container || $[13] !== ariaControls || $[14] !== ariaExpanded || $[15] !== ariaHasPopup || $[16] !== isDisabled || $[17] !== onClick || $[18] !== t10 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9 || $[25] !== tabIndex || $[26] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement(Container, {
            style: t4,
            ref: t5,
            "aria-label": t6,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            onClick: onClick,
            tabIndex: tabIndex,
            "data-testid": testId,
            disabled: isDisabled,
            type: t7,
            ...t8,
            className: t9
        }, t10);
        $[12] = Container;
        $[13] = ariaControls;
        $[14] = ariaExpanded;
        $[15] = ariaHasPopup;
        $[16] = isDisabled;
        $[17] = onClick;
        $[18] = t10;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
        $[24] = t9;
        $[25] = tabIndex;
        $[26] = testId;
        $[27] = t11;
    } else t11 = $[27];
    const renderedContent = t11;
    if (appearance !== "hexagon") return renderedContent;
    const t12 = `0 0 0 2px ${borderColor}`;
    let t13;
    if ($[28] !== borderColor || $[29] !== t12) {
        t13 = {
            [$384a2ccebdfdde3d$var$bgColorCssVar]: borderColor,
            [$384a2ccebdfdde3d$var$boxShadowCssVar]: t12
        };
        $[28] = borderColor;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    const t14 = t13;
    const t15 = testId ? `${testId}-hexagon-focus-container` : "hexagon-focus-container";
    let t16;
    if ($[31] !== isDisabled || $[32] !== isInteractive) {
        t16 = (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $iDrrr.fg)("platform-dst-motion-uplift") && $384a2ccebdfdde3d$var$unboundStyles.interactiveMotion,
            (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") && $384a2ccebdfdde3d$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]);
        $[31] = isDisabled;
        $[32] = isInteractive;
        $[33] = t16;
    } else t16 = $[33];
    const t17 = testId ? `${testId}-hexagon-border-container` : "hexagon-border-container";
    let t18;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.hexagonBorderContainer,
            (0, $iDrrr.fg)("avatar-custom-border") && $384a2ccebdfdde3d$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") && $384a2ccebdfdde3d$var$hexagonBorderFixStyles.hexagonBorderContainer
        ]);
        $[34] = t18;
    } else t18 = $[34];
    let t19;
    if ($[35] !== renderedContent || $[36] !== t17 || $[37] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t17,
            className: t18
        }, renderedContent);
        $[35] = renderedContent;
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16 || $[42] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t14,
            "data-testid": t15,
            className: t16
        }, t19);
        $[39] = t14;
        $[40] = t15;
        $[41] = t16;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
} : ({ children: children }, ref)=>{
    (0, $6f79223af6724947$export$7db5c57474082dd9)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $cozmU.useContext)((0, $lnlX7.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ $cozmU.createElement(Container, {
        style: {
            [$384a2ccebdfdde3d$var$bgColorCssVar]: borderColor,
            [$384a2ccebdfdde3d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.root,
            (0, $iDrrr.fg)('avatar-custom-border') && $384a2ccebdfdde3d$var$unboundStyles.rootCustomBorder,
            $384a2ccebdfdde3d$var$styles.root,
            appearance === 'square' && $384a2ccebdfdde3d$var$styles.square,
            appearance === 'circle' && $384a2ccebdfdde3d$var$styles.circle,
            appearance === 'hexagon' && $384a2ccebdfdde3d$var$unboundStyles.hexagon,
            $384a2ccebdfdde3d$var$widthHeightMap[size],
            stackIndex !== undefined && $384a2ccebdfdde3d$var$styles.positionRelative,
            isInteractive && !isDisabled && $384a2ccebdfdde3d$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $iDrrr.fg)('platform-dst-motion-uplift') && $384a2ccebdfdde3d$var$unboundStyles.interactiveMotion,
            isDisabled && $384a2ccebdfdde3d$var$styles.disabled
        ])
    }, children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
     // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            [$384a2ccebdfdde3d$var$bgColorCssVar]: borderColor,
            [$384a2ccebdfdde3d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $iDrrr.fg)('platform-dst-motion-uplift') && $384a2ccebdfdde3d$var$unboundStyles.interactiveMotion,
            (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') && $384a2ccebdfdde3d$var$hexagonBorderFixStyles.hexagonFocusContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
        className: (0, $hekY6.default)([
            $384a2ccebdfdde3d$var$unboundStyles.hexagonBorderContainer,
            (0, $iDrrr.fg)('avatar-custom-border') && $384a2ccebdfdde3d$var$unboundStyles.hexagonBorderContainerCustomBorder,
            (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') && $384a2ccebdfdde3d$var$hexagonBorderFixStyles.hexagonBorderContainer
        ])
    }, renderedContent));
});
module.exports["AvatarContent"] = $384a2ccebdfdde3d$export$47fbc0b44cae5559;

});

parcelRegister("3v3yD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c3f0211254e146c6$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["AvatarContext"] = $c3f0211254e146c6$export$a20dad690e1279e2;

});

parcelRegister("6IL1T", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9uf2f = parcelRequire("9uf2f");


var $acQiA = parcelRequire("acQiA");

const $2c4a75e6076a04aa$var$baseStyles = null; /**
                          * __Menu group__
                          *
                          * A menu group includes all the actions or items in a menu.
                          *
                          * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
                          * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                          */ 
const $2c4a75e6076a04aa$var$MenuGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    let UNSAFE_className;
    let isLoading;
    let maxHeight;
    let maxWidth;
    let menuLabel;
    let minHeight;
    let minWidth;
    let rest;
    let role;
    let t1;
    let testId;
    if ($[0] !== t0) {
        ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: t1, menuLabel: menuLabel, className: UNSAFE_className, ...rest } = t0);
        $[0] = t0;
        $[1] = UNSAFE_className;
        $[2] = isLoading;
        $[3] = maxHeight;
        $[4] = maxWidth;
        $[5] = menuLabel;
        $[6] = minHeight;
        $[7] = minWidth;
        $[8] = rest;
        $[9] = role;
        $[10] = t1;
        $[11] = testId;
    } else {
        UNSAFE_className = $[1];
        isLoading = $[2];
        maxHeight = $[3];
        maxWidth = $[4];
        menuLabel = $[5];
        minHeight = $[6];
        minWidth = $[7];
        rest = $[8];
        role = $[9];
        t1 = $[10];
        testId = $[11];
    }
    const spacing = t1 === undefined ? "cozy" : t1;
    let t2;
    if ($[12] !== maxHeight || $[13] !== maxWidth || $[14] !== minHeight || $[15] !== minWidth) {
        t2 = {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        };
        $[12] = maxHeight;
        $[13] = maxWidth;
        $[14] = minHeight;
        $[15] = minWidth;
        $[16] = t2;
    } else t2 = $[16];
    let t3;
    if ($[17] !== UNSAFE_className) {
        t3 = (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w",
            UNSAFE_className
        ]);
        $[17] = UNSAFE_className;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== isLoading || $[20] !== menuLabel || $[21] !== rest || $[22] !== role || $[23] !== t2 || $[24] !== t3 || $[25] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border"
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-busy": isLoading,
            style: t2,
            "data-testid": testId,
            role: role,
            className: t3,
            "aria-label": menuLabel,
            ...rest
        }));
        $[19] = isLoading;
        $[20] = menuLabel;
        $[21] = rest;
        $[22] = role;
        $[23] = t2;
        $[24] = t3;
        $[25] = testId;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== spacing || $[28] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $9uf2f.SpacingContext).Provider, {
            value: spacing
        }, t4);
        $[27] = spacing;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ $cozmU.createElement((0, $9uf2f.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $cozmU.createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w",
            UNSAFE_className
        ]),
        "aria-label": menuLabel,
        ...rest
    })));
var $2c4a75e6076a04aa$export$2e2bcd8739ae039 = $2c4a75e6076a04aa$var$MenuGroup;
module.exports["default"] = $2c4a75e6076a04aa$export$2e2bcd8739ae039;

});

parcelRegister("acQiA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f9f515614f647594$export$9ca534b70725964d = /*#__PURE__*/ (0, $cozmU.createContext)('border');
module.exports["SELECTION_STYLE_CONTEXT_DO_NOT_USE"] = $f9f515614f647594$export$9ca534b70725964d;

});

parcelRegister("9d7Pd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $6CckD = parcelRequire("6CckD");

const $f3a474b5d06effd5$var$ButtonItem = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(40);
    let UNSAFE_className;
    let children;
    let description;
    let iconAfter;
    let iconBefore;
    let interactionName;
    let onClick;
    let onMouseDown;
    let rest;
    let shouldDescriptionWrap;
    let shouldTitleWrap;
    let t0;
    let t1;
    let testId;
    if ($[0] !== props) {
        ({ children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: t0, isSelected: t1, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props);
        $[0] = props;
        $[1] = UNSAFE_className;
        $[2] = children;
        $[3] = description;
        $[4] = iconAfter;
        $[5] = iconBefore;
        $[6] = interactionName;
        $[7] = onClick;
        $[8] = onMouseDown;
        $[9] = rest;
        $[10] = shouldDescriptionWrap;
        $[11] = shouldTitleWrap;
        $[12] = t0;
        $[13] = t1;
        $[14] = testId;
    } else {
        UNSAFE_className = $[1];
        children = $[2];
        description = $[3];
        iconAfter = $[4];
        iconBefore = $[5];
        interactionName = $[6];
        onClick = $[7];
        onMouseDown = $[8];
        rest = $[9];
        shouldDescriptionWrap = $[10];
        shouldTitleWrap = $[11];
        t0 = $[12];
        t1 = $[13];
        testId = $[14];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isSelected = t1 === undefined ? false : t1;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    if ($[15] !== interactionContext || $[16] !== interactionName || $[17] !== onClick) {
        t2 = (e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        };
        $[15] = interactionContext;
        $[16] = interactionName;
        $[17] = onClick;
        $[18] = t2;
    } else t2 = $[18];
    const handleClick = t2;
    if (!children) return null;
    const t3 = testId && `${testId}--primitive`;
    let t4;
    if ($[19] !== handleClick || $[20] !== isDisabled || $[21] !== isSelected || $[22] !== onMouseDownHandler || $[23] !== ref || $[24] !== rest || $[25] !== testId) {
        t4 = (t5)=>{
            const { children: children_0, className: className } = t5;
            return /*#__PURE__*/ $cozmU.createElement("button", {
                "data-testid": testId,
                "aria-current": isSelected ? "true" : undefined,
                ...rest,
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button"
            }, children_0);
        };
        $[19] = handleClick;
        $[20] = isDisabled;
        $[21] = isSelected;
        $[22] = onMouseDownHandler;
        $[23] = ref;
        $[24] = rest;
        $[25] = testId;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== UNSAFE_className || $[28] !== children || $[29] !== description || $[30] !== iconAfter || $[31] !== iconBefore || $[32] !== isDisabled || $[33] !== isSelected || $[34] !== rest || $[35] !== shouldDescriptionWrap || $[36] !== shouldTitleWrap || $[37] !== t3 || $[38] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default), {
            className: UNSAFE_className,
            ...rest,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isTitleHeading: false,
            description: description,
            title: children,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            testId: t3
        }, t4);
        $[27] = UNSAFE_className;
        $[28] = children;
        $[29] = description;
        $[30] = iconAfter;
        $[31] = iconBefore;
        $[32] = isDisabled;
        $[33] = isSelected;
        $[34] = rest;
        $[35] = shouldDescriptionWrap;
        $[36] = shouldTitleWrap;
        $[37] = t3;
        $[38] = t4;
        $[39] = t5;
    } else t5 = $[39];
    return t5;
} : (props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children_0, className: className })=>/*#__PURE__*/ $cozmU.createElement("button", {
            "data-testid": testId,
            // which are already being passed to the button element.
            "aria-current": isSelected ? 'true' : undefined,
            ...rest,
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children_0));
}));
var $f3a474b5d06effd5$export$2e2bcd8739ae039 = $f3a474b5d06effd5$var$ButtonItem;
module.exports["default"] = $f3a474b5d06effd5$export$2e2bcd8739ae039;

});

parcelRegister("kD4eB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $6CckD = parcelRequire("6CckD");

const $e0ec13ca81d07c17$var$preventEvent = (e)=>{
    e.preventDefault();
}; // Dirty hack to get generics working with forward ref [1/2]
const $e0ec13ca81d07c17$var$CustomItem = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(45);
    let Component;
    let UNSAFE_className;
    let UNSAFE_isDraggable;
    let children;
    let description;
    let iconAfter;
    let iconBefore;
    let interactionName;
    let onClick;
    let onMouseDown;
    let rest;
    let shouldDescriptionWrap;
    let shouldTitleWrap;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ component: Component, isDisabled: t1, isSelected: t2, isTitleHeading: t3, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = Component;
        $[2] = UNSAFE_className;
        $[3] = UNSAFE_isDraggable;
        $[4] = children;
        $[5] = description;
        $[6] = iconAfter;
        $[7] = iconBefore;
        $[8] = interactionName;
        $[9] = onClick;
        $[10] = onMouseDown;
        $[11] = rest;
        $[12] = shouldDescriptionWrap;
        $[13] = shouldTitleWrap;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
        $[17] = testId;
    } else {
        Component = $[1];
        UNSAFE_className = $[2];
        UNSAFE_isDraggable = $[3];
        children = $[4];
        description = $[5];
        iconAfter = $[6];
        iconBefore = $[7];
        interactionName = $[8];
        onClick = $[9];
        onMouseDown = $[10];
        rest = $[11];
        shouldDescriptionWrap = $[12];
        shouldTitleWrap = $[13];
        t1 = $[14];
        t2 = $[15];
        t3 = $[16];
        testId = $[17];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isSelected = t2 === undefined ? false : t2;
    const isTitleHeading = t3 === undefined ? false : t3;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t4;
    if ($[18] !== interactionContext || $[19] !== interactionName || $[20] !== onClick) {
        t4 = (e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        };
        $[18] = interactionContext;
        $[19] = interactionName;
        $[20] = onClick;
        $[21] = t4;
    } else t4 = $[21];
    const handleClick = t4;
    if (!Component) return null;
    const t5 = testId && `${testId}--primitive`;
    let t6;
    if ($[22] !== Component || $[23] !== UNSAFE_isDraggable || $[24] !== handleClick || $[25] !== isDisabled || $[26] !== onMouseDownHandler || $[27] !== ref || $[28] !== rest || $[29] !== testId) {
        t6 = (t7)=>{
            const { children: children_0, className: className } = t7;
            return /*#__PURE__*/ $cozmU.createElement(Component, {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $e0ec13ca81d07c17$var$preventEvent
                },
                onMouseDown: isDisabled ? $e0ec13ca81d07c17$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $e0ec13ca81d07c17$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined
            }, children_0);
        };
        $[22] = Component;
        $[23] = UNSAFE_isDraggable;
        $[24] = handleClick;
        $[25] = isDisabled;
        $[26] = onMouseDownHandler;
        $[27] = ref;
        $[28] = rest;
        $[29] = testId;
        $[30] = t6;
    } else t6 = $[30];
    let t7;
    if ($[31] !== UNSAFE_className || $[32] !== children || $[33] !== description || $[34] !== iconAfter || $[35] !== iconBefore || $[36] !== isDisabled || $[37] !== isSelected || $[38] !== isTitleHeading || $[39] !== rest || $[40] !== shouldDescriptionWrap || $[41] !== shouldTitleWrap || $[42] !== t5 || $[43] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default), {
            className: UNSAFE_className,
            ...rest,
            description: description,
            iconAfter: iconAfter,
            title: children,
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isTitleHeading: isTitleHeading,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            testId: t5
        }, t6);
        $[31] = UNSAFE_className;
        $[32] = children;
        $[33] = description;
        $[34] = iconAfter;
        $[35] = iconBefore;
        $[36] = isDisabled;
        $[37] = isSelected;
        $[38] = isTitleHeading;
        $[39] = rest;
        $[40] = shouldDescriptionWrap;
        $[41] = shouldTitleWrap;
        $[42] = t5;
        $[43] = t6;
        $[44] = t7;
    } else t7 = $[44];
    return t7;
} : ({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children_0, className: className })=>/*#__PURE__*/ $cozmU.createElement(Component, {
            "data-testid": testId,
            ...rest,
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $e0ec13ca81d07c17$var$preventEvent
            },
            onMouseDown: isDisabled ? $e0ec13ca81d07c17$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $e0ec13ca81d07c17$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled || undefined
        }, children_0));
}));
var $e0ec13ca81d07c17$export$2e2bcd8739ae039 = $e0ec13ca81d07c17$var$CustomItem;
module.exports["default"] = $e0ec13ca81d07c17$export$2e2bcd8739ae039;

});

parcelRegister("8oBbn", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ir4h8 = parcelRequire("ir4h8");


var $5EzLH = parcelRequire("5EzLH");


var $6CckD = parcelRequire("6CckD");

const $fced2b3418f4305b$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $fced2b3418f4305b$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $fced2b3418f4305b$var$preventEvent = (e)=>{
    e.preventDefault();
}; /**
    * __Link item__
    *
    * A link item is used to populate a menu with items that are links.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $fced2b3418f4305b$var$LinkItem = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(51);
    let UNSAFE_className;
    let UNSAFE_isDraggable;
    let UNSAFE_shouldDisableRouterLink;
    let children;
    let description;
    let href;
    let iconAfter;
    let iconBefore;
    let interactionName;
    let onClick;
    let onMouseDown;
    let rest;
    let shouldDescriptionWrap;
    let shouldTitleWrap;
    let t0;
    let t1;
    let testId;
    if ($[0] !== props) {
        ({ children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: t0, isSelected: t1, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props);
        $[0] = props;
        $[1] = UNSAFE_className;
        $[2] = UNSAFE_isDraggable;
        $[3] = UNSAFE_shouldDisableRouterLink;
        $[4] = children;
        $[5] = description;
        $[6] = href;
        $[7] = iconAfter;
        $[8] = iconBefore;
        $[9] = interactionName;
        $[10] = onClick;
        $[11] = onMouseDown;
        $[12] = rest;
        $[13] = shouldDescriptionWrap;
        $[14] = shouldTitleWrap;
        $[15] = t0;
        $[16] = t1;
        $[17] = testId;
    } else {
        UNSAFE_className = $[1];
        UNSAFE_isDraggable = $[2];
        UNSAFE_shouldDisableRouterLink = $[3];
        children = $[4];
        description = $[5];
        href = $[6];
        iconAfter = $[7];
        iconBefore = $[8];
        interactionName = $[9];
        onClick = $[10];
        onMouseDown = $[11];
        rest = $[12];
        shouldDescriptionWrap = $[13];
        shouldTitleWrap = $[14];
        t0 = $[15];
        t1 = $[16];
        testId = $[17];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isSelected = t1 === undefined ? false : t1;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $ir4h8.useRouterLink)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    if ($[18] !== interactionContext || $[19] !== interactionName || $[20] !== onClick) {
        t2 = (e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        };
        $[18] = interactionContext;
        $[19] = interactionName;
        $[20] = onClick;
        $[21] = t2;
    } else t2 = $[21];
    const handleClick = t2;
    if (!children) return null;
    let t3;
    if ($[22] !== href) {
        t3 = typeof href === "string" && $fced2b3418f4305b$var$IS_EXTERNAL_LINK_REGEX.test(href);
        $[22] = href;
        $[23] = t3;
    } else t3 = $[23];
    const isExternal = t3;
    let t4;
    if ($[24] !== href) {
        t4 = typeof href === "string" && $fced2b3418f4305b$var$IS_NON_HTTP_BASED.test(href);
        $[24] = href;
        $[25] = t4;
    } else t4 = $[25];
    const isNonHttpBased = t4;
    const isEmptyHref = href == null || href === "";
    const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : "a";
    const t5 = testId && `${testId}--primitive`;
    let t6;
    if ($[26] !== Component || $[27] !== UNSAFE_isDraggable || $[28] !== handleClick || $[29] !== href || $[30] !== isDisabled || $[31] !== isRouterLink || $[32] !== isSelected || $[33] !== onMouseDownHandler || $[34] !== ref || $[35] !== rest || $[36] !== testId) {
        t6 = (t7)=>{
            const { children: children_0, className: className } = t7;
            return /*#__PURE__*/ $cozmU.createElement(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
                "data-vc": "link-item",
                ...rest,
                className: className,
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $fced2b3418f4305b$var$preventEvent
                },
                onMouseDown: isDisabled ? $fced2b3418f4305b$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $fced2b3418f4305b$var$preventEvent : handleClick,
                "aria-current": isSelected ? "page" : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref
            }, children_0);
        };
        $[26] = Component;
        $[27] = UNSAFE_isDraggable;
        $[28] = handleClick;
        $[29] = href;
        $[30] = isDisabled;
        $[31] = isRouterLink;
        $[32] = isSelected;
        $[33] = onMouseDownHandler;
        $[34] = ref;
        $[35] = rest;
        $[36] = testId;
        $[37] = t6;
    } else t6 = $[37];
    let t7;
    if ($[38] !== UNSAFE_className || $[39] !== children || $[40] !== description || $[41] !== iconAfter || $[42] !== iconBefore || $[43] !== isDisabled || $[44] !== isSelected || $[45] !== rest || $[46] !== shouldDescriptionWrap || $[47] !== shouldTitleWrap || $[48] !== t5 || $[49] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default), {
            ...rest,
            className: UNSAFE_className,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isTitleHeading: false,
            description: description,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            title: children,
            testId: t5
        }, t6);
        $[38] = UNSAFE_className;
        $[39] = children;
        $[40] = description;
        $[41] = iconAfter;
        $[42] = iconBefore;
        $[43] = isDisabled;
        $[44] = isSelected;
        $[45] = rest;
        $[46] = shouldDescriptionWrap;
        $[47] = shouldTitleWrap;
        $[48] = t5;
        $[49] = t6;
        $[50] = t7;
    } else t7 = $[50];
    return t7;
} : (props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $ir4h8.useRouterLink)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $fced2b3418f4305b$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $fced2b3418f4305b$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === ''; /**
                                                    * Renders a router link if:
                                                    *
                                                    * - a link component is set in the app provider
                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
                                                    * - it doesn't have an empty href (e.g. href="" or href={undefined})
                                                    */ 
    const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $cozmU.createElement((0, $6CckD.default), {
        ...rest,
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children_0, className: className })=>/*#__PURE__*/ $cozmU.createElement(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            className: className,
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $fced2b3418f4305b$var$preventEvent
            },
            onMouseDown: isDisabled ? $fced2b3418f4305b$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $fced2b3418f4305b$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled || undefined,
            ref: ref
        }, children_0));
}));
var $fced2b3418f4305b$export$2e2bcd8739ae039 = $fced2b3418f4305b$var$LinkItem;
module.exports["default"] = $fced2b3418f4305b$export$2e2bcd8739ae039;

});

parcelRegister("8FgJC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $huzJY = parcelRequire("huzJY");

const $e5a1d9d2b2c4cdd9$var$itemHeadingTopMargin = 20;
const $e5a1d9d2b2c4cdd9$var$itemHeadingBottomMargin = 6; // Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $e5a1d9d2b2c4cdd9$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $e5a1d9d2b2c4cdd9$var$skeletonHeadingHeight = 8;
const $e5a1d9d2b2c4cdd9$var$skeletonHeadingMarginOffset = 3;
const $e5a1d9d2b2c4cdd9$var$skeletonHeadingTopMargin = $e5a1d9d2b2c4cdd9$var$itemHeadingTopMargin + ($e5a1d9d2b2c4cdd9$var$itemHeadingContentHeight - $e5a1d9d2b2c4cdd9$var$skeletonHeadingHeight) - $e5a1d9d2b2c4cdd9$var$skeletonHeadingMarginOffset;
const $e5a1d9d2b2c4cdd9$var$sectionPaddingTopBottom = 6;
const $e5a1d9d2b2c4cdd9$var$styles = {
    root: "_4Gb5FivLZJ _0OU75rvLZJ _47eTBtZimw _1lBcDcZimw _0GBAIrogpp _3Ku51Iogpp _420PbdZimw _3LXXKoSPN1 _1DqDD4EbN9 _0Ipfpy2AF2 _1apEF8fFOW _3R93WOXCiO _38a67RA17z",
    scrollable: "_4bt5LAIZbP _2WAcuGIZbP _3YEZNO7dHp",
    unscrollable: "_3YEZNOdnbC",
    thinSeparator: "_1v3aPqo71H",
    noSeparator: "_1wX8q6mW1D",
    sideNavSectionHeading: "_2Y7lL42ADO"
}; /**
    * __Section__
    *
    * A section includes related actions or items in a menu.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
    */ 
const $e5a1d9d2b2c4cdd9$var$Section = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(34);
    let UNSAFE_className;
    let children;
    let hasSeparator;
    let id;
    let isScrollable;
    let label;
    let rest;
    let t1;
    let t2;
    let testId;
    let title;
    let titleId;
    if ($[0] !== t0) {
        ({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: t1, isSideNavSection: t2, label: label, className: UNSAFE_className, ...rest } = t0);
        $[0] = t0;
        $[1] = UNSAFE_className;
        $[2] = children;
        $[3] = hasSeparator;
        $[4] = id;
        $[5] = isScrollable;
        $[6] = label;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = testId;
        $[11] = title;
        $[12] = titleId;
    } else {
        UNSAFE_className = $[1];
        children = $[2];
        hasSeparator = $[3];
        id = $[4];
        isScrollable = $[5];
        label = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        testId = $[10];
        title = $[11];
        titleId = $[12];
    }
    const isList = t1 === undefined ? false : t1;
    const isSideNavSection = t2 === undefined ? false : t2;
    let t3;
    if ($[13] !== children || $[14] !== isList) {
        t3 = isList ? /*#__PURE__*/ $cozmU.createElement("ul", {
            style: {
                margin: 0,
                padding: 0
            }
        }, (0, $cozmU.Children).map((0, $cozmU.Children).toArray(children), $e5a1d9d2b2c4cdd9$var$_temp)) : children;
        $[13] = children;
        $[14] = isList;
        $[15] = t3;
    } else t3 = $[15];
    const content = t3;
    let t4;
    if ($[16] !== content || $[17] !== isSideNavSection || $[18] !== testId || $[19] !== title) {
        t4 = title !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $huzJY.default), {
            testId: testId && `${testId}--heading`,
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                isSideNavSection && $e5a1d9d2b2c4cdd9$var$styles.sideNavSectionHeading
            ])
        }, title), content) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, content);
        $[16] = content;
        $[17] = isSideNavSection;
        $[18] = testId;
        $[19] = title;
        $[20] = t4;
    } else t4 = $[20];
    const childrenMarkup = t4;
    const t5 = isScrollable ? $e5a1d9d2b2c4cdd9$var$styles.scrollable : $e5a1d9d2b2c4cdd9$var$styles.unscrollable;
    const t6 = hasSeparator ? $e5a1d9d2b2c4cdd9$var$styles.thinSeparator : $e5a1d9d2b2c4cdd9$var$styles.noSeparator;
    let t7;
    if ($[21] !== UNSAFE_className || $[22] !== t5 || $[23] !== t6) {
        t7 = (0, $hekY6.default)([
            $e5a1d9d2b2c4cdd9$var$styles.root,
            t5,
            t6,
            UNSAFE_className
        ]);
        $[21] = UNSAFE_className;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
    } else t7 = $[24];
    const t8 = title || label;
    const t9 = ref;
    let t10;
    if ($[25] !== childrenMarkup || $[26] !== id || $[27] !== rest || $[28] !== t7 || $[29] !== t8 || $[30] !== t9 || $[31] !== testId || $[32] !== titleId) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...rest,
            className: t7,
            id: id,
            "aria-label": t8,
            "aria-labelledby": titleId,
            "data-testid": testId,
            role: "group",
            "data-section": true,
            ref: t9
        }, childrenMarkup);
        $[25] = childrenMarkup;
        $[26] = id;
        $[27] = rest;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
        $[31] = testId;
        $[32] = titleId;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ $cozmU.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $cozmU.Children).map((0, $cozmU.Children).toArray(children), (child, index)=>/*#__PURE__*/ $cozmU.createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $huzJY.default), {
        testId: testId && `${testId}--heading`,
        "aria-hidden": true,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hekY6.default)([
            isSideNavSection && $e5a1d9d2b2c4cdd9$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, content);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...rest,
        className: (0, $hekY6.default)([
            $e5a1d9d2b2c4cdd9$var$styles.root,
            isScrollable ? $e5a1d9d2b2c4cdd9$var$styles.scrollable : $e5a1d9d2b2c4cdd9$var$styles.unscrollable,
            hasSeparator ? $e5a1d9d2b2c4cdd9$var$styles.thinSeparator : $e5a1d9d2b2c4cdd9$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $e5a1d9d2b2c4cdd9$export$2e2bcd8739ae039 = $e5a1d9d2b2c4cdd9$var$Section;
function $e5a1d9d2b2c4cdd9$var$_temp(child, index) {
    return /*#__PURE__*/ $cozmU.createElement("li", {
        style: {
            listStyleType: "none",
            margin: 0,
            padding: 0
        },
        key: index
    }, child);
}
module.exports["default"] = $e5a1d9d2b2c4cdd9$export$2e2bcd8739ae039;

});

parcelRegister("huzJY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c98362beb0aa4f8a$var$headingStyles = null; /**
                             * __Heading item__
                             *
                             * A heading item is used to describe sibling menu items.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $c98362beb0aa4f8a$var$HeadingItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    let UNSAFE_className;
    let children;
    let id;
    let rest;
    let t1;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, testId: testId, headingLevel: t1, id: id, className: UNSAFE_className, ...rest } = t0);
        $[0] = t0;
        $[1] = UNSAFE_className;
        $[2] = children;
        $[3] = id;
        $[4] = rest;
        $[5] = t1;
        $[6] = testId;
    } else {
        UNSAFE_className = $[1];
        children = $[2];
        id = $[3];
        rest = $[4];
        t1 = $[5];
        testId = $[6];
    }
    const headingLevel = t1 === undefined ? 2 : t1;
    let t2;
    if ($[7] !== UNSAFE_className) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK",
            UNSAFE_className
        ]);
        $[7] = UNSAFE_className;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== children || $[10] !== headingLevel || $[11] !== id || $[12] !== rest || $[13] !== t2 || $[14] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "heading",
            "aria-level": headingLevel,
            "data-testid": testId,
            "data-ds--menu--heading-item": true,
            id: id,
            className: t2,
            ...rest
        }, children);
        $[9] = children;
        $[10] = headingLevel;
        $[11] = id;
        $[12] = rest;
        $[13] = t2;
        $[14] = testId;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : ({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK",
            UNSAFE_className
        ]),
        ...rest
    }, children);
});
var $c98362beb0aa4f8a$export$2e2bcd8739ae039 = $c98362beb0aa4f8a$var$HeadingItem;
module.exports["default"] = $c98362beb0aa4f8a$export$2e2bcd8739ae039;

});

parcelRegister("hMjUh", function(module, exports) {
/* tabs.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $kHJXa = parcelRequire("kHJXa");


var $2i8vD = parcelRequire("2i8vD");

const $5d3d2e063a10433d$var$baseStyles = null;
const $5d3d2e063a10433d$var$tabsStyles = null;
const $5d3d2e063a10433d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $5d3d2e063a10433d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $cozmU.createElement((0, $2i8vD.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $5d3d2e063a10433d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $cozmU.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $cozmU.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $cozmU.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $cozmU.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$5d3d2e063a10433d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $5d3d2e063a10433d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$5d3d2e063a10433d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1EqgXlN91d _4kiQYAdnbC _1bHrqEN91d _0aFT5vbt8w _2O5Vij7dHp",
            "_3aS2JlQ4SZ _12J1kbdnbC _2W6bUT7dHp _2UEJu4YbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kHJXa.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, tabPanelsWithContext));
};
var $5d3d2e063a10433d$export$2e2bcd8739ae039 = $5d3d2e063a10433d$var$Tabs;
module.exports["default"] = $5d3d2e063a10433d$export$2e2bcd8739ae039;

});

parcelRegister("22LbG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $2i8vD = parcelRequire("2i8vD");

// TODO: Fill in the hook {description}.
/**
 * {description}.
 */ const $d4cba972b6adf971$var$useTabPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTabPanel() {
    const tabPanelData = (0, $cozmU.useContext)((0, $2i8vD.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === "undefined") throw Error("@atlaskit/tabs:  A TabPanel must have a Tabs parent.");
    return tabPanelData;
} : function useTabPanel() {
    const tabPanelData = (0, $cozmU.useContext)((0, $2i8vD.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};
var $d4cba972b6adf971$export$2e2bcd8739ae039 = $d4cba972b6adf971$var$useTabPanel;
module.exports["default"] = $d4cba972b6adf971$export$2e2bcd8739ae039;

});

parcelRegister("bxtKM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8cnlb = parcelRequire("8cnlb");

var $4aRua = parcelRequire("4aRua");


var $eq2ng = parcelRequire("eq2ng");

/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $c720a8ce66d0c176$var$Tab = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Tab(t0, ref) {
    const $ = (0, $bDgLe.c)(15);
    const { children: children, testId: testId } = t0;
    const { onClick: onClick, id: id, "aria-controls": ariaControls, "aria-posinset": ariaPosinset, "aria-selected": ariaSelected, "aria-setsize": ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eq2ng.default)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "inherit",
            maxLines: 1
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== ariaControls || $[3] !== ariaPosinset || $[4] !== ariaSelected || $[5] !== ariaSetsize || $[6] !== id || $[7] !== onClick || $[8] !== onKeyDown || $[9] !== ref || $[10] !== role || $[11] !== t1 || $[12] !== tabIndex || $[13] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.Focusable), {
            as: "div",
            isInset: true,
            testId: testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref
        }, t1);
        $[2] = ariaControls;
        $[3] = ariaPosinset;
        $[4] = ariaSelected;
        $[5] = ariaSetsize;
        $[6] = id;
        $[7] = onClick;
        $[8] = onKeyDown;
        $[9] = ref;
        $[10] = role;
        $[11] = t1;
        $[12] = tabIndex;
        $[13] = testId;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
} : function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eq2ng.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.Focusable), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children));
});
var $c720a8ce66d0c176$export$2e2bcd8739ae039 = $c720a8ce66d0c176$var$Tab;
module.exports["default"] = $c720a8ce66d0c176$export$2e2bcd8739ae039;

});

parcelRegister("eq2ng", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $fOPNo = parcelRequire("fOPNo");

// TODO: Fill in the hook {description}.
/**
 * {description}.
 */ const $b3b40633acb3bb78$var$useTab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTab() {
    const tabData = (0, $cozmU.useContext)((0, $fOPNo.TabContext));
    if (tabData == null || typeof tabData === "undefined") throw Error("@atlaskit/tabs: A Tab must have a TabList parent.");
    return tabData;
} : function useTab() {
    const tabData = (0, $cozmU.useContext)((0, $fOPNo.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
var $b3b40633acb3bb78$export$2e2bcd8739ae039 = $b3b40633acb3bb78$var$useTab;
module.exports["default"] = $b3b40633acb3bb78$export$2e2bcd8739ae039;

});

parcelRegister("dkVNA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fOPNo = parcelRequire("fOPNo");








var $kHJXa = parcelRequire("kHJXa");

// TODO: Fill in the hook {description}.
/**
 * {description}.
 */ const $616a857d1c919e85$var$useTabList = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useTabList() {
    const tabListData = (0, $cozmU.useContext)((0, $kHJXa.TabListContext));
    if (tabListData === null || typeof tabListData === "undefined") throw Error("@atlaskit/tabs: A TabList must have a Tabs parent.");
    return tabListData;
} : function useTabList() {
    const tabListData = (0, $cozmU.useContext)((0, $kHJXa.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
var $616a857d1c919e85$export$2e2bcd8739ae039 = $616a857d1c919e85$var$useTabList;


const $e9f7aeaec0e345da$var$baseStyles = null;
const $e9f7aeaec0e345da$var$tabListStyles = null; /**
                             * __TabList__
                             *
                             * A TabList groups `Tab` components together.
                             *
                             * - [Examples](https://atlassian.design/components/tabs/examples)
                             * - [Code](https://atlassian.design/components/tabs/code)
                             * - [Usage](https://atlassian.design/components/tabs/usage)
                             */ 
const $e9f7aeaec0e345da$var$TabList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children } = t0;
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $616a857d1c919e85$export$2e2bcd8739ae039)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $cozmU.createRef)();
        $[0] = t1;
    } else t1 = $[0];
    const ref = t1;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[1] !== children || $[2] !== onChange || $[3] !== selected || $[4] !== tabsId) {
        const childrenArray = (0, $cozmU.Children).toArray(children).filter(Boolean);
        const length = childrenArray.length;
        let t6;
        if ($[9] !== onChange || $[10] !== tabsId) {
            t6 = (index)=>{
                const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
                if (newSelectedNode) newSelectedNode.focus();
                onChange(index);
            };
            $[9] = onChange;
            $[10] = tabsId;
            $[11] = t6;
        } else t6 = $[11];
        const selectTabByIndex = t6;
        let t7;
        if ($[12] !== length || $[13] !== selectTabByIndex) {
            t7 = (e)=>{
                if (![
                    "ArrowRight",
                    "ArrowLeft",
                    "Home",
                    "End"
                ].includes(e.key)) return;
                e.preventDefault();
                const lastTabIndex = length - 1;
                if ([
                    "Home",
                    "End"
                ].includes(e.key)) {
                    const newSelected = e.key === "Home" ? 0 : lastTabIndex;
                    selectTabByIndex(newSelected);
                    return;
                }
                const selectedIndex = parseInt(e.currentTarget.getAttribute("aria-posinset") || "0") - 1;
                const modifier = e.key === "ArrowRight" ? 1 : -1;
                let newSelected_0 = selectedIndex + modifier;
                if (newSelected_0 < 0 || newSelected_0 >= length) newSelected_0 = newSelected_0 < 0 ? lastTabIndex : 0;
                selectTabByIndex(newSelected_0);
            };
            $[12] = length;
            $[13] = selectTabByIndex;
            $[14] = t7;
        } else t7 = $[14];
        const onKeyDown = t7;
        let t8;
        if ($[15] !== length || $[16] !== onChange || $[17] !== onKeyDown || $[18] !== tabsId) {
            t8 = (t9)=>{
                const { tab: tab, isSelected: isSelected, index: index_0 } = t9;
                return /*#__PURE__*/ $cozmU.createElement((0, $fOPNo.TabContext).Provider, {
                    value: {
                        onClick: ()=>onChange(index_0),
                        onKeyDown: onKeyDown,
                        "aria-setsize": length,
                        role: "tab",
                        id: `${tabsId}-${index_0}`,
                        "aria-posinset": index_0 + 1,
                        "aria-selected": isSelected,
                        "aria-controls": `${tabsId}-${index_0}-tab`,
                        tabIndex: isSelected ? 0 : -1
                    },
                    key: index_0
                }, tab);
            };
            $[15] = length;
            $[16] = onChange;
            $[17] = onKeyDown;
            $[18] = tabsId;
            $[19] = t8;
        } else t8 = $[19];
        const getTabWithContext = t8;
        t2 = "tablist";
        t3 = ref;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, $hekY6.default)([
                "_3iDTPbQ4SZ _1mT5xdRAKS _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
                "_1kk5Tkf7mX _0GTcwR4F84 _16lLG9dnbC _2qX1yVdnbC _06FeTudnbC _2KGAYMdnbC _1M8NbwKTcp _0uDr6znQyn _3q9enAnQyn _0Kgs9nRAKS _49etWbZpcK _1QztuU7zJH _3ZhGSOgVvo _1HtMRwgVvo _33a3dI2ADO _1P4a492ADO _3ixl7Mz8Lp _4kzHpcLRg7 _11udAYdnbC _4BuBnpdnbC _2eXEWddnbC _2MDmEMdnbC _3Pk5gX1z4g _08GMC8OLYo _2DLSZVdnbC _1rQ2gkWVPG _2JhnOxogpp _05UqTtdnbC _28rMKq2ADO _3ZX5nV2ADO _3YM2rzZpcK _2813NtdnbC _2Q3hqednbC _2fik7ndnbC _3X0muIdnbC _37htk41z4g _3Typz6OLYo _0vw3bcdnbC _1AtSNnWVPG _2PiyWMogpp _4EIZSGdnbC _3MzQbH2ADO _3bxqMK2ADO _3zcyJ5y7kJ _0LW2msdnbC _3QHcMXdnbC _1mslYIdnbC _2abfNmdnbC _1PJZKigcHp _3Po0TzOLYo _0BfuX5dnbC _4fMoTIWVPG _3KpS27ogpp _42JjKAdnbC _46QKPk2ADO _3FgjuD2ADO _11tmTmjTy9 _1eBeNQgcHp _162m3ijTy9 _1FwLP5dnbC _0Xnm3ednbC _2miNbsdnbC _125xK8dnbC _3ScelFOLYo _1lBcDcNvrM _3dCYwDWVPG _4diMdq9r67 _3Ku51Iogpp _3p3AmIdnbC _3ljX6PdnbC _2jTvwt2ADO"
            ]);
            $[20] = t4;
        } else t4 = $[20];
        let t9;
        if ($[21] !== getTabWithContext || $[22] !== selected) {
            t9 = (child, index_1)=>getTabWithContext({
                    tab: child,
                    index: index_1,
                    isSelected: index_1 === selected
                });
            $[21] = getTabWithContext;
            $[22] = selected;
            $[23] = t9;
        } else t9 = $[23];
        t5 = childrenArray.map(t9);
        $[1] = children;
        $[2] = onChange;
        $[3] = selected;
        $[4] = tabsId;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else {
        t2 = $[5];
        t3 = $[6];
        t4 = $[7];
        t5 = $[8];
    }
    let t6;
    if ($[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: t2,
            ref: t3,
            className: t4
        }, t5);
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
    } else t6 = $[28];
    return t6;
} : ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $616a857d1c919e85$export$2e2bcd8739ae039)();
    const ref = /*#__PURE__*/ (0, $cozmU.createRef)(); // Don't include any conditional children
    const childrenArray = (0, $cozmU.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $cozmU.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
         // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        } // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected_0 = selectedIndex + modifier;
        if (newSelected_0 < 0 || newSelected_0 >= length) // Cycling focus to move from last to first and from first to last
        newSelected_0 = newSelected_0 < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected_0);
    }, [
        length,
        selectTabByIndex
    ]); // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $cozmU.useCallback)(({ tab: tab, isSelected: isSelected, index: index_0 })=>/*#__PURE__*/ $cozmU.createElement((0, $fOPNo.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index_0),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index_0}`,
                'aria-posinset': index_0 + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index_0}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index_0
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mT5xdRAKS _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            "_1kk5Tkf7mX _0GTcwR4F84 _16lLG9dnbC _2qX1yVdnbC _06FeTudnbC _2KGAYMdnbC _1M8NbwKTcp _0uDr6znQyn _3q9enAnQyn _0Kgs9nRAKS _49etWbZpcK _1QztuU7zJH _3ZhGSOgVvo _1HtMRwgVvo _33a3dI2ADO _1P4a492ADO _3ixl7Mz8Lp _4kzHpcLRg7 _11udAYdnbC _4BuBnpdnbC _2eXEWddnbC _2MDmEMdnbC _3Pk5gX1z4g _08GMC8OLYo _2DLSZVdnbC _1rQ2gkWVPG _2JhnOxogpp _05UqTtdnbC _28rMKq2ADO _3ZX5nV2ADO _3YM2rzZpcK _2813NtdnbC _2Q3hqednbC _2fik7ndnbC _3X0muIdnbC _37htk41z4g _3Typz6OLYo _0vw3bcdnbC _1AtSNnWVPG _2PiyWMogpp _4EIZSGdnbC _3MzQbH2ADO _3bxqMK2ADO _3zcyJ5y7kJ _0LW2msdnbC _3QHcMXdnbC _1mslYIdnbC _2abfNmdnbC _1PJZKigcHp _3Po0TzOLYo _0BfuX5dnbC _4fMoTIWVPG _3KpS27ogpp _42JjKAdnbC _46QKPk2ADO _3FgjuD2ADO _11tmTmjTy9 _1eBeNQgcHp _162m3ijTy9 _1FwLP5dnbC _0Xnm3ednbC _2miNbsdnbC _125xK8dnbC _3ScelFOLYo _1lBcDcNvrM _3dCYwDWVPG _4diMdq9r67 _3Ku51Iogpp _3p3AmIdnbC _3ljX6PdnbC _2jTvwt2ADO"
        ])
    }, childrenArray.map((child, index_1)=>getTabWithContext({
            tab: child,
            index: index_1,
            isSelected: index_1 === selected
        })));
};
var $e9f7aeaec0e345da$export$2e2bcd8739ae039 = $e9f7aeaec0e345da$var$TabList;
module.exports["default"] = $e9f7aeaec0e345da$export$2e2bcd8739ae039;

});

parcelRegister("7lxF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $14d5dad4a6329c33$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");










const $d936686a3a9843a6$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $d936686a3a9843a6$var$LazySuspenseContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $d936686a3a9843a6$var$DynamicFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, outsideSuspense: outsideSuspense } = t0;
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($d936686a3a9843a6$var$LazySuspenseContext);
    let t1;
    let t2;
    if ($[0] !== outsideSuspense || $[1] !== setFallback) {
        t1 = ()=>()=>{
                if (!outsideSuspense) setFallback(null);
            };
        t2 = [
            outsideSuspense,
            setFallback
        ];
        $[0] = outsideSuspense;
        $[1] = setFallback;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    const t3 = outsideSuspense ? null : fallback;
    let t4;
    if ($[4] !== children || $[5] !== t3) {
        t4 = children(t3);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($d936686a3a9843a6$var$LazySuspenseContext);
    (0, $cozmU.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$d936686a3a9843a6$var$DynamicFallback.displayName = 'DynamicFallback';
const $d936686a3a9843a6$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $cozmU.useState)(null);
    const mountedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d936686a3a9843a6$var$DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d936686a3a9843a6$var$LazySuspenseContext.Provider, {
        value: contextValue
    }, $d936686a3a9843a6$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: renderFallback(false)
    }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
};
$d936686a3a9843a6$export$256c542058532d6f.displayName = 'LazySuspense';




const $5f8e54a51d616266$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});


/**
 * @private
 * @deprecated Use `atlaskit/react-ufo/suspense` instead.
 *
 * Provides a placeholder for lazily loaded content (via react-loosely-lazy), improving perceived performance.
 */ const $6e65e7222b8cd667$var$Placeholder = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Placeholder(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { name: name, children: children, fallback: t1 } = t0;
    const fallback = t1 === undefined ? null : t1;
    const waitContext = (0, $cozmU.useContext)((0, $5f8e54a51d616266$export$9ba3fe09d15de47b));
    let t2;
    if ($[0] !== waitContext) {
        t2 = !waitContext || !!waitContext.currentValue();
        $[0] = waitContext;
        $[1] = t2;
    } else t2 = $[1];
    const shouldHold = t2;
    let t3;
    if ($[2] !== name || $[3] !== shouldHold) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: name,
            hold: shouldHold
        });
        $[2] = name;
        $[3] = shouldHold;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== fallback || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback, t3);
        $[5] = fallback;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== children || $[9] !== name || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d936686a3a9843a6$export$256c542058532d6f), {
            fallback: t4,
            name: name
        }, children);
        $[8] = children;
        $[9] = name;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function Placeholder({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $cozmU.useContext)((0, $5f8e54a51d616266$export$9ba3fe09d15de47b));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d936686a3a9843a6$export$256c542058532d6f), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: name,
            hold: shouldHold
        })),
        name: name
    }, children);
};
var $6e65e7222b8cd667$export$2e2bcd8739ae039 = $6e65e7222b8cd667$var$Placeholder;


var $14d5dad4a6329c33$export$2e2bcd8739ae039 = (0, $6e65e7222b8cd667$export$2e2bcd8739ae039);

});

parcelRegister("h6BA0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $8BQV6 = parcelRequire("8BQV6");


var $a33Aa = parcelRequire("a33Aa");

const $9f87565a696977c5$export$75d40f522062f923 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUFOReportError() {
    const $ = (0, $bDgLe.c)(2);
    const ufoContext = (0, $8BQV6.useInteractionContext)();
    let t0;
    if ($[0] !== ufoContext?.labelStack) {
        t0 = (error)=>{
            const interaction = (0, $a33Aa.getActiveInteraction)();
            if (interaction?.id) (0, $a33Aa.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
            else (0, $a33Aa.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
        };
        $[0] = ufoContext?.labelStack;
        $[1] = t0;
    } else t0 = $[1];
    const reportError = t0;
    return reportError;
} : function useUFOReportError() {
    const ufoContext = (0, $8BQV6.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction?.id) (0, $a33Aa.addError)(interaction.id, error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $a33Aa.addErrorToAll)(error.name, ufoContext?.labelStack || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
};
module.exports["useUFOReportError"] = $9f87565a696977c5$export$75d40f522062f923;

});

parcelRegister("3GNtk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $1enXm = parcelRequire("1enXm");


var $3eoUW = parcelRequire("3eoUW");

var $dMmly = parcelRequire("dMmly");

var $95n9g = parcelRequire("95n9g");


var $dqxOF = parcelRequire("dqxOF");


var $dDboE = parcelRequire("dDboE");


var $iDrrr = parcelRequire("iDrrr");









var $1TlML = parcelRequire("1TlML");


var $6wGOF = parcelRequire("6wGOF");





var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hAgam = parcelRequire("hAgam");


var $l9ukq = parcelRequire("l9ukq");

// Custom Components
// ==============================
const $92e26531a78bb73e$var$dropdownStyles = null;
const $92e26531a78bb73e$var$DropdownIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_39xV02Uofl _2xTnZxFQfX _2fwxA5DIqT"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                color: "currentColor",
                label: ""
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_39xV02Uofl _2xTnZxFQfX _2fwxA5DIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: "currentColor",
            label: ""
        })
    });
const $92e26531a78bb73e$var$controlStyles = null;
const $92e26531a78bb73e$var$Control = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let innerProps;
    let innerRef;
    let props;
    if ($[0] !== t0) {
        ({ innerRef: innerRef, innerProps: innerProps, ...props } = t0);
        $[0] = t0;
        $[1] = innerProps;
        $[2] = innerRef;
        $[3] = props;
    } else {
        innerProps = $[1];
        innerRef = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0xmtko1Y8M _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO"
        ]);
        $[4] = t1;
    } else t1 = $[4];
    const t2 = props;
    let t3;
    if ($[5] !== innerProps || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Control, {
            ...t2,
            innerProps: innerProps
        });
        $[5] = innerProps;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== innerRef || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: innerRef,
            className: t1,
            children: t3
        });
        $[8] = innerRef;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: innerRef,
        className: (0, $hekY6.default)([
            "_0xmtko1Y8M _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Control, {
            ...props,
            innerProps: innerProps
        })
    }); // NOTE `props` intentionally omitted from `Fragment`
const $92e26531a78bb73e$var$Menu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, innerProps: innerProps } = t0;
    let t1;
    if ($[0] !== children || $[1] !== innerProps) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...innerProps,
            children: children
        });
        $[0] = children;
        $[1] = innerProps;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...innerProps,
        children: children
    });
const $92e26531a78bb73e$var$ClearIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).ClearIndicator, {
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).ClearIndicator, {
        ...props
    });
const $92e26531a78bb73e$var$MultiValueRemove = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).MultiValueRemove, {
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).MultiValueRemove, {
        ...props
    }); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $92e26531a78bb73e$export$71abc632aa29e6fe = {
    Control: $92e26531a78bb73e$var$Control,
    DropdownIndicator: $92e26531a78bb73e$var$DropdownIndicator,
    Menu: $92e26531a78bb73e$var$Menu,
    ClearIndicator: $92e26531a78bb73e$var$ClearIndicator,
    MultiValueRemove: $92e26531a78bb73e$var$MultiValueRemove
};











parcelRequire("cozmU");





var $9GVkD = parcelRequire("9GVkD");

const $9dc733dca24c3835$export$87ce933b7fc29b8c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const t0 = props;
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Control, {
                ...t0
            })
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l9ukq.components).Control, {
            ...props
        })
    });




















const $4bede461701a30b7$var$menuDialogStyles = null;
const $4bede461701a30b7$var$menuDialogStylesT26Shape = null; /**
                                        * __Menu dialog__
                                        * Wrapper for PopupSelect component.
                                        */ 
const $4bede461701a30b7$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, id: id, style: style, testId: testId } = t0;
    const t1 = testId && `${testId}--menu`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0bjKvDKxmn _42Yu6BFIQA _0KLXruoI2d _2OUyjtGk8v",
            (0, $iDrrr.fg)("platform-dst-shape-theme-default") && "_0bjKvD8fU6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== id || $[3] !== ref || $[4] !== style || $[5] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: ref,
            style: style,
            id: id,
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = id;
        $[3] = ref;
        $[4] = style;
        $[5] = t1;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _42Yu6BFIQA _0KLXruoI2d _2OUyjtGk8v",
            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvD8fU6"
        ]),
        children: children
    });
});









var $5Tdig = parcelRequire("5Tdig");

const $1c60787026c600ef$export$17baa7c95b6ba1b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NotifyOpenLayerObserver(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { isOpen: isOpen, onClose: onClose } = t0;
    let t1;
    if ($[0] !== isOpen || $[1] !== onClose) {
        t1 = {
            isOpen: isOpen,
            onClose: onClose
        };
        $[0] = isOpen;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    (0, $5Tdig.useNotifyOpenLayerObserver)(t1);
    return null;
} : function NotifyOpenLayerObserver({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
};


/* popup-select-top-layer.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");


var $1unCm = parcelRequire("1unCm");






const $2eac864070162ab6$var$menuDialogStyles = null;
const $2eac864070162ab6$var$menuDialogStylesT26Shape = null; /**
                                        * Top-layer implementation of PopupSelect.
                                        *
                                        * Replaces the legacy PopupSelect rendering pipeline
                                        * (react-popper + createPortal + react-focus-lock + @atlaskit/layering + z-index)
                                        * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $2eac864070162ab6$export$25125c0cb8e7659a({ closeMenuOnSelect: // PopupSelect-specific props.
closeMenuOnSelect = true, shouldCloseMenuOnTab: shouldCloseMenuOnTab = true, footer: footer, searchThreshold: searchThreshold = 5, maxMenuWidth: maxMenuWidth = 440, minMenuWidth: minMenuWidth = 220, maxMenuHeight: maxMenuHeight = 300, target: target, label: label, placeholder: placeholder, testId: testId, isOpen: controlledIsOpen, defaultIsOpen: defaultIsOpen, spacing: _spacing, options: options = [], isSearchable: isSearchable = true, components: consumerComponents, styles: consumerStyles, onChange: onChange, onKeyDown: onKeyDown, onOpen: // Lifecycle callbacks.
// @ts-ignore react-select unsupported props
onOpen, onClose: // @ts-ignore react-select unsupported props
onClose, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, popperProps: // No-op props in top-layer path.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
popperProps, // eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldPreventEscapePropagation: _shouldPreventEscapePropagation, // Remaining props spread to Select.
...selectProps }) {
    // State.
    const isControlled = controlledIsOpen !== undefined;
    const [internalIsOpen, setInternalIsOpen] = (0, $cozmU.useState)(isControlled ? Boolean(controlledIsOpen) : Boolean(defaultIsOpen));
    const isOpen = isControlled ? Boolean(controlledIsOpen) : internalIsOpen;
    const selectRef = (0, $cozmU.useRef)(null);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const popoverId = (0, $1unCm.usePopoverId)(); // Placement.
    const legacyPlacement = popperProps?.placement ?? 'bottom-start'; // `popup-select` historically defaulted to an `[along, away] = [0, 8]` popper offset
    // modifier; consumers can override it via `popperProps.modifiers`. Honour both here so
    // the top-layer rendering matches the legacy popper output.
    const legacyOffset = (0, $cozmU.useMemo)(()=>{
        const modifiers = popperProps?.modifiers;
        const value = modifiers?.find((modifier)=>modifier?.name === 'offset')?.options?.offset;
        if (Array.isArray(value) && value.length === 2) return [
            Number(value[0]) || 0,
            Number(value[1]) || 0
        ];
        return [
            0,
            8
        ];
    }, [
        popperProps?.modifiers
    ]);
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: legacyPlacement,
            offset: legacyOffset
        }), [
        legacyPlacement,
        legacyOffset
    ]);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }); // Merged components.
    const mergedComponents = (0, $cozmU.useMemo)(()=>({
            ...(0, $92e26531a78bb73e$export$71abc632aa29e6fe),
            ...consumerComponents
        }), [
        consumerComponents
    ]); // Default styles.
    const defaultStyles = (0, $cozmU.useMemo)(()=>({
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        }), []); // Utils.
    const getItemCount = (0, $cozmU.useCallback)(()=>{
        return options.reduce((count, groupOrOption)=>{
            const group = groupOrOption;
            if (group.options) return count + group.options.length;
            return count + 1;
        }, 0);
    }, [
        options
    ]);
    const showSearchControl = isSearchable && getItemCount() > searchThreshold;
    const getMaxHeight = (0, $cozmU.useCallback)(()=>{
        if (!selectRef.current) return maxMenuHeight;
        const controlRef = selectRef.current.select?.controlRef;
        const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
        return maxMenuHeight - offsetHeight;
    }, [
        maxMenuHeight,
        showSearchControl
    ]);
    const getLabel = (0, $cozmU.useCallback)(()=>{
        if (label) return label;
        if (typeof placeholder === 'string') return placeholder;
        return undefined;
    }, [
        label,
        placeholder
    ]); // Open / Close.
    const open = (0, $cozmU.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(true);
        onOpen?.();
        onMenuOpen?.();
    }, [
        isControlled,
        onOpen,
        onMenuOpen
    ]);
    const close = (0, $cozmU.useCallback)(()=>{
        if (!isControlled) setInternalIsOpen(false);
        onClose?.();
        onMenuClose?.();
    }, [
        isControlled,
        onClose,
        onMenuClose
    ]); // Sync controlled isOpen.
    (0, $cozmU.useEffect)(()=>{
        if (!isControlled) return;
        if (controlledIsOpen) {
            onOpen?.();
            onMenuOpen?.();
        } else {
            onClose?.();
            onMenuClose?.();
        } // Only react to changes in the controlled value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        controlledIsOpen
    ]); // Open the react-select menu when isOpen becomes true.
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && selectRef.current) selectRef.current.select?.openMenu('first');
    }, [
        isOpen
    ]); // Event Handlers.
    const handleTargetKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'ArrowDown') open();
    }, [
        open
    ]); // Open the menu when the trigger is clicked. Mirrors the legacy
    // `PopupSelect` global-click listener: consumers are not required to
    // spread an `onClick`, so we walk up from the event target to the
    // trigger ref instead.
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        return (0, $cbY7C.bind)(window, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!(target instanceof Element)) return;
                const trigger = triggerRef.current;
                if (!trigger || !trigger.contains(target)) return;
                if (isOpen) {
                    close();
                    return;
                }
                open();
            },
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        open,
        close
    ]); // Focus restoration on close is handled automatically by Popover
    // based on the content role (role="dialog" -> auto-restore).
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        if (isControlled) {
            // For controlled mode, notify consumer but do not change internal state
            onClose?.();
            onMenuClose?.();
            return;
        }
        close();
    }, [
        close,
        isControlled,
        onClose,
        onMenuClose
    ]);
    const handleSelectChange = (0, $cozmU.useCallback)((value, actionMeta)=>{
        if (closeMenuOnSelect && actionMeta.action !== 'clear') {
            close(); // Return focus to trigger after selection
            triggerRef.current?.focus();
        }
        onChange?.(value, actionMeta);
    }, [
        closeMenuOnSelect,
        close,
        onChange
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const tabEvent = event.key === 'Tab';
        if (shouldCloseMenuOnTab && tabEvent) {
            close();
            triggerRef.current?.focus();
        } // Escape closes the menu and returns focus to the trigger.
        // The browser auto-restores focus on Escape, but we close
        // explicitly here so isOpen state stays in sync with the popover.
        if (event.key === 'Escape') {
            close();
            triggerRef.current?.focus();
        }
        onKeyDown?.(event);
    }, [
        shouldCloseMenuOnTab,
        close,
        onKeyDown
    ]); // Select components.
    // Type assertion needed because defaultComponents uses concrete OptionType/boolean
    // but Select expects the generic Option/IsMulti parameters. The components are
    // structurally compatible regardless of the generic parameters.
    const selectComponentsMerged = (0, $cozmU.useMemo)(()=>({
            ...mergedComponents,
            Control: showSearchControl ? mergedComponents.Control : (0, $9dc733dca24c3835$export$87ce933b7fc29b8c),
            // Render react-select's menu inline; PopupSelectTopLayer's own
            // `Popover` is already the top-layer host. Otherwise the flag-on
            // `MenuPortalTopLayer` would nest a second popover.
            MenuPortal: ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
                    children: children
                })
        }), [
        mergedComponents,
        showSearchControl
    ]);
    const getSelectRef = (0, $cozmU.useCallback)((ref)=>{
        selectRef.current = ref;
    }, []);
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        // No `onClick` on `triggerProps`: the trigger click is observed via
        // the capture-phase global `click` listener in the effect above,
        // matching the legacy `PopupSelect` contract for consumers that do
        // not spread `triggerProps` onto their target.
        onKeyDown: handleTargetKeyDown,
        // Maintain existing aria attribute format for backwards compatibility.
        // Should technically be 'dialog' instead of 'true', but preserving
        // legacy behavior. See go/DSP-22283
        'aria-haspopup': 'true',
        'aria-expanded': isOpen,
        // Always emit aria-controls referencing the controlled element.
        // Matches the behavior of `getAriaForTrigger` (see
        // `@atlaskit/top-layer/get-aria-for-trigger`) and aligns with the
        // WAI-ARIA spec recommendation.
        'aria-controls': popoverId,
        isOpen: isOpen
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            target?.(triggerProps),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                label: getLabel() ?? 'Popup select',
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juXYb.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: {
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-testid": testId && `${testId}--menu`,
                        className: (0, $hekY6.default)([
                            "_0bjKvDKxmn _0KLXruoI2d _2OUyjtGk8v",
                            (0, $iDrrr.fg)('platform-dst-shape-theme-default') && "_0bjKvD8fU6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
                                label: getLabel(),
                                backspaceRemovesValue: false,
                                controlShouldRenderValue: false,
                                isClearable: false,
                                tabSelectsValue: false,
                                menuIsOpen: true,
                                placeholder: placeholder,
                                ref: getSelectRef,
                                ...selectProps,
                                options: options,
                                isSearchable: showSearchControl,
                                styles: (0, $1TlML.mergeStyles)(defaultStyles, consumerStyles || {}),
                                maxMenuHeight: getMaxHeight(),
                                components: selectComponentsMerged,
                                onChange: handleSelectChange,
                                onKeyDown: handleKeyDown,
                                testId: testId
                            }),
                            footer
                        ]
                    })
                })
            })
        ]
    });
}


/**
 * Are we rendering on the client or server?
 */ const $16688d1608bf4541$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
function $16688d1608bf4541$var$getPopperComponents() {
    if ((0, $iDrrr.fg)('platform-dst-popper-consolidation')) return {
        Manager: (0, $3eoUW.Manager),
        Popper: (0, $dMmly.Popper),
        Reference: (0, $95n9g.Reference)
    };
    return {
        Manager: (0, $3eoUW.Manager),
        Popper: (0, $dMmly.Popper),
        Reference: (0, $95n9g.Reference)
    };
}
// ==============================
// Class
// ==============================
const $16688d1608bf4541$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $16688d1608bf4541$var$defaultPopperProps = {
    modifiers: $16688d1608bf4541$var$modifiers,
    placement: 'bottom-start'
};
const $16688d1608bf4541$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $16688d1608bf4541$export$4c5821a1fa94a0e6 extends (0, $cozmU.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$16688d1608bf4541$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $dqxOF.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $92e26531a78bb73e$export$71abc632aa29e6fe),
            ...props.components
        };
        if (!(0, $dqxOF.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$16688d1608bf4541$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cbY7C.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        // Top-layer rendering path: native Popover API via @atlaskit/top-layer
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2eac864070162ab6$export$25125c0cb8e7659a), {
            ...this.props
        });
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        const { Manager: Manager, Reference: Reference } = $16688d1608bf4541$var$getPopperComponents();
        return /*#__PURE__*/ (0, $8aG6j.jsxs)(Manager, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dDboE.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)(Reference, {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1c60787026c600ef$export$17baa7c95b6ba1b8), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: "var(--ds-text-subtlest, #6B6E76)"
                })
        };
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $92e26531a78bb73e$export$71abc632aa29e6fe),
            mergedPopperProps: $16688d1608bf4541$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    if (this.props.shouldPreventEscapePropagation) event.stopPropagation();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
     * Opens the popup
     *
     * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
     */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
     * Closes the popup
     *
     * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
     */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: _target, testId: testId, onMenuOpen: _onMenuOpen, onMenuClose: _onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const { Popper: Popper } = $16688d1608bf4541$var$getPopperComponents();
            const showSearchControl = this.showSearchControl();
            const portalDestination = $16688d1608bf4541$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $9dc733dca24c3835$export$87ce933b7fc29b8c)
            };
            // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, $8aG6j.jsx)(Popper, {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4bede461701a30b7$export$c94219dad7c0e37d), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1enXm.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6wGOF.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $1TlML.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $9kbTQ.createPortal)(popper, portalDestination);
        };
        this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}
$16688d1608bf4541$export$4c5821a1fa94a0e6.defaultProps = {
    closeMenuOnSelect: true,
    shouldCloseMenuOnTab: true,
    components: {},
    maxMenuHeight: 300,
    maxMenuWidth: 440,
    minMenuWidth: 220,
    popperProps: {},
    isSearchable: true,
    searchThreshold: 5,
    styles: {},
    options: []
};
module.exports["PopupSelect"] = $16688d1608bf4541$export$4c5821a1fa94a0e6;

});

parcelRegister("2QrXF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $b2VYe = parcelRequire("b2VYe");

const $91f4b846d962a29e$var$bgColorCssVar = '--avatar-item-bg-color';
const $91f4b846d962a29e$var$styles = {
    root: "_0bjKvDzXzM _2xIroY98eZ _497WNwYbGa _2zndICT6kp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0hPCNLDIqT _0KLXruUD7e _1UtDYzOLYo _4ya3eEOLYo _2l4i3rzUZr _1kk5Tku7m9 _26BoRw7dHp _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtko1Y8M _46hvQm1Y8M _03SyCP1Y8M _0LQT5E1Y8M _2fwxA5ecOK",
    rootDisabled: "_0wOv4Qsyl5 _1YKVNsVx3j _1pp6NdYbGa",
    rootInteractive: "_1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0xkEdpnXvL _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0ReiIH7zJH _3gzVzLN4oS",
    avatarItem: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _4ouGXIdnbC _1EqgXlN91d _26BoRwflal _0LQT5E2ADO",
    baseText: "_3iDTPbvLZJ _1UtDYzy7kJ",
    truncation: "_4bt5LAnQyn _39HuIbz8Lp _1ANEUSLRg7",
    secondaryTextLegacy: "_1UtDYzKGUX _4ya3eEfauz"
};
const $91f4b846d962a29e$var$AvatarItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { avatar: avatar, backgroundColor: t1, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label } = t0;
    const backgroundColor = t1 === undefined ? "transparent" : t1;
    let t2;
    if ($[0] !== href || $[1] !== isDisabled || $[2] !== onClick) {
        t2 = (0, $b2VYe.default)(isDisabled, href, onClick);
        $[0] = href;
        $[1] = isDisabled;
        $[2] = onClick;
        $[3] = t2;
    } else t2 = $[3];
    const Container = t2;
    const isInteractive = Boolean(onClick || href);
    let t3;
    if ($[4] !== backgroundColor) {
        t3 = {
            [$91f4b846d962a29e$var$bgColorCssVar]: backgroundColor
        };
        $[4] = backgroundColor;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = t3;
    const t5 = ref;
    const t6 = isInteractive ? label : undefined;
    const t7 = testId ? `${testId}--itemInner` : undefined;
    const t8 = Container === "button" ? "button" : undefined;
    let t9;
    if ($[6] !== href || $[7] !== target) {
        t9 = href && {
            href: href,
            target: target,
            rel: target === "_blank" ? "noopener noreferrer" : undefined
        };
        $[6] = href;
        $[7] = target;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = isInteractive && $91f4b846d962a29e$var$styles.rootInteractive;
    const t11 = isDisabled && $91f4b846d962a29e$var$styles.rootDisabled;
    let t12;
    if ($[9] !== t10 || $[10] !== t11) {
        t12 = (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.root,
            t10,
            t11
        ]);
        $[9] = t10;
        $[10] = t11;
        $[11] = t12;
    } else t12 = $[11];
    let t13;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.avatarItem
        ]);
        $[12] = t13;
    } else t13 = $[12];
    let t14;
    if ($[13] !== isTruncationDisabled || $[14] !== primaryText || $[15] !== secondaryText) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t13
        }, (0, $iDrrr.fg)("platform.design-system-team.avatar-item-font-size_830x6") ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            maxLines: isTruncationDisabled ? undefined : 1
        }, primaryText), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            maxLines: isTruncationDisabled ? undefined : 1,
            size: "small"
        }, secondaryText)) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $91f4b846d962a29e$var$styles.baseText,
                !isTruncationDisabled && $91f4b846d962a29e$var$styles.truncation
            ])
        }, primaryText), /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $91f4b846d962a29e$var$styles.baseText,
                $91f4b846d962a29e$var$styles.secondaryTextLegacy,
                !isTruncationDisabled && $91f4b846d962a29e$var$styles.truncation
            ])
        }, secondaryText)));
        $[13] = isTruncationDisabled;
        $[14] = primaryText;
        $[15] = secondaryText;
        $[16] = t14;
    } else t14 = $[16];
    let t15;
    if ($[17] !== Container || $[18] !== avatar || $[19] !== isDisabled || $[20] !== onClick || $[21] !== t12 || $[22] !== t14 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
        t15 = /*#__PURE__*/ $cozmU.createElement(Container, {
            style: t4,
            ref: t5,
            "aria-label": t6,
            onClick: onClick,
            disabled: isDisabled,
            "data-testid": t7,
            type: t8,
            ...t9,
            className: t12
        }, avatar, t14);
        $[17] = Container;
        $[18] = avatar;
        $[19] = isDisabled;
        $[20] = onClick;
        $[21] = t12;
        $[22] = t14;
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
        $[29] = t15;
    } else t15 = $[29];
    return t15;
} : ({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $b2VYe.default)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ $cozmU.createElement(Container, {
        style: {
            [$91f4b846d962a29e$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.root,
            isInteractive && $91f4b846d962a29e$var$styles.rootInteractive,
            isDisabled && $91f4b846d962a29e$var$styles.rootDisabled
        ])
    }, avatar, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.avatarItem
        ])
    }, (0, $iDrrr.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: isTruncationDisabled ? undefined : 1
    }, primaryText), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        maxLines: isTruncationDisabled ? undefined : 1,
        size: "small"
    }, secondaryText)) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.baseText,
            !isTruncationDisabled && $91f4b846d962a29e$var$styles.truncation
        ])
    }, primaryText), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $91f4b846d962a29e$var$styles.baseText,
            $91f4b846d962a29e$var$styles.secondaryTextLegacy,
            !isTruncationDisabled && $91f4b846d962a29e$var$styles.truncation
        ])
    }, secondaryText))));
});
$91f4b846d962a29e$var$AvatarItem.displayName = 'AvatarItem';
var $91f4b846d962a29e$export$2e2bcd8739ae039 = $91f4b846d962a29e$var$AvatarItem;
module.exports["default"] = $91f4b846d962a29e$export$2e2bcd8739ae039;

});

parcelRegister("dWZMi", function(module, exports) {
const $9e0db2c0b7af079a$var$getAppearanceForAppType = (appType)=>{
    switch(appType){
        case 'agent':
            return 'hexagon';
        case 'user':
        case 'system':
        default:
            return 'circle';
    }
};
var $9e0db2c0b7af079a$export$2e2bcd8739ae039 = $9e0db2c0b7af079a$var$getAppearanceForAppType;
module.exports["default"] = $9e0db2c0b7af079a$export$2e2bcd8739ae039;

});

parcelRegister("jb2gB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");











var $5EzLH = parcelRequire("5EzLH");

/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $c4db282e0a39e2e5$var$UFOIgnoreHolds = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, ignore: t1 } = t0;
    const ignore = t1 === undefined ? true : t1;
    const parentContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    bb0: {
        if (!parentContext) {
            t2 = null;
            break bb0;
        }
        let t3;
        if ($[0] !== ignore || $[1] !== parentContext) {
            t3 = {
                ...parentContext,
                hold (...t4) {
                    const args = t4;
                    if (!ignore) return parentContext.hold(...args);
                }
            };
            $[0] = ignore;
            $[1] = parentContext;
            $[2] = t3;
        } else t3 = $[2];
        t2 = t3;
    }
    const ignoredInteractionContext = t2;
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) {
        let t3;
        if ($[3] !== kids) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, kids);
            $[3] = kids;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    let t3;
    if ($[5] !== ignoredInteractionContext || $[6] !== kids) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5EzLH.default).Provider, {
            value: ignoredInteractionContext
        }, kids);
        $[5] = ignoredInteractionContext;
        $[6] = kids;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    const ignoredInteractionContext = (0, $cozmU.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5EzLH.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
};
$c4db282e0a39e2e5$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $c4db282e0a39e2e5$export$2e2bcd8739ae039 = $c4db282e0a39e2e5$var$UFOIgnoreHolds;


/**
 * Legacy wrapper component that delegates to `UFOIgnoreHolds`.
 * Use `UFOIgnoreHolds` instead for new implementations.
 * This component is maintained for backward compatibility only.
 */ const $ae13aec0ff34d669$var$UFOInteractionIgnore = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOInteractionIgnore(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4db282e0a39e2e5$export$2e2bcd8739ae039), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function UFOInteractionIgnore(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4db282e0a39e2e5$export$2e2bcd8739ae039), props);
};
var $ae13aec0ff34d669$export$2e2bcd8739ae039 = $ae13aec0ff34d669$var$UFOInteractionIgnore;
module.exports["default"] = $ae13aec0ff34d669$export$2e2bcd8739ae039;

});

parcelRegister("1o3CH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");

const $1494c90e1e217de0$var$usePressTracing = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePressTracing(name) {
    const $ = (0, $bDgLe.c)(3);
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t0;
    if ($[0] !== context || $[1] !== name) {
        t0 = (timeStamp)=>{
            if (context) {
                const time = timeStamp || performance.now();
                context.tracePress(name, time);
            }
        };
        $[0] = context;
        $[1] = name;
        $[2] = t0;
    } else t0 = $[2];
    const handleClick = t0;
    return handleClick;
} : function usePressTracing(name) {
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    const handleClick = (0, $cozmU.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
};
var $1494c90e1e217de0$export$2e2bcd8739ae039 = $1494c90e1e217de0$var$usePressTracing;
module.exports["default"] = $1494c90e1e217de0$export$2e2bcd8739ae039;

});

parcelRegister("6H0Pg", function(module, exports) {
$parcel$export(module.exports, "default", () => $c52bd43fd71dc881$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");

/**
 * Annotate part of the react tree with a product name
 * ```
 * <UFOLabel name="card">
 *   <Card card={data} />
 * </UFOLabel>
 * ```
 */ const $dd6b1c707eb26e11$var$UFOLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { name: name, children: children } = t0;
    const context = (0, $8BQV6.useInteractionContext)();
    let t1;
    if (context) {
        let t2;
        if ($[0] !== context.labelStack || $[1] !== name) {
            t2 = context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ];
            $[0] = context.labelStack;
            $[1] = name;
            $[2] = t2;
        } else t2 = $[2];
        let t3;
        if ($[3] !== context || $[4] !== t2) {
            t3 = {
                ...context,
                labelStack: t2
            };
            $[3] = context;
            $[4] = t2;
            $[5] = t3;
        } else t3 = $[5];
        t1 = t3;
    } else t1 = context;
    const newContext = t1;
    let t2;
    if ($[6] !== children || $[7] !== context || $[8] !== newContext) {
        t2 = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BQV6.default).Provider, {
            value: newContext
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[6] = children;
        $[7] = context;
        $[8] = newContext;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ name: name, children: children })=>{
    const context = (0, $8BQV6.useInteractionContext)();
    const newContext = (0, $cozmU.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BQV6.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
$dd6b1c707eb26e11$var$UFOLabel.displayName = 'UFOLabel';
var $dd6b1c707eb26e11$export$2e2bcd8739ae039 = $dd6b1c707eb26e11$var$UFOLabel;


var $c52bd43fd71dc881$export$2e2bcd8739ae039 = (0, $dd6b1c707eb26e11$export$2e2bcd8739ae039);

});

parcelRegister("ekCm6", function(module, exports) {
const $04a563f967f06f68$export$9a270941bcff7e77 = {
    xxsmall: 16,
    xsmall: 16,
    UNSAFE_xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
module.exports["AVATAR_SIZES"] = $04a563f967f06f68$export$9a270941bcff7e77;

});

parcelRegister("Vh9GY", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $e6Ach = parcelRequire("e6Ach");


var $6Zv1z = parcelRequire("6Zv1z");

const $8c504f62a5ff47e1$var$CreatableSelect = (0, $6Zv1z.default)((0, $e6Ach.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8c504f62a5ff47e1$export$2e2bcd8739ae039 = $8c504f62a5ff47e1$var$CreatableSelect;
module.exports["default"] = $8c504f62a5ff47e1$export$2e2bcd8739ae039;

});

parcelRegister("l6Cdg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");

const $92eb11050a4f0dec$var$UFOCustomMark = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOCustomMark(t0) {
    const { name: name, timestamp: timestamp } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    if (interactionContext != null) interactionContext.addMark(name, timestamp);
    return null;
} : function UFOCustomMark({ name: name, timestamp: timestamp }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    (0, $cozmU.useMemo)(()=>{
        if (interactionContext != null) interactionContext.addMark(name, timestamp);
    }, [
        interactionContext,
        name,
        timestamp
    ]);
    return null;
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $92eb11050a4f0dec$export$2e2bcd8739ae039 = $92eb11050a4f0dec$var$UFOCustomMark;
const $92eb11050a4f0dec$export$dab235c4bc5af006 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOCustomMarks(t0) {
    const { data: data } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    if (interactionContext != null && data != null) Object.keys(data).forEach((i)=>{
        interactionContext.addMark(i, data[i]);
    });
    return null;
} : function UFOCustomMarks({ data: data }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    (0, $cozmU.useMemo)(()=>{
        if (interactionContext != null && data != null) Object.keys(data).forEach((i)=>{
            interactionContext.addMark(i, data[i]);
        });
    }, [
        data,
        interactionContext
    ]);
    return null;
};
function $92eb11050a4f0dec$export$f60090ba91e71358(name, timestamp) {
    const interactionId = (0, $4QMIF.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const time = timestamp || performance.now();
    (0, $a33Aa.addMark)(currentInteractionId, 'custom', name, [], time);
}
module.exports["addUFOCustomMark"] = $92eb11050a4f0dec$export$f60090ba91e71358;

});

parcelRegister("91ZZN", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb547e5bd11a6163$export$2e2bcd8739ae039);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $6e378aa664d32273$var$Suspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, fallback: fallback, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== fallback || $[1] !== interactionName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: interactionName
        }, fallback);
        $[0] = fallback;
        $[1] = interactionName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== children || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: t1
        }, children);
        $[3] = children;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, fallback: fallback, interactionName: interactionName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: interactionName
        }, fallback)
    }, children);
};
var $6e378aa664d32273$export$2e2bcd8739ae039 = $6e378aa664d32273$var$Suspense;


var $eb547e5bd11a6163$export$2e2bcd8739ae039 = (0, $6e378aa664d32273$export$2e2bcd8739ae039);

});

parcelRegister("eFbDl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $bb0d05c0553a2342$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $bb0d05c0553a2342$var$styles = {
    root: "_0bjKvDaaQb _2V7sgO2M4S _3hxITi6wH8 _3vBAKHjOvk _3iDTPbvbI6 _0KLXruNaal _1YKVNs4ERJ",
    square: "_0bjKvD0O7w",
    hexagon: "_1uo2ZfTcEg",
    strongOpacity: "_1YKVNsy8LG"
};
const $bb0d05c0553a2342$var$sizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
}; /**
    * __Skeleton__
    *
    * A skeleton is the loading state for the avatar component.
    *
    * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
    * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
    */ 
const $bb0d05c0553a2342$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { size: size, appearance: t1, color: color, weight: weight } = t0;
    const appearance = t1 === undefined ? "circle" : t1;
    const avatarSize = size ?? "medium";
    const t2 = color ?? "currentColor";
    let t3;
    if ($[0] !== t2) {
        t3 = {
            [$bb0d05c0553a2342$var$bgColorCssVar]: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const t4 = t3;
    const t5 = $bb0d05c0553a2342$var$sizeStyles[avatarSize];
    const t6 = appearance === "square" && $bb0d05c0553a2342$var$styles.square;
    const t7 = appearance === "hexagon" && $bb0d05c0553a2342$var$styles.hexagon;
    const t8 = weight === "strong" && $bb0d05c0553a2342$var$styles.strongOpacity;
    let t9;
    if ($[2] !== t5 || $[3] !== t6 || $[4] !== t7 || $[5] !== t8) {
        t9 = (0, $hekY6.default)([
            $bb0d05c0553a2342$var$styles.root,
            t5,
            t6,
            t7,
            t8
        ]);
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] !== t4 || $[8] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t4,
            className: t9
        });
        $[7] = t4;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    return t10;
} : ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            [$bb0d05c0553a2342$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hekY6.default)([
            $bb0d05c0553a2342$var$styles.root,
            $bb0d05c0553a2342$var$sizeStyles[avatarSize],
            appearance === 'square' && $bb0d05c0553a2342$var$styles.square,
            appearance === 'hexagon' && $bb0d05c0553a2342$var$styles.hexagon,
            weight === 'strong' && $bb0d05c0553a2342$var$styles.strongOpacity
        ])
    });
};
var $bb0d05c0553a2342$export$2e2bcd8739ae039 = $bb0d05c0553a2342$var$Skeleton;
module.exports["default"] = $bb0d05c0553a2342$export$2e2bcd8739ae039;

});

parcelRegister("lf2MH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $3QDLx = parcelRequire("3QDLx");


var $jtTx3 = parcelRequire("jtTx3");


var $c9IWh = parcelRequire("c9IWh");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $bC8sq = parcelRequire("bC8sq");




function $ed7b669bd2243ce3$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}


function $f369e1e6f5e7b04e$export$f2e521e495a88544(newId) {
    (0, $c9IWh.setActiveTrace)(newId.replace(/-/g, ''), (0, $ed7b669bd2243ce3$export$295213bc4d0c54ad)(), 'transition');
}


function $a6929cdd03343639$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $jtTx3.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $jtTx3.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $a33Aa.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $bC8sq.default).current = ufoName;
        const rate = (0, $jtTx3.getInteractionRate)(ufoName, 'transition');
        if ((0, $3QDLx.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $kHija.v4)();
            (0, $f369e1e6f5e7b04e$export$f2e521e495a88544)(newId);
            (0, $4QMIF.DefaultInteractionID).current = newId;
            (0, $a33Aa.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $c9IWh.getActiveTrace)());
        }
    }
}
const $a6929cdd03343639$export$369f0ded13ce6c50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUFOTransitionCompleter() {
    const $ = (0, $bDgLe.c)(6);
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const capturedInteractionId = interactionId.current;
    let t0;
    if ($[0] !== capturedInteractionId || $[1] !== interactionId.current) {
        t0 = ()=>{
            if (capturedInteractionId != null) {
                let cancel = requestAnimationFrame(()=>{
                    cancel = requestAnimationFrame(()=>{
                        if (capturedInteractionId === interactionId.current) (0, $a33Aa.tryComplete)(capturedInteractionId);
                    });
                });
                (0, $a33Aa.addOnCancelCallback)(capturedInteractionId, ()=>{
                    cancelAnimationFrame(cancel);
                });
            }
        };
        $[0] = capturedInteractionId;
        $[1] = interactionId.current;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== capturedInteractionId || $[4] !== interactionId) {
        t1 = [
            capturedInteractionId,
            interactionId
        ];
        $[3] = capturedInteractionId;
        $[4] = interactionId;
        $[5] = t1;
    } else t1 = $[5];
    (0, $cozmU.useEffect)(t0, t1);
} : function useUFOTransitionCompleter() {
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const capturedInteractionId = interactionId.current;
    (0, $cozmU.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $a33Aa.tryComplete)(capturedInteractionId);
                });
            });
            (0, $a33Aa.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a6929cdd03343639$export$2e2bcd8739ae039 = $a6929cdd03343639$var$traceUFOTransition;
module.exports["default"] = $a6929cdd03343639$export$2e2bcd8739ae039;

});

parcelRegister("lRNyi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jtTx3 = parcelRequire("jtTx3");


var $7Hxln = parcelRequire("7Hxln");


var $a33Aa = parcelRequire("a33Aa");


var $1P2f3 = parcelRequire("1P2f3");

// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $a296d3f2905c2998$var$startTimes = new Map();
const $a296d3f2905c2998$var$spanStates = new Map();
const $a296d3f2905c2998$export$cf4e4023c0a34c8d = ()=>{
    $a296d3f2905c2998$var$startTimes.clear();
    $a296d3f2905c2998$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $a296d3f2905c2998$var$lastActiveInteraction;
function $a296d3f2905c2998$var$checkActiveInteractionAndResetStartMarksIfSet() {
    const activeInteractionId = (0, $a33Aa.getActiveInteraction)()?.id;
    if (!!$a296d3f2905c2998$var$lastActiveInteraction && $a296d3f2905c2998$var$lastActiveInteraction !== activeInteractionId) $a296d3f2905c2998$export$cf4e4023c0a34c8d();
    $a296d3f2905c2998$var$lastActiveInteraction = activeInteractionId;
}
const $a296d3f2905c2998$var$getIsNativeTracingEnabled = ()=>(0, $jtTx3.getConfig)()?.ssr?.enableNativeTracing ?? false;
const $a296d3f2905c2998$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    if (!$a296d3f2905c2998$var$startTimes.has(id)) $a296d3f2905c2998$var$startTimes.set(id, []);
    $a296d3f2905c2998$var$startTimes.get(id)?.push(performance.now());
    if (!$a296d3f2905c2998$var$getIsNativeTracingEnabled()) return null;
    const startSpan = globalThis.__vm_internals__?.telemetry?.startSpan;
    let spanState = $a296d3f2905c2998$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext?.spanId
        });
        spanState = {
            span: span
        };
        $a296d3f2905c2998$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $a296d3f2905c2998$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $1P2f3 !== 'undefined' && Boolean($1P2f3?.env?.REACT_SSR || false);
const $a296d3f2905c2998$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender?.();
    return null;
};
const $a296d3f2905c2998$var$ParentSpanContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $a296d3f2905c2998$export$c8760e11c713fafc = ()=>{
    $a296d3f2905c2998$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $a296d3f2905c2998$var$spanStates.clear();
};
const $a296d3f2905c2998$export$b8bd105b650b1c1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, labelStack: labelStack, onRender: onRender } = t0;
    let t1;
    if ($[0] !== labelStack) {
        t1 = labelStack.map($a296d3f2905c2998$var$_temp).join("/");
        $[0] = labelStack;
        $[1] = t1;
    } else t1 = $[1];
    const reactProfilerId = t1;
    $a296d3f2905c2998$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $cozmU.useContext)($a296d3f2905c2998$var$ParentSpanContext);
    let T0;
    let t2;
    if ($[2] !== labelStack || $[3] !== parentSpan || $[4] !== reactProfilerId) {
        const currentSpanState = $a296d3f2905c2998$var$onStartRender(reactProfilerId, (0, $7Hxln.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
        T0 = $a296d3f2905c2998$var$ParentSpanContext.Provider;
        t2 = currentSpanState?.span.getSpanContext() ?? null;
        $[2] = labelStack;
        $[3] = parentSpan;
        $[4] = reactProfilerId;
        $[5] = T0;
        $[6] = t2;
    } else {
        T0 = $[5];
        t2 = $[6];
    }
    let t3;
    if ($[7] !== onRender || $[8] !== reactProfilerId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$var$ProfilerMarker, {
            onRender: ()=>{
                const startTimesForId = $a296d3f2905c2998$var$startTimes.get(reactProfilerId);
                if (startTimesForId?.length) {
                    const endTime = performance.now();
                    const firstStartTime = startTimesForId[0];
                    const lastStartTime = startTimesForId[startTimesForId.length - 1];
                    const baseDuration = endTime - lastStartTime;
                    const actualDuration = endTime - firstStartTime;
                    onRender("mount", actualDuration, baseDuration, firstStartTime, endTime);
                }
                const spanState = $a296d3f2905c2998$var$spanStates.get(reactProfilerId);
                if (spanState) spanState.latestEndTime = performance.now();
            }
        });
        $[7] = onRender;
        $[8] = reactProfilerId;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== T0 || $[11] !== children || $[12] !== t2 || $[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            value: t2
        }, children, t3));
        $[10] = T0;
        $[11] = children;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $cozmU.useMemo)(()=>labelStack.map((l)=>(0, $7Hxln.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $a296d3f2905c2998$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $cozmU.useContext)($a296d3f2905c2998$var$ParentSpanContext);
    const currentSpanState = $a296d3f2905c2998$var$onStartRender(reactProfilerId, (0, $7Hxln.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$var$ParentSpanContext.Provider, {
        value: currentSpanState?.span.getSpanContext() ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $a296d3f2905c2998$var$startTimes.get(reactProfilerId);
            if (startTimesForId?.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = $a296d3f2905c2998$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const $a296d3f2905c2998$var$SsrRenderProfiler = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    if ($a296d3f2905c2998$var$isInSSR) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$export$b8bd105b650b1c1e, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$var$ProfilerMarker, null);
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== props.children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, props.children);
        $[3] = props.children;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    if ($a296d3f2905c2998$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a296d3f2905c2998$var$ProfilerMarker, null), props.children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a296d3f2905c2998$export$2e2bcd8739ae039 = $a296d3f2905c2998$var$SsrRenderProfiler;
function $a296d3f2905c2998$var$_temp(l) {
    return (0, $7Hxln.sanitizeLabelStackName)(l.name);
}
module.exports["flushSsrRenderProfilerTraces"] = $a296d3f2905c2998$export$c8760e11c713fafc;
module.exports["default"] = $a296d3f2905c2998$export$2e2bcd8739ae039;

});

parcelRegister("hHISI", function(module, exports) {
const $1e8fa34d91f85e30$export$42f4885608027d0c = 'non_boolean';


function $d2624ba365a1c41d$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $d2624ba365a1c41d$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $d2624ba365a1c41d$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $d2624ba365a1c41d$export$7b4abba432e57989(value) {
    return $d2624ba365a1c41d$var$isString(value) && $d2624ba365a1c41d$var$startsAsObject(value) || $d2624ba365a1c41d$var$isObject(value);
}
function $d2624ba365a1c41d$export$fcc03ee4c944962f(featureFlagValue) {
    return $d2624ba365a1c41d$export$7b4abba432e57989(featureFlagValue) ? (0, $1e8fa34d91f85e30$export$42f4885608027d0c) : featureFlagValue;
}
module.exports["redactValue"] = $d2624ba365a1c41d$export$fcc03ee4c944962f;

});

parcelRegister("pLTIz", function(module, exports) {
const $ccb0dea7a19e2eee$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $ccb0dea7a19e2eee$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $ccb0dea7a19e2eee$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $ccb0dea7a19e2eee$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $ccb0dea7a19e2eee$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $ccb0dea7a19e2eee$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $ccb0dea7a19e2eee$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $ccb0dea7a19e2eee$var$PAGE_LAYOUT_ID) return $ccb0dea7a19e2eee$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $ccb0dea7a19e2eee$var$PAGE_LAYOUT_ID) return $ccb0dea7a19e2eee$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}
module.exports["SSRPlaceholderHandlers"] = $ccb0dea7a19e2eee$export$c0102f1a1198d10f;

});

parcelRegister("6AKGx", function(module, exports) {

var $5o4s6 = parcelRequire("5o4s6");

function $c5847143dcd108fc$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $5o4s6.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}
module.exports["isContainedWithinMediaWrapper"] = $c5847143dcd108fc$export$f61fbc3b9c4a9019;

});

parcelRegister("issAY", function(module, exports) {
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $837b8fe1ad685ea8$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $837b8fe1ad685ea8$export$2e2bcd8739ae039 = $837b8fe1ad685ea8$var$isNonVisualStyleMutation;
module.exports["default"] = $837b8fe1ad685ea8$export$2e2bcd8739ae039;

});

parcelRegister("jlWJa", function(module, exports) {
const $5381c82a8b89f179$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $5381c82a8b89f179$export$166779fc0f49d4df {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$5381c82a8b89f179$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$5381c82a8b89f179$var$GLOBAL_RLL_HANDLERS_KEY] = new $5381c82a8b89f179$export$166779fc0f49d4df();
            return globalThis[$5381c82a8b89f179$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $5381c82a8b89f179$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}
module.exports["RLLPlaceholderHandlers"] = $5381c82a8b89f179$export$166779fc0f49d4df;

});

parcelRegister("l8ayF", function(module, exports) {
const $e7f03cfbb0edbb3c$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);
module.exports["BACKEND_RESOURCE_TIMING_INITIATOR_TYPES"] = $e7f03cfbb0edbb3c$export$c3b002e13fbb9ef2;

});

parcelRegister("65DSU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bHUUH = parcelRequire("bHUUH");


var $kHija = parcelRequire("kHija");


var $3QDLx = parcelRequire("3QDLx");


var $jtTx3 = parcelRequire("jtTx3");


var $7Hxln = parcelRequire("7Hxln");


var $c9IWh = parcelRequire("c9IWh");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $bC8sq = parcelRequire("bC8sq");


var $lyVz2 = parcelRequire("lyVz2");


var $3FZoX = parcelRequire("3FZoX");


var $lRNyi = parcelRequire("lRNyi");

let $182a7e5aa88dffed$var$tryCompleteHandle;
/** A portion of the page we apply measurement to */ const $182a7e5aa88dffed$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $jtTx3.isUFOEnabled)();
    const parentContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const segmentIdMap = (0, $cozmU.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $cozmU.useMemo)(()=>{
        if (mode === 'single') return (0, $lyVz2.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $lyVz2.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $cozmU.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const interactionContext = (0, $cozmU.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($182a7e5aa88dffed$var$tryCompleteHandle) cancelAnimationFrame?.($182a7e5aa88dffed$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $182a7e5aa88dffed$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $182a7e5aa88dffed$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $a33Aa.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $a33Aa.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $bHUUH.unstable_scheduleCallback)((0, $bHUUH.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $a33Aa.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $a33Aa.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $a33Aa.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $jtTx3.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $jtTx3.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
                    activeInteraction?.minorInteractions?.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $a33Aa.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $jtTx3.getInteractionRate)(name, 'press');
                if ((0, $3QDLx.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $kHija.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $c9IWh.setInteractionActiveTrace)(newId, 'press');
                    (0, $a33Aa.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $bC8sq.default).current, (0, $c9IWh.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $a33Aa.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $a33Aa.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $a33Aa.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $a33Aa.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $a33Aa.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $a33Aa.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $a33Aa.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $a33Aa.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $3FZoX.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $cozmU.useRef)(false);
    const onRender = (0, $cozmU.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $jtTx3.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $a33Aa.addSegment)(labelStack);
        return ()=>{
            (0, $a33Aa.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $cozmU.useMemo)(()=>labelStack.map((l)=>(0, $7Hxln.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BQV6.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lRNyi.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$182a7e5aa88dffed$var$UFOSegment.displayName = 'UFOSegment';
var $182a7e5aa88dffed$export$2e2bcd8739ae039 = $182a7e5aa88dffed$var$UFOSegment;
module.exports["default"] = $182a7e5aa88dffed$export$2e2bcd8739ae039;

});

parcelRegister("dHBqk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jtTx3 = parcelRequire("jtTx3");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");

const $c979187c69a70c8a$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ const $c979187c69a70c8a$var$useInteractionIdValue = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInteractionIdValue() {
    const $ = (0, $bDgLe.c)(4);
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const [currentId, setCurrentId] = (0, $cozmU.useState)(interactionId?.current || null);
    let t0;
    if ($[0] !== interactionId?.current) {
        t0 = ()=>{
            setCurrentId(interactionId?.current || null);
            const unsubscribe = (0, $4QMIF.subscribeToInteractionIdChanges)((newId)=>{
                setCurrentId(newId);
            });
            return unsubscribe;
        };
        $[0] = interactionId?.current;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== interactionId) {
        t1 = [
            interactionId
        ];
        $[2] = interactionId;
        $[3] = t1;
    } else t1 = $[3];
    $c979187c69a70c8a$var$useLayoutEffectSAFE(t0, t1);
    return currentId;
} : function useInteractionIdValue() {
    const interactionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const [currentId, setCurrentId] = (0, $cozmU.useState)(interactionId?.current || null);
    $c979187c69a70c8a$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $4QMIF.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
};
const $c979187c69a70c8a$var$UFOLoadHold = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOLoadHold(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, name: name, hold: t1 } = t0;
    const hold = t1 === undefined ? true : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $jtTx3.isUFOEnabled)();
        $[0] = t2;
    } else t2 = $[0];
    const ufoEnabled = t2;
    const currentInteractionId = $c979187c69a70c8a$var$useInteractionIdValue();
    const context = (0, $cozmU.useContext)((0, $8BQV6.default));
    let t3;
    if ($[1] !== context || $[2] !== hold || $[3] !== name) {
        t3 = ()=>{
            if (!ufoEnabled) return;
            if (hold && context != null) return context.hold(name);
        };
        $[1] = context;
        $[2] = hold;
        $[3] = name;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== context || $[6] !== currentInteractionId || $[7] !== hold || $[8] !== name) {
        t4 = [
            hold,
            context,
            name,
            currentInteractionId,
            ufoEnabled
        ];
        $[5] = context;
        $[6] = currentInteractionId;
        $[7] = hold;
        $[8] = name;
        $[9] = t4;
    } else t4 = $[9];
    $c979187c69a70c8a$var$useLayoutEffectSAFE(t3, t4);
    let t5;
    if ($[10] !== children) {
        t5 = children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
        $[10] = children;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function UFOLoadHold({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $jtTx3.isUFOEnabled)();
    const currentInteractionId = $c979187c69a70c8a$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $cozmU.useContext)((0, $8BQV6.default));
    $c979187c69a70c8a$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
};
var $c979187c69a70c8a$export$2e2bcd8739ae039 = $c979187c69a70c8a$var$UFOLoadHold;
module.exports["default"] = $c979187c69a70c8a$export$2e2bcd8739ae039;

});

parcelRegister("lnlX7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2bc8f53c47b7bb76$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $2bc8f53c47b7bb76$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $cozmU.createContext)($2bc8f53c47b7bb76$var$defaultAvatarContentProps);
module.exports["AvatarContentContext"] = $2bc8f53c47b7bb76$export$b983474ddd0b6d28;

});

parcelRegister("bIrLJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $34a11be64a14c96c$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["EnsureIsInsideAvatarContext"] = $34a11be64a14c96c$export$6b4cbd90d24955ad;

});

parcelRegister("9uf2f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $acQiA = parcelRequire("acQiA");

const $39dbf1f545e5a633$export$443076ec7ebce042 = /*#__PURE__*/ (0, $cozmU.createContext)('cozy');
module.exports["SpacingContext"] = $39dbf1f545e5a633$export$443076ec7ebce042;

});

parcelRegister("6CckD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");


var $9uf2f = parcelRequire("9uf2f");


var $acQiA = parcelRequire("acQiA");

const $c7544a01a709407e$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ $cozmU.createElement(Component, props);
const $c7544a01a709407e$var$styles = {
    root: "_30huDKdnbC _2xIroY98eZ _497WNwYbGa _2zndICdnbC _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _4kiQYAUF4f _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _0hPCNLDIqT _20VacPYbGa _0wOv4Q7zJH _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1zr6DcnXvL _1ubuxonXvL _38a67RZPSy _34b3D2ZPSy _0htemX6wH8 _1NDpvb6wH8 _067Lcevc3e _2wtOC9vc3e _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3e11vU6wH8 _0hSAgbHZdu",
    beforeAfterElement: "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    content: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2O5Vij7dHp _2fwxA5ecOK",
    truncate: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
    title: "_2sNsIgmnOE",
    wordBreak: "_3W2Oc8wPeg",
    description: "_2sNsIg7NXe _1UtDYzKGUX",
    disabledDescription: "_1UtDYzot27",
    unselected: "_0KLXru66of _1UtDYz98eZ _2nTuUY98eZ _1eOmH6o126 _0clgaM98eZ _3gzVzLo126 _0CMRbk98eZ",
    disabled: "_0wOv4Qsyl5 _0KLXru66of _1UtDYzot27 _1eOmH666of _0clgaMot27 _3gzVzL66of _0CMRbkot27",
    selectedBorder: "_3ScelF4Jdh _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmIPgdg _1cR5ZLPgdg _2jTvwtPgdg",
    selectedNotch: "_1OimfuMLSV _3ScelFUNDJ _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmI8HPE _1cR5ZL8HPE _2jTvwtPgdg",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _1eOmH6sumd _0clgaM866Z _3gzVzLXsxn _0CMRbkjTy9",
    selectedOld: "_0clgaMjTy9",
    motionUnselected: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $c7544a01a709407e$var$spacingMapStyles = {
    cozy: "_4c065U2ADO _2Y7lL45zaO",
    compact: "_4c065U1Y8M _2Y7lL48HPE _4kiQYAUofl"
};
const $c7544a01a709407e$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
}; /**
    * __Menu item primitive__
    *
    * Menu item primitive contains all the styles for menu items,
    * including support for selected, disabled, and interaction states.
    *
    * Using children as function prop you wire up this to your own host element.
    *
    * ```jsx
    * <MenuItemPrimitive>
    *   {({ children, ...props }) => <button {...props}>{children}</button>}
    * </MenuItemPrimitive>
    * ```
    */ 
const $c7544a01a709407e$var$MenuItemPrimitive = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: t1, shouldDescriptionWrap: t2, isDisabled: t3, isSelected: t4, isTitleHeading: t5, testId: testId } = t0;
    const shouldTitleWrap = t1 === undefined ? false : t1;
    const shouldDescriptionWrap = t2 === undefined ? false : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const isSelected = t4 === undefined ? false : t4;
    const isTitleHeading = t5 === undefined ? false : t5;
    const spacing = (0, $cozmU.useContext)((0, $9uf2f.SpacingContext));
    const selectionStyle = (0, $cozmU.useContext)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    let t6;
    if ($[0] !== UNSAFE_className || $[1] !== children || $[2] !== description || $[3] !== iconAfter || $[4] !== iconBefore || $[5] !== isDisabled || $[6] !== isSelected || $[7] !== isTitleHeading || $[8] !== selectionStyle || $[9] !== shouldDescriptionWrap || $[10] !== shouldTitleWrap || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        const t7 = $c7544a01a709407e$var$gapMap[spacing];
        const t8 = testId && `${testId}--container`;
        let t9;
        if ($[15] !== iconBefore || $[16] !== testId) {
            t9 = iconBefore && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && `${testId}--icon-before`,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.beforeAfterElement
                ])
            }, iconBefore);
            $[15] = iconBefore;
            $[16] = testId;
            $[17] = t9;
        } else t9 = $[17];
        let t10;
        if ($[18] !== description || $[19] !== isDisabled || $[20] !== isTitleHeading || $[21] !== shouldDescriptionWrap || $[22] !== shouldTitleWrap || $[23] !== title) {
            t10 = title && /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.content
                ])
            }, $c7544a01a709407e$var$renderTitle(isTitleHeading ? "h2" : "span", {
                children: title,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.title,
                    shouldTitleWrap ? $c7544a01a709407e$var$styles.wordBreak : $c7544a01a709407e$var$styles.truncate
                ]),
                "data-item-title": true
            }), description && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-description": true,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.description,
                    isDisabled && $c7544a01a709407e$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c7544a01a709407e$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c7544a01a709407e$var$styles.truncate
                ])
            }, description));
            $[18] = description;
            $[19] = isDisabled;
            $[20] = isTitleHeading;
            $[21] = shouldDescriptionWrap;
            $[22] = shouldTitleWrap;
            $[23] = title;
            $[24] = t10;
        } else t10 = $[24];
        let t11;
        if ($[25] !== iconAfter || $[26] !== testId) {
            t11 = iconAfter && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && `${testId}--icon-after`,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.beforeAfterElement
                ])
            }, iconAfter);
            $[25] = iconAfter;
            $[26] = testId;
            $[27] = t11;
        } else t11 = $[27];
        let t12;
        if ($[28] !== t10 || $[29] !== t11 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
            t12 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: t7,
                grow: "fill",
                testId: t8
            }, t9, t10, t11);
            $[28] = t10;
            $[29] = t11;
            $[30] = t7;
            $[31] = t8;
            $[32] = t9;
            $[33] = t12;
        } else t12 = $[33];
        t6 = children({
            className: (0, $hekY6.default)([
                (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.root,
                    $c7544a01a709407e$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c7544a01a709407e$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $c7544a01a709407e$var$styles.motionUnselected,
                    !isDisabled && isSelected && $c7544a01a709407e$var$styles.selected,
                    !isDisabled && isSelected && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $c7544a01a709407e$var$styles.motionSelected,
                    !isDisabled && isSelected && $c7544a01a709407e$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === "border" && $c7544a01a709407e$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === "notch" && $c7544a01a709407e$var$styles.selectedNotch,
                    isDisabled && $c7544a01a709407e$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: t12
        });
        $[0] = UNSAFE_className;
        $[1] = children;
        $[2] = description;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = isTitleHeading;
        $[8] = selectionStyle;
        $[9] = shouldDescriptionWrap;
        $[10] = shouldTitleWrap;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $cozmU.useContext)((0, $9uf2f.SpacingContext));
    const selectionStyle = (0, $cozmU.useContext)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $hekY6.default)([
                (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.root,
                    $c7544a01a709407e$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $c7544a01a709407e$var$styles.unselected,
                    !isDisabled && !isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $c7544a01a709407e$var$styles.motionUnselected,
                    !isDisabled && isSelected && $c7544a01a709407e$var$styles.selected,
                    !isDisabled && isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $c7544a01a709407e$var$styles.motionSelected,
                    !isDisabled && isSelected && $c7544a01a709407e$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $c7544a01a709407e$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $c7544a01a709407e$var$styles.selectedNotch,
                    isDisabled && $c7544a01a709407e$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $c7544a01a709407e$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && `${testId}--icon-before`,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.content
                ])
            }, $c7544a01a709407e$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.title,
                    shouldTitleWrap ? $c7544a01a709407e$var$styles.wordBreak : $c7544a01a709407e$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-description": true,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.description,
                    isDisabled && $c7544a01a709407e$var$styles.disabledDescription,
                    shouldDescriptionWrap && $c7544a01a709407e$var$styles.wordBreak,
                    !shouldDescriptionWrap && $c7544a01a709407e$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $cozmU.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && `${testId}--icon-after`,
                className: (0, $hekY6.default)([
                    $c7544a01a709407e$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    })();
};
var $c7544a01a709407e$export$2e2bcd8739ae039 = $c7544a01a709407e$var$MenuItemPrimitive;
module.exports["default"] = $c7544a01a709407e$export$2e2bcd8739ae039;

});

parcelRegister("2i8vD", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $4c0939126feefba6$export$2054129d247c3102 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TabPanelContext"] = $4c0939126feefba6$export$2054129d247c3102;

});

parcelRegister("fOPNo", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $03a84005f2a51080$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TabContext"] = $03a84005f2a51080$export$5a5d356ca5f10a0a;

});

parcelRegister("kHJXa", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $98dec971905d8fdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TabListContext"] = $98dec971905d8fdc$export$aa6907f9fd69e93b;

});

parcelRegister("b2VYe", function(module, exports) {
const $aa9bd643d4658bd7$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $aa9bd643d4658bd7$export$2e2bcd8739ae039 = $aa9bd643d4658bd7$var$getCustomElement;
module.exports["default"] = $aa9bd643d4658bd7$export$2e2bcd8739ae039;

});

parcelRegister("lyVz2", function(module, exports) {
function $b1a8ad99557aea02$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $b1a8ad99557aea02$export$2e2bcd8739ae039 = $b1a8ad99557aea02$var$generateId;
module.exports["default"] = $b1a8ad99557aea02$export$2e2bcd8739ae039;

});

parcelRegister("3FZoX", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

function $f17f4cba45d3587e$var$scheduleOnPaint(callback) {
    const isSSR = typeof window === 'undefined' || Boolean(globalThis?.__SERVER__) || typeof $1P2f3 !== 'undefined' && Boolean($1P2f3?.env?.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $f17f4cba45d3587e$export$2e2bcd8739ae039 = $f17f4cba45d3587e$var$scheduleOnPaint;
module.exports["default"] = $f17f4cba45d3587e$export$2e2bcd8739ae039;

});


$parcel$global.rlb("7EorR")
//# sourceMappingURL=vendors~editor_atlaskit_md.5a340518.js.map
